import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any; }
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: any; output: any; }
  /** The `Short` scalar type represents non-fractional signed whole 16-bit numeric values. Short can represent values between -(2^15) and 2^15 - 1. */
  Short: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type ActiveStudyExpenses = {
  expenseId: Scalars['Int']['output'];
  expenseKey: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  studyId?: Maybe<Scalars['Int']['output']>;
};

export type ActiveStudyExpensesFilterInput = {
  and?: InputMaybe<Array<ActiveStudyExpensesFilterInput>>;
  expenseId?: InputMaybe<IntOperationFilterInput>;
  expenseKey?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ActiveStudyExpensesFilterInput>>;
  studyId?: InputMaybe<IntOperationFilterInput>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type AuthResult = {
  jwtAccessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']['input']>;
  gt?: InputMaybe<Scalars['Byte']['input']>;
  gte?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  lt?: InputMaybe<Scalars['Byte']['input']>;
  lte?: InputMaybe<Scalars['Byte']['input']>;
  neq?: InputMaybe<Scalars['Byte']['input']>;
  ngt?: InputMaybe<Scalars['Byte']['input']>;
  ngte?: InputMaybe<Scalars['Byte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  nlt?: InputMaybe<Scalars['Byte']['input']>;
  nlte?: InputMaybe<Scalars['Byte']['input']>;
};

export type Caregiver = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  addressSameAsPatient: Scalars['Boolean']['output'];
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  caregiverEditRequest?: Maybe<CaregiverEditRequest>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  modifiedBy: Scalars['String']['output'];
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiration?: Maybe<Scalars['Date']['output']>;
  passportIssue?: Maybe<Scalars['Date']['output']>;
  passportNum?: Maybe<Scalars['String']['output']>;
  patient: Patient;
  patientId: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  preferredLang: Scalars['String']['output'];
  relationship?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  travelRequestCaregiver: Array<TravelRequestCaregiver>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CaregiverEditRequest = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  addressSameAsPatient?: Maybe<Scalars['Boolean']['output']>;
  caregiver: Caregiver;
  caregiverId: Scalars['Int']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modifiedBy: Scalars['String']['output'];
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiration?: Maybe<Scalars['Date']['output']>;
  passportIssue?: Maybe<Scalars['Date']['output']>;
  passportNum?: Maybe<Scalars['String']['output']>;
  patientEditRequest: PatientEditRequest;
  patientEditRequestId: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  preferredLang?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CaregiverEditRequestDtoInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  addressSameAsPatient?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverId: Scalars['Int']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  passportCountry?: InputMaybe<Scalars['String']['input']>;
  passportExpiration?: InputMaybe<Scalars['Date']['input']>;
  passportIssue?: InputMaybe<Scalars['Date']['input']>;
  passportNum?: InputMaybe<Scalars['String']['input']>;
  patientEditRequestId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredLang?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CaregiverEditRequestFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  addressSameAsPatient?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CaregiverEditRequestFilterInput>>;
  caregiver?: InputMaybe<CaregiverFilterInput>;
  caregiverId?: InputMaybe<IntOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CaregiverEditRequestFilterInput>>;
  passportCountry?: InputMaybe<StringOperationFilterInput>;
  passportExpiration?: InputMaybe<DateOperationFilterInput>;
  passportIssue?: InputMaybe<DateOperationFilterInput>;
  passportNum?: InputMaybe<StringOperationFilterInput>;
  patientEditRequest?: InputMaybe<PatientEditRequestFilterInput>;
  patientEditRequestId?: InputMaybe<IntOperationFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  preferredLang?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type CaregiverEditRequestSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  addressSameAsPatient?: InputMaybe<SortEnumType>;
  caregiver?: InputMaybe<CaregiverSortInput>;
  caregiverId?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  passportCountry?: InputMaybe<SortEnumType>;
  passportExpiration?: InputMaybe<SortEnumType>;
  passportIssue?: InputMaybe<SortEnumType>;
  passportNum?: InputMaybe<SortEnumType>;
  patientEditRequest?: InputMaybe<PatientEditRequestSortInput>;
  patientEditRequestId?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  preferredLang?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

export type CaregiverFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  addressSameAsPatient?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CaregiverFilterInput>>;
  birthDate?: InputMaybe<DateTimeOperationFilterInput>;
  caregiverEditRequest?: InputMaybe<CaregiverEditRequestFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  details?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  gender?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  middleName?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CaregiverFilterInput>>;
  passportCountry?: InputMaybe<StringOperationFilterInput>;
  passportExpiration?: InputMaybe<DateOperationFilterInput>;
  passportIssue?: InputMaybe<DateOperationFilterInput>;
  passportNum?: InputMaybe<StringOperationFilterInput>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  preferredLang?: InputMaybe<StringOperationFilterInput>;
  relationship?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  travelRequestCaregiver?: InputMaybe<ListFilterInputTypeOfTravelRequestCaregiverFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type CaregiverSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  addressSameAsPatient?: InputMaybe<SortEnumType>;
  birthDate?: InputMaybe<SortEnumType>;
  caregiverEditRequest?: InputMaybe<CaregiverEditRequestSortInput>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  details?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  gender?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isPrimary?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  middleName?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  passportCountry?: InputMaybe<SortEnumType>;
  passportExpiration?: InputMaybe<SortEnumType>;
  passportIssue?: InputMaybe<SortEnumType>;
  passportNum?: InputMaybe<SortEnumType>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  preferredLang?: InputMaybe<SortEnumType>;
  relationship?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CaregiversConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<CaregiversEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Caregiver>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CaregiversEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Caregiver;
};

export type ChangeLoggedPatientPasswordInput = {
  newPassword: Scalars['String']['input'];
  previousPassword: Scalars['String']['input'];
};

export type ChangeLoggedPatientPasswordPayload = {
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePasswordInPasswordResetScenarioInput = {
  newPassword: Scalars['String']['input'];
  passwordResetCode: Scalars['String']['input'];
};

export type ChangePasswordInPasswordResetScenarioPayload = {
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePatientUserLanguageInput = {
  language: Scalars['String']['input'];
};

export type ChangePatientUserLanguagePayload = {
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ClinTrakPatientVisit = {
  actualDate?: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  patientId: Scalars['UUID']['output'];
  patientVisitId: Scalars['UUID']['output'];
  patientVisitMasterId: Scalars['UUID']['output'];
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  statusAbbreviation?: Maybe<Scalars['String']['output']>;
  statusDescription?: Maybe<Scalars['String']['output']>;
};

export type ClinTrakPatientVisitFilterInput = {
  actualDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ClinTrakPatientVisitFilterInput>>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ClinTrakPatientVisitFilterInput>>;
  patientId?: InputMaybe<UuidOperationFilterInput>;
  patientVisitId?: InputMaybe<UuidOperationFilterInput>;
  patientVisitMasterId?: InputMaybe<UuidOperationFilterInput>;
  scheduledDate?: InputMaybe<DateTimeOperationFilterInput>;
  statusAbbreviation?: InputMaybe<StringOperationFilterInput>;
  statusDescription?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type ClinTrakVisitNamesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ClinTrakVisitNamesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PatientVisit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClinTrakVisitNamesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PatientVisit;
};

/** A connection to a list of items. */
export type CountriesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<CountriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Country>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CountriesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Country;
};

export type Country = {
  currencyIsoCode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  regionType?: Maybe<Scalars['String']['output']>;
  threeCharCode: Scalars['String']['output'];
};

export type CountryFilterInput = {
  and?: InputMaybe<Array<CountryFilterInput>>;
  currencyIsoCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CountryFilterInput>>;
  regionType?: InputMaybe<StringOperationFilterInput>;
  threeCharCode?: InputMaybe<StringOperationFilterInput>;
};

export type CountrySortInput = {
  currencyIsoCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  regionType?: InputMaybe<SortEnumType>;
  threeCharCode?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CurrenciesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<CurrenciesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CurrencyInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CurrenciesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CurrencyInfo;
};

export type CurrencyInfo = {
  decimalPlaces: Scalars['Byte']['output'];
  isActive: Scalars['Boolean']['output'];
  isocode: Scalars['String']['output'];
  isoid: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Short']['output'];
  symbolDecimal?: Maybe<Scalars['String']['output']>;
  symbolHex?: Maybe<Scalars['String']['output']>;
};

export type CurrencyInfoFilterInput = {
  and?: InputMaybe<Array<CurrencyInfoFilterInput>>;
  decimalPlaces?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isocode?: InputMaybe<StringOperationFilterInput>;
  isoid?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CurrencyInfoFilterInput>>;
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  symbolDecimal?: InputMaybe<StringOperationFilterInput>;
  symbolHex?: InputMaybe<StringOperationFilterInput>;
};

export type CurrencyInfoSortInput = {
  decimalPlaces?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isocode?: InputMaybe<SortEnumType>;
  isoid?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  symbolDecimal?: InputMaybe<SortEnumType>;
  symbolHex?: InputMaybe<SortEnumType>;
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeletePatientEditRequestPayload = {
  successPatientEditRequestResponseDto?: Maybe<SuccessPatientEditRequestResponseDto>;
};

export type EditPatientInput = {
  patientEditData: PatientEditRequestDtoInput;
};

export type EditPatientPayload = {
  successPatientEditRequestResponseDto?: Maybe<SuccessPatientEditRequestResponseDto>;
};

export type Expense = {
  expenseDefaultValue: Scalars['String']['output'];
  expenseKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reimbursementTransaction: Array<ReimbursementTransaction>;
  studyExpense: Array<StudyExpense>;
};

export type ExpenseFilterInput = {
  and?: InputMaybe<Array<ExpenseFilterInput>>;
  expenseDefaultValue?: InputMaybe<StringOperationFilterInput>;
  expenseKey?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ExpenseFilterInput>>;
  reimbursementTransaction?: InputMaybe<ListFilterInputTypeOfReimbursementTransactionFilterInput>;
  studyExpense?: InputMaybe<ListFilterInputTypeOfStudyExpenseFilterInput>;
};

export type ExpenseSortInput = {
  expenseDefaultValue?: InputMaybe<SortEnumType>;
  expenseKey?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ExpensesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ExpensesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Expense>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ExpensesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Expense;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type GetPatientPortalAccessRequestByIdResult = {
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type ListFilterInputTypeOfCaregiverEditRequestFilterInput = {
  all?: InputMaybe<CaregiverEditRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CaregiverEditRequestFilterInput>;
  some?: InputMaybe<CaregiverEditRequestFilterInput>;
};

export type ListFilterInputTypeOfCaregiverFilterInput = {
  all?: InputMaybe<CaregiverFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CaregiverFilterInput>;
  some?: InputMaybe<CaregiverFilterInput>;
};

export type ListFilterInputTypeOfClinTrakPatientVisitFilterInput = {
  all?: InputMaybe<ClinTrakPatientVisitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ClinTrakPatientVisitFilterInput>;
  some?: InputMaybe<ClinTrakPatientVisitFilterInput>;
};

export type ListFilterInputTypeOfNotificationSentFilterInput = {
  all?: InputMaybe<NotificationSentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NotificationSentFilterInput>;
  some?: InputMaybe<NotificationSentFilterInput>;
};

export type ListFilterInputTypeOfPatientFilterInput = {
  all?: InputMaybe<PatientFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatientFilterInput>;
  some?: InputMaybe<PatientFilterInput>;
};

export type ListFilterInputTypeOfPatientUserFcmTokenFilterInput = {
  all?: InputMaybe<PatientUserFcmTokenFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatientUserFcmTokenFilterInput>;
  some?: InputMaybe<PatientUserFcmTokenFilterInput>;
};

export type ListFilterInputTypeOfPatientUserNotificationFilterInput = {
  all?: InputMaybe<PatientUserNotificationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatientUserNotificationFilterInput>;
  some?: InputMaybe<PatientUserNotificationFilterInput>;
};

export type ListFilterInputTypeOfReimbursementRequestApprovalStatusLogFilterInput = {
  all?: InputMaybe<ReimbursementRequestApprovalStatusLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReimbursementRequestApprovalStatusLogFilterInput>;
  some?: InputMaybe<ReimbursementRequestApprovalStatusLogFilterInput>;
};

export type ListFilterInputTypeOfReimbursementRequestFilterInput = {
  all?: InputMaybe<ReimbursementRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReimbursementRequestFilterInput>;
  some?: InputMaybe<ReimbursementRequestFilterInput>;
};

export type ListFilterInputTypeOfReimbursementTransactionFilterInput = {
  all?: InputMaybe<ReimbursementTransactionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReimbursementTransactionFilterInput>;
  some?: InputMaybe<ReimbursementTransactionFilterInput>;
};

export type ListFilterInputTypeOfSiteFilterInput = {
  all?: InputMaybe<SiteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SiteFilterInput>;
  some?: InputMaybe<SiteFilterInput>;
};

export type ListFilterInputTypeOfStipendRequestFilterInput = {
  all?: InputMaybe<StipendRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StipendRequestFilterInput>;
  some?: InputMaybe<StipendRequestFilterInput>;
};

export type ListFilterInputTypeOfStudyExpenseFilterInput = {
  all?: InputMaybe<StudyExpenseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StudyExpenseFilterInput>;
  some?: InputMaybe<StudyExpenseFilterInput>;
};

export type ListFilterInputTypeOfStudyFilterInput = {
  all?: InputMaybe<StudyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StudyFilterInput>;
  some?: InputMaybe<StudyFilterInput>;
};

export type ListFilterInputTypeOfStudyTravelOptionFilterInput = {
  all?: InputMaybe<StudyTravelOptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StudyTravelOptionFilterInput>;
  some?: InputMaybe<StudyTravelOptionFilterInput>;
};

export type ListFilterInputTypeOfTravelRequestApprovalStatusLogFilterInput = {
  all?: InputMaybe<TravelRequestApprovalStatusLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TravelRequestApprovalStatusLogFilterInput>;
  some?: InputMaybe<TravelRequestApprovalStatusLogFilterInput>;
};

export type ListFilterInputTypeOfTravelRequestCaregiverFilterInput = {
  all?: InputMaybe<TravelRequestCaregiverFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TravelRequestCaregiverFilterInput>;
  some?: InputMaybe<TravelRequestCaregiverFilterInput>;
};

export type ListFilterInputTypeOfTravelRequestFilterInput = {
  all?: InputMaybe<TravelRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TravelRequestFilterInput>;
  some?: InputMaybe<TravelRequestFilterInput>;
};

export type ListFilterInputTypeOfTravelRequestSpendDataFilterInput = {
  all?: InputMaybe<TravelRequestSpendDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TravelRequestSpendDataFilterInput>;
  some?: InputMaybe<TravelRequestSpendDataFilterInput>;
};

export type ListFilterInputTypeOfTravelRequestTransferDataFilterInput = {
  all?: InputMaybe<TravelRequestTransferDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TravelRequestTransferDataFilterInput>;
  some?: InputMaybe<TravelRequestTransferDataFilterInput>;
};

export type ListFilterInputTypeOfTravelTransactionFilterInput = {
  all?: InputMaybe<TravelTransactionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TravelTransactionFilterInput>;
  some?: InputMaybe<TravelTransactionFilterInput>;
};

export type ListFilterInputTypeOfVisitNameFilterInput = {
  all?: InputMaybe<VisitNameFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VisitNameFilterInput>;
  some?: InputMaybe<VisitNameFilterInput>;
};

export type ListFilterInputTypeOfVisitScheduleRequestItemFilterInput = {
  all?: InputMaybe<VisitScheduleRequestItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VisitScheduleRequestItemFilterInput>;
  some?: InputMaybe<VisitScheduleRequestItemFilterInput>;
};

export type LoginPatientInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginPatientPayload = {
  authResult?: Maybe<AuthResult>;
};

export type LogoutPatientPayload = {
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type MileageReimbursementRate = {
  countryCode: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  effectiveDate: Scalars['Date']['output'];
  mileageDistanceUnits: Scalars['String']['output'];
  mileageReimbursementRatePerUnit: Scalars['Float']['output'];
  modifiedBy: Scalars['String']['output'];
};

export type MileageReimbursementRateFilterInput = {
  and?: InputMaybe<Array<MileageReimbursementRateFilterInput>>;
  countryCode?: InputMaybe<StringOperationFilterInput>;
  currencyCode?: InputMaybe<StringOperationFilterInput>;
  effectiveDate?: InputMaybe<DateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  mileageDistanceUnits?: InputMaybe<StringOperationFilterInput>;
  mileageReimbursementRatePerUnit?: InputMaybe<DecimalOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MileageReimbursementRateFilterInput>>;
};

export type MileageReimbursementRateSortInput = {
  countryCode?: InputMaybe<SortEnumType>;
  currencyCode?: InputMaybe<SortEnumType>;
  effectiveDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  mileageDistanceUnits?: InputMaybe<SortEnumType>;
  mileageReimbursementRatePerUnit?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MileageReimbursementRatesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<MileageReimbursementRatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MileageReimbursementRate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MileageReimbursementRatesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MileageReimbursementRate;
};

export type Mutation = {
  changeLoggedPatientPassword: ChangeLoggedPatientPasswordPayload;
  changePasswordInPasswordResetScenario: ChangePasswordInPasswordResetScenarioPayload;
  changePatientUserLanguage: ChangePatientUserLanguagePayload;
  deletePatientEditRequest: DeletePatientEditRequestPayload;
  editPatient: EditPatientPayload;
  loginPatient: LoginPatientPayload;
  logoutPatient: LogoutPatientPayload;
  refreshTokenFromBody: RefreshTokenFromBodyPayload;
  refreshTokenFromCookie: RefreshTokenFromCookiePayload;
  registerPatient: RegisterPatientPayload;
  removePatientFcmToken: RemovePatientFcmTokenPayload;
  resetPassword: ResetPasswordPayload;
  saveDraftReimbursementRequest: SaveDraftReimbursementRequestPayload;
  saveDraftTravelRequest: SaveDraftTravelRequestPayload;
  savePatientUserFcmToken: SavePatientUserFcmTokenPayload;
  setPatientUserNotificationDefaults: SetPatientUserNotificationDefaultsPayload;
  setPatientUserNotifications: SetPatientUserNotificationsPayload;
  submitPatientEditRequest: SubmitPatientEditRequestPayload;
  submitReimbursementRequest: SubmitReimbursementRequestPayload;
  submitTravelRequest: SubmitTravelRequestPayload;
};


export type MutationChangeLoggedPatientPasswordArgs = {
  input: ChangeLoggedPatientPasswordInput;
};


export type MutationChangePasswordInPasswordResetScenarioArgs = {
  input: ChangePasswordInPasswordResetScenarioInput;
};


export type MutationChangePatientUserLanguageArgs = {
  input: ChangePatientUserLanguageInput;
};


export type MutationEditPatientArgs = {
  input: EditPatientInput;
};


export type MutationLoginPatientArgs = {
  input: LoginPatientInput;
};


export type MutationRefreshTokenFromBodyArgs = {
  input: RefreshTokenFromBodyInput;
};


export type MutationRegisterPatientArgs = {
  input: RegisterPatientInput;
};


export type MutationRemovePatientFcmTokenArgs = {
  input: RemovePatientFcmTokenInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSaveDraftReimbursementRequestArgs = {
  input: SaveDraftReimbursementRequestInput;
};


export type MutationSaveDraftTravelRequestArgs = {
  input: SaveDraftTravelRequestInput;
};


export type MutationSavePatientUserFcmTokenArgs = {
  input: SavePatientUserFcmTokenInput;
};


export type MutationSetPatientUserNotificationsArgs = {
  input: SetPatientUserNotificationsInput;
};


export type MutationSubmitReimbursementRequestArgs = {
  input: SubmitReimbursementRequestInput;
};


export type MutationSubmitTravelRequestArgs = {
  input: SubmitTravelRequestInput;
};

export type NotificationSent = {
  createDatetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notificationEventKey: Scalars['String']['output'];
  patient: Patient;
  patientId: Scalars['Int']['output'];
  targetGroup: Scalars['String']['output'];
  targetId: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type NotificationSentFilterInput = {
  and?: InputMaybe<Array<NotificationSentFilterInput>>;
  createDatetime?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  notificationEventKey?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NotificationSentFilterInput>>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  targetGroup?: InputMaybe<StringOperationFilterInput>;
  targetId?: InputMaybe<IntOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type NotificationSentSortInput = {
  createDatetime?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  notificationEventKey?: InputMaybe<SortEnumType>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  targetGroup?: InputMaybe<SortEnumType>;
  targetId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type NotificationsSentConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<NotificationsSentEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<NotificationSent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationsSentEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NotificationSent;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PasswordResetRequest = {
  id: Scalars['Int']['output'];
  modifiedBy: Scalars['String']['output'];
  patientUser: PatientUser;
  patientUserId: Scalars['Int']['output'];
  requestTime: Scalars['DateTime']['output'];
  resetPasswordCode: Scalars['String']['output'];
};

export type PasswordResetRequestFilterInput = {
  and?: InputMaybe<Array<PasswordResetRequestFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PasswordResetRequestFilterInput>>;
  patientUser?: InputMaybe<PatientUserFilterInput>;
  patientUserId?: InputMaybe<IntOperationFilterInput>;
  requestTime?: InputMaybe<DateTimeOperationFilterInput>;
  resetPasswordCode?: InputMaybe<StringOperationFilterInput>;
};

export type PasswordResetRequestSortInput = {
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  patientUser?: InputMaybe<PatientUserSortInput>;
  patientUserId?: InputMaybe<SortEnumType>;
  requestTime?: InputMaybe<SortEnumType>;
  resetPasswordCode?: InputMaybe<SortEnumType>;
};

export type Patient = {
  accessRamp: Scalars['Boolean']['output'];
  accessWalker: Scalars['Boolean']['output'];
  accessWheelChair: Scalars['Boolean']['output'];
  accessibilityRequirements?: Maybe<Scalars['String']['output']>;
  airTravelRequired: Scalars['Boolean']['output'];
  airlinePrimary?: Maybe<Scalars['String']['output']>;
  airlineSecondary?: Maybe<Scalars['String']['output']>;
  allergies?: Maybe<Scalars['String']['output']>;
  bankDetailsId?: Maybe<Scalars['Int']['output']>;
  caregiver: Array<Caregiver>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  groundTransportRequired: Scalars['Boolean']['output'];
  hotelChainPrimary?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internationTravelRequired: Scalars['Boolean']['output'];
  internationalTraveler?: Maybe<Scalars['String']['output']>;
  lodgingRequired: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  notificationSent: Array<NotificationSent>;
  patientData?: Maybe<PatientData>;
  patientEditRequest?: Maybe<PatientEditRequest>;
  patientNum: Scalars['String']['output'];
  patientPaymentDetails?: Maybe<PatientPaymentDetails>;
  patientPortalAccessRequest?: Maybe<PatientPortalAccessRequest>;
  patientUser?: Maybe<PatientUser>;
  pcsId?: Maybe<Scalars['String']['output']>;
  reimbursementRequest: Array<ReimbursementRequest>;
  rentalCarRequired: Scalars['Boolean']['output'];
  seatPreference?: Maybe<Scalars['String']['output']>;
  site: Site;
  siteId: Scalars['Int']['output'];
  status: PatientStatus;
  statusId: Scalars['Int']['output'];
  stipendRequest: Array<StipendRequest>;
  trainRequired: Scalars['Boolean']['output'];
  travelRequest: Array<TravelRequest>;
  travelRequestSpendData: Array<TravelRequestSpendData>;
};

export type PatientCtsmStatusDto = {
  statusName?: Maybe<Scalars['String']['output']>;
};

export type PatientData = {
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  airlineRewardsPrimary?: Maybe<Scalars['String']['output']>;
  airlineRewardsSecondary?: Maybe<Scalars['String']['output']>;
  airlineSpecialNeeds?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  caregiverInfo?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  groundSpecialNeeds?: Maybe<Scalars['String']['output']>;
  hasConsentForm: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  knownTravelerNum?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  lodgingRoomPreference?: Maybe<Scalars['String']['output']>;
  lodgingSpecialNeeds?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  modifiedBy: Scalars['String']['output'];
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiration?: Maybe<Scalars['Date']['output']>;
  passportIssue?: Maybe<Scalars['Date']['output']>;
  passportNum?: Maybe<Scalars['String']['output']>;
  patient: Patient;
  patientId: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
  preferredLang: Scalars['String']['output'];
  rentalCarFrequentTravelerNum?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  trainSpecialNeeds?: Maybe<Scalars['String']['output']>;
  underEighteen: Scalars['Boolean']['output'];
  visitGroupId?: Maybe<Scalars['Int']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type PatientDataConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<PatientDataEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PatientData>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PatientDataEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PatientData;
};

export type PatientDataFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  airlineRewardsPrimary?: InputMaybe<StringOperationFilterInput>;
  airlineRewardsSecondary?: InputMaybe<StringOperationFilterInput>;
  airlineSpecialNeeds?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<PatientDataFilterInput>>;
  birthDate?: InputMaybe<DateTimeOperationFilterInput>;
  caregiverInfo?: InputMaybe<StringOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  gender?: InputMaybe<StringOperationFilterInput>;
  groundSpecialNeeds?: InputMaybe<StringOperationFilterInput>;
  hasConsentForm?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  knownTravelerNum?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  lodgingRoomPreference?: InputMaybe<StringOperationFilterInput>;
  lodgingSpecialNeeds?: InputMaybe<StringOperationFilterInput>;
  middleName?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatientDataFilterInput>>;
  passportCountry?: InputMaybe<StringOperationFilterInput>;
  passportExpiration?: InputMaybe<DateOperationFilterInput>;
  passportIssue?: InputMaybe<DateOperationFilterInput>;
  passportNum?: InputMaybe<StringOperationFilterInput>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  preferredLang?: InputMaybe<StringOperationFilterInput>;
  rentalCarFrequentTravelerNum?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  trainSpecialNeeds?: InputMaybe<StringOperationFilterInput>;
  underEighteen?: InputMaybe<BooleanOperationFilterInput>;
  visitGroupId?: InputMaybe<IntOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type PatientDataSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  airlineRewardsPrimary?: InputMaybe<SortEnumType>;
  airlineRewardsSecondary?: InputMaybe<SortEnumType>;
  airlineSpecialNeeds?: InputMaybe<SortEnumType>;
  birthDate?: InputMaybe<SortEnumType>;
  caregiverInfo?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  gender?: InputMaybe<SortEnumType>;
  groundSpecialNeeds?: InputMaybe<SortEnumType>;
  hasConsentForm?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  knownTravelerNum?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lodgingRoomPreference?: InputMaybe<SortEnumType>;
  lodgingSpecialNeeds?: InputMaybe<SortEnumType>;
  middleName?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  passportCountry?: InputMaybe<SortEnumType>;
  passportExpiration?: InputMaybe<SortEnumType>;
  passportIssue?: InputMaybe<SortEnumType>;
  passportNum?: InputMaybe<SortEnumType>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  preferredLang?: InputMaybe<SortEnumType>;
  rentalCarFrequentTravelerNum?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  trainSpecialNeeds?: InputMaybe<SortEnumType>;
  underEighteen?: InputMaybe<SortEnumType>;
  visitGroupId?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

export type PatientEditRequest = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  airlinePrimary?: Maybe<Scalars['String']['output']>;
  airlineRewardsPrimary?: Maybe<Scalars['String']['output']>;
  airlineRewardsSecondary?: Maybe<Scalars['String']['output']>;
  airlineSecondary?: Maybe<Scalars['String']['output']>;
  airlineSpecialNeeds?: Maybe<Scalars['String']['output']>;
  allergies?: Maybe<Scalars['String']['output']>;
  caregiverEditRequest: Array<CaregiverEditRequest>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  groundSpecialNeeds?: Maybe<Scalars['String']['output']>;
  hotelChainPrimary?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isSubmitted: Scalars['Boolean']['output'];
  knownTravelerNum?: Maybe<Scalars['String']['output']>;
  lastUpdateTimestamp: Scalars['DateTime']['output'];
  lodgingRoomPreference?: Maybe<Scalars['String']['output']>;
  lodgingSpecialNeeds?: Maybe<Scalars['String']['output']>;
  modifiedBy: Scalars['String']['output'];
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiration?: Maybe<Scalars['Date']['output']>;
  passportIssue?: Maybe<Scalars['Date']['output']>;
  passportNum?: Maybe<Scalars['String']['output']>;
  patient: Patient;
  patientId: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  preferredLang?: Maybe<Scalars['String']['output']>;
  profileChangeDetails?: Maybe<Scalars['String']['output']>;
  rentalCarFrequentTravelerNum?: Maybe<Scalars['String']['output']>;
  seatPreference?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  trainSpecialNeeds?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type PatientEditRequestDtoInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  airlinePrimary?: InputMaybe<Scalars['String']['input']>;
  airlineRewardsPrimary?: InputMaybe<Scalars['String']['input']>;
  airlineRewardsSecondary?: InputMaybe<Scalars['String']['input']>;
  airlineSecondary?: InputMaybe<Scalars['String']['input']>;
  airlineSpecialNeeds?: InputMaybe<Scalars['String']['input']>;
  allergies?: InputMaybe<Scalars['String']['input']>;
  caregiverEditRequest: Array<CaregiverEditRequestDtoInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  groundSpecialNeeds?: InputMaybe<Scalars['String']['input']>;
  hotelChainPrimary?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  knownTravelerNum?: InputMaybe<Scalars['String']['input']>;
  lodgingRoomPreference?: InputMaybe<Scalars['String']['input']>;
  lodgingSpecialNeeds?: InputMaybe<Scalars['String']['input']>;
  passportCountry?: InputMaybe<Scalars['String']['input']>;
  passportExpiration?: InputMaybe<Scalars['Date']['input']>;
  passportIssue?: InputMaybe<Scalars['Date']['input']>;
  passportNum?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredLang?: InputMaybe<Scalars['String']['input']>;
  profileChangeDetails?: InputMaybe<Scalars['String']['input']>;
  rentalCarFrequentTravelerNum?: InputMaybe<Scalars['String']['input']>;
  seatPreference?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  trainSpecialNeeds?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type PatientEditRequestFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  airlinePrimary?: InputMaybe<StringOperationFilterInput>;
  airlineRewardsPrimary?: InputMaybe<StringOperationFilterInput>;
  airlineRewardsSecondary?: InputMaybe<StringOperationFilterInput>;
  airlineSecondary?: InputMaybe<StringOperationFilterInput>;
  airlineSpecialNeeds?: InputMaybe<StringOperationFilterInput>;
  allergies?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<PatientEditRequestFilterInput>>;
  caregiverEditRequest?: InputMaybe<ListFilterInputTypeOfCaregiverEditRequestFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  groundSpecialNeeds?: InputMaybe<StringOperationFilterInput>;
  hotelChainPrimary?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isSubmitted?: InputMaybe<BooleanOperationFilterInput>;
  knownTravelerNum?: InputMaybe<StringOperationFilterInput>;
  lastUpdateTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  lodgingRoomPreference?: InputMaybe<StringOperationFilterInput>;
  lodgingSpecialNeeds?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatientEditRequestFilterInput>>;
  passportCountry?: InputMaybe<StringOperationFilterInput>;
  passportExpiration?: InputMaybe<DateOperationFilterInput>;
  passportIssue?: InputMaybe<DateOperationFilterInput>;
  passportNum?: InputMaybe<StringOperationFilterInput>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  preferredLang?: InputMaybe<StringOperationFilterInput>;
  profileChangeDetails?: InputMaybe<StringOperationFilterInput>;
  rentalCarFrequentTravelerNum?: InputMaybe<StringOperationFilterInput>;
  seatPreference?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  trainSpecialNeeds?: InputMaybe<StringOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type PatientEditRequestSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  airlinePrimary?: InputMaybe<SortEnumType>;
  airlineRewardsPrimary?: InputMaybe<SortEnumType>;
  airlineRewardsSecondary?: InputMaybe<SortEnumType>;
  airlineSecondary?: InputMaybe<SortEnumType>;
  airlineSpecialNeeds?: InputMaybe<SortEnumType>;
  allergies?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  groundSpecialNeeds?: InputMaybe<SortEnumType>;
  hotelChainPrimary?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isSubmitted?: InputMaybe<SortEnumType>;
  knownTravelerNum?: InputMaybe<SortEnumType>;
  lastUpdateTimestamp?: InputMaybe<SortEnumType>;
  lodgingRoomPreference?: InputMaybe<SortEnumType>;
  lodgingSpecialNeeds?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  passportCountry?: InputMaybe<SortEnumType>;
  passportExpiration?: InputMaybe<SortEnumType>;
  passportIssue?: InputMaybe<SortEnumType>;
  passportNum?: InputMaybe<SortEnumType>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  preferredLang?: InputMaybe<SortEnumType>;
  profileChangeDetails?: InputMaybe<SortEnumType>;
  rentalCarFrequentTravelerNum?: InputMaybe<SortEnumType>;
  seatPreference?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  trainSpecialNeeds?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

export type PatientFilterInput = {
  accessRamp?: InputMaybe<BooleanOperationFilterInput>;
  accessWalker?: InputMaybe<BooleanOperationFilterInput>;
  accessWheelChair?: InputMaybe<BooleanOperationFilterInput>;
  accessibilityRequirements?: InputMaybe<StringOperationFilterInput>;
  airTravelRequired?: InputMaybe<BooleanOperationFilterInput>;
  airlinePrimary?: InputMaybe<StringOperationFilterInput>;
  airlineSecondary?: InputMaybe<StringOperationFilterInput>;
  allergies?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<PatientFilterInput>>;
  bankDetailsId?: InputMaybe<IntOperationFilterInput>;
  caregiver?: InputMaybe<ListFilterInputTypeOfCaregiverFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  groundTransportRequired?: InputMaybe<BooleanOperationFilterInput>;
  hotelChainPrimary?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  internationTravelRequired?: InputMaybe<BooleanOperationFilterInput>;
  internationalTraveler?: InputMaybe<StringOperationFilterInput>;
  lodgingRequired?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  notificationSent?: InputMaybe<ListFilterInputTypeOfNotificationSentFilterInput>;
  or?: InputMaybe<Array<PatientFilterInput>>;
  patientData?: InputMaybe<PatientDataFilterInput>;
  patientEditRequest?: InputMaybe<PatientEditRequestFilterInput>;
  patientNum?: InputMaybe<StringOperationFilterInput>;
  patientPaymentDetails?: InputMaybe<PatientPaymentDetailsFilterInput>;
  patientPortalAccessRequest?: InputMaybe<PatientPortalAccessRequestFilterInput>;
  patientUser?: InputMaybe<PatientUserFilterInput>;
  pcsId?: InputMaybe<StringOperationFilterInput>;
  reimbursementRequest?: InputMaybe<ListFilterInputTypeOfReimbursementRequestFilterInput>;
  rentalCarRequired?: InputMaybe<BooleanOperationFilterInput>;
  seatPreference?: InputMaybe<StringOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<PatientStatusFilterInput>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  stipendRequest?: InputMaybe<ListFilterInputTypeOfStipendRequestFilterInput>;
  trainRequired?: InputMaybe<BooleanOperationFilterInput>;
  travelRequest?: InputMaybe<ListFilterInputTypeOfTravelRequestFilterInput>;
  travelRequestSpendData?: InputMaybe<ListFilterInputTypeOfTravelRequestSpendDataFilterInput>;
};

export type PatientPaymentDetails = {
  id: Scalars['ID']['output'];
  kycdocumentInfoId?: Maybe<Scalars['Int']['output']>;
  kycvendorId?: Maybe<Scalars['String']['output']>;
  modifiedBy: Scalars['String']['output'];
  patient: Patient;
  patientId: Scalars['Int']['output'];
  paymentApprovalDate?: Maybe<Scalars['Date']['output']>;
  paymentApprover?: Maybe<Scalars['String']['output']>;
  paymentRecipientEmail?: Maybe<Scalars['String']['output']>;
  paymentRecipientFirstName?: Maybe<Scalars['String']['output']>;
  paymentRecipientLastName?: Maybe<Scalars['String']['output']>;
  paymentRecipientRole?: Maybe<Scalars['String']['output']>;
  pqaccountStatus?: Maybe<Scalars['Int']['output']>;
  pqfundingAccountPublicId?: Maybe<Scalars['String']['output']>;
  preferredCurrency?: Maybe<Scalars['String']['output']>;
  preferredPayment?: Maybe<Scalars['String']['output']>;
  readyForPayment: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type PatientPaymentDetailsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<PatientPaymentDetailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PatientData>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PatientPaymentDetailsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PatientData;
};

export type PatientPaymentDetailsFilterInput = {
  and?: InputMaybe<Array<PatientPaymentDetailsFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  kycdocumentInfoId?: InputMaybe<IntOperationFilterInput>;
  kycvendorId?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatientPaymentDetailsFilterInput>>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  paymentApprovalDate?: InputMaybe<DateTimeOperationFilterInput>;
  paymentApprover?: InputMaybe<StringOperationFilterInput>;
  paymentRecipientEmail?: InputMaybe<StringOperationFilterInput>;
  paymentRecipientFirstName?: InputMaybe<StringOperationFilterInput>;
  paymentRecipientLastName?: InputMaybe<StringOperationFilterInput>;
  paymentRecipientRole?: InputMaybe<StringOperationFilterInput>;
  pqaccountStatus?: InputMaybe<IntOperationFilterInput>;
  pqfundingAccountPublicId?: InputMaybe<StringOperationFilterInput>;
  preferredCurrency?: InputMaybe<StringOperationFilterInput>;
  preferredPayment?: InputMaybe<StringOperationFilterInput>;
  readyForPayment?: InputMaybe<BooleanOperationFilterInput>;
};

export type PatientPaymentDetailsSortInput = {
  id?: InputMaybe<SortEnumType>;
  kycdocumentInfoId?: InputMaybe<SortEnumType>;
  kycvendorId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  paymentApprovalDate?: InputMaybe<SortEnumType>;
  paymentApprover?: InputMaybe<SortEnumType>;
  paymentRecipientEmail?: InputMaybe<SortEnumType>;
  paymentRecipientFirstName?: InputMaybe<SortEnumType>;
  paymentRecipientLastName?: InputMaybe<SortEnumType>;
  paymentRecipientRole?: InputMaybe<SortEnumType>;
  pqaccountStatus?: InputMaybe<SortEnumType>;
  pqfundingAccountPublicId?: InputMaybe<SortEnumType>;
  preferredCurrency?: InputMaybe<SortEnumType>;
  preferredPayment?: InputMaybe<SortEnumType>;
  readyForPayment?: InputMaybe<SortEnumType>;
};

export type PatientPortalAccessRequest = {
  expire: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  modifiedBy: Scalars['String']['output'];
  patient: Patient;
  patientId: Scalars['Int']['output'];
  registrationTrialsLeft: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
};

export type PatientPortalAccessRequestFilterInput = {
  and?: InputMaybe<Array<PatientPortalAccessRequestFilterInput>>;
  expire?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatientPortalAccessRequestFilterInput>>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  registrationTrialsLeft?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
};

export type PatientPortalAccessRequestSortInput = {
  expire?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  registrationTrialsLeft?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type PatientSortInput = {
  accessRamp?: InputMaybe<SortEnumType>;
  accessWalker?: InputMaybe<SortEnumType>;
  accessWheelChair?: InputMaybe<SortEnumType>;
  accessibilityRequirements?: InputMaybe<SortEnumType>;
  airTravelRequired?: InputMaybe<SortEnumType>;
  airlinePrimary?: InputMaybe<SortEnumType>;
  airlineSecondary?: InputMaybe<SortEnumType>;
  allergies?: InputMaybe<SortEnumType>;
  bankDetailsId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  groundTransportRequired?: InputMaybe<SortEnumType>;
  hotelChainPrimary?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  internationTravelRequired?: InputMaybe<SortEnumType>;
  internationalTraveler?: InputMaybe<SortEnumType>;
  lodgingRequired?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  patientData?: InputMaybe<PatientDataSortInput>;
  patientEditRequest?: InputMaybe<PatientEditRequestSortInput>;
  patientNum?: InputMaybe<SortEnumType>;
  patientPaymentDetails?: InputMaybe<PatientPaymentDetailsSortInput>;
  patientPortalAccessRequest?: InputMaybe<PatientPortalAccessRequestSortInput>;
  patientUser?: InputMaybe<PatientUserSortInput>;
  pcsId?: InputMaybe<SortEnumType>;
  rentalCarRequired?: InputMaybe<SortEnumType>;
  seatPreference?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<PatientStatusSortInput>;
  statusId?: InputMaybe<SortEnumType>;
  trainRequired?: InputMaybe<SortEnumType>;
};

export type PatientStatus = {
  appName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  patient: Array<Patient>;
};

export type PatientStatusFilterInput = {
  and?: InputMaybe<Array<PatientStatusFilterInput>>;
  appName?: InputMaybe<StringOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PatientStatusFilterInput>>;
  patient?: InputMaybe<ListFilterInputTypeOfPatientFilterInput>;
};

export type PatientStatusSortInput = {
  appName?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PatientStatusesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<PatientStatusesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PatientStatus>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PatientStatusesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PatientStatus;
};

export type PatientUser = {
  applicationLanguage: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modifiedBy: Scalars['String']['output'];
  passwordResetRequest?: Maybe<PasswordResetRequest>;
  patient: Patient;
  patientId: Scalars['Int']['output'];
  patientUserFcmToken: Array<PatientUserFcmToken>;
  patientUserNotification: Array<PatientUserNotification>;
  patientUserPassword?: Maybe<PatientUserPassword>;
};

export type PatientUserFcmToken = {
  deviceId: Scalars['String']['output'];
  fcmToken: Scalars['String']['output'];
  fcmTokenExpirationDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  patientUser: PatientUser;
  patientUserId: Scalars['Int']['output'];
};

export type PatientUserFcmTokenDtoInput = {
  deviceId: Scalars['String']['input'];
  fcmToken: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type PatientUserFcmTokenFilterInput = {
  and?: InputMaybe<Array<PatientUserFcmTokenFilterInput>>;
  deviceId?: InputMaybe<StringOperationFilterInput>;
  fcmToken?: InputMaybe<StringOperationFilterInput>;
  fcmTokenExpirationDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PatientUserFcmTokenFilterInput>>;
  patientUser?: InputMaybe<PatientUserFilterInput>;
  patientUserId?: InputMaybe<IntOperationFilterInput>;
};

export type PatientUserFilterInput = {
  and?: InputMaybe<Array<PatientUserFilterInput>>;
  applicationLanguage?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatientUserFilterInput>>;
  passwordResetRequest?: InputMaybe<PasswordResetRequestFilterInput>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  patientUserFcmToken?: InputMaybe<ListFilterInputTypeOfPatientUserFcmTokenFilterInput>;
  patientUserNotification?: InputMaybe<ListFilterInputTypeOfPatientUserNotificationFilterInput>;
  patientUserPassword?: InputMaybe<PatientUserPasswordFilterInput>;
  refreshToken?: InputMaybe<RefreshTokenFilterInput>;
  refreshTokenId?: InputMaybe<UuidOperationFilterInput>;
};

export type PatientUserNotification = {
  allowEmailNotification?: Maybe<Scalars['Boolean']['output']>;
  allowPushNotification?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  patientUser: PatientUser;
  patientUserId: Scalars['Int']['output'];
  templateId: Scalars['String']['output'];
};

export type PatientUserNotificationDtoInput = {
  allowEmailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  allowPushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  templateId: Scalars['String']['input'];
};

export type PatientUserNotificationFilterInput = {
  allowEmailNotification?: InputMaybe<BooleanOperationFilterInput>;
  allowPushNotification?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<PatientUserNotificationFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatientUserNotificationFilterInput>>;
  patientUser?: InputMaybe<PatientUserFilterInput>;
  patientUserId?: InputMaybe<IntOperationFilterInput>;
  templateId?: InputMaybe<StringOperationFilterInput>;
};

export type PatientUserNotificationSortInput = {
  allowEmailNotification?: InputMaybe<SortEnumType>;
  allowPushNotification?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  patientUser?: InputMaybe<PatientUserSortInput>;
  patientUserId?: InputMaybe<SortEnumType>;
  templateId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PatientUserNotificationsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<PatientUserNotificationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PatientUserNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PatientUserNotificationsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PatientUserNotification;
};

export type PatientUserPassword = {
  patientUser: PatientUser;
  patientUserId: Scalars['ID']['output'];
};

export type PatientUserPasswordFilterInput = {
  and?: InputMaybe<Array<PatientUserPasswordFilterInput>>;
  or?: InputMaybe<Array<PatientUserPasswordFilterInput>>;
  passwordHash?: InputMaybe<StringOperationFilterInput>;
  passwordSalt?: InputMaybe<StringOperationFilterInput>;
  patientUser?: InputMaybe<PatientUserFilterInput>;
  patientUserId?: InputMaybe<IntOperationFilterInput>;
};

export type PatientUserPasswordSortInput = {
  passwordHash?: InputMaybe<SortEnumType>;
  passwordSalt?: InputMaybe<SortEnumType>;
  patientUser?: InputMaybe<PatientUserSortInput>;
  patientUserId?: InputMaybe<SortEnumType>;
};

export type PatientUserSortInput = {
  applicationLanguage?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  passwordResetRequest?: InputMaybe<PasswordResetRequestSortInput>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  patientUserPassword?: InputMaybe<PatientUserPasswordSortInput>;
  refreshToken?: InputMaybe<RefreshTokenSortInput>;
  refreshTokenId?: InputMaybe<SortEnumType>;
};

export type PatientVisit = {
  actualDate?: Maybe<Scalars['DateTime']['output']>;
  clinTrakPatientVisits?: Maybe<Array<ClinTrakPatientVisit>>;
  clintrakActualDate?: Maybe<Scalars['DateTime']['output']>;
  hasStipendSupport: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  requestCount: Scalars['Int']['output'];
  requests?: Maybe<Array<VisitScheduleRequestItem>>;
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  sortOrder: Scalars['Int']['output'];
  sortOrderDate?: Maybe<Scalars['DateTime']['output']>;
  stipendConfigAmount?: Maybe<Scalars['Decimal']['output']>;
  stipendRequestStatus?: Maybe<Scalars['String']['output']>;
  stipendRequestStatusTimestamp?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  visitGroupId?: Maybe<Scalars['Int']['output']>;
  visitGroupName?: Maybe<Scalars['String']['output']>;
  visitName: Scalars['String']['output'];
  visitNameType: Scalars['Int']['output'];
};

export type PatientVisitFilterInput = {
  actualDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<PatientVisitFilterInput>>;
  clinTrakPatientVisits?: InputMaybe<ListFilterInputTypeOfClinTrakPatientVisitFilterInput>;
  clintrakActualDate?: InputMaybe<DateTimeOperationFilterInput>;
  hasStipendSupport?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PatientVisitFilterInput>>;
  requestCount?: InputMaybe<IntOperationFilterInput>;
  requests?: InputMaybe<ListFilterInputTypeOfVisitScheduleRequestItemFilterInput>;
  scheduled?: InputMaybe<BooleanOperationFilterInput>;
  scheduledDate?: InputMaybe<DateTimeOperationFilterInput>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  sortOrderDate?: InputMaybe<DateTimeOperationFilterInput>;
  stipendConfigAmount?: InputMaybe<DecimalOperationFilterInput>;
  stipendRequestStatus?: InputMaybe<StringOperationFilterInput>;
  stipendRequestStatusTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  visitGroupId?: InputMaybe<IntOperationFilterInput>;
  visitGroupName?: InputMaybe<StringOperationFilterInput>;
  visitName?: InputMaybe<StringOperationFilterInput>;
  visitNameType?: InputMaybe<IntOperationFilterInput>;
};

export type PatientVisitSortInput = {
  actualDate?: InputMaybe<SortEnumType>;
  clintrakActualDate?: InputMaybe<SortEnumType>;
  hasStipendSupport?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  requestCount?: InputMaybe<SortEnumType>;
  scheduled?: InputMaybe<SortEnumType>;
  scheduledDate?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  sortOrderDate?: InputMaybe<SortEnumType>;
  stipendConfigAmount?: InputMaybe<SortEnumType>;
  stipendRequestStatus?: InputMaybe<SortEnumType>;
  stipendRequestStatusTimestamp?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  visitGroupId?: InputMaybe<SortEnumType>;
  visitGroupName?: InputMaybe<SortEnumType>;
  visitName?: InputMaybe<SortEnumType>;
  visitNameType?: InputMaybe<SortEnumType>;
};

export type Query = {
  caregiver?: Maybe<Caregiver>;
  caregivers?: Maybe<CaregiversConnection>;
  clinTrakVisitNames?: Maybe<ClinTrakVisitNamesConnection>;
  countries?: Maybe<CountriesConnection>;
  country?: Maybe<Country>;
  currencies?: Maybe<CurrenciesConnection>;
  currency?: Maybe<CurrencyInfo>;
  currentPatient?: Maybe<Patient>;
  expense?: Maybe<Expense>;
  expenses?: Maybe<ExpensesConnection>;
  mileageReimbursementRate?: Maybe<MileageReimbursementRate>;
  mileageReimbursementRates?: Maybe<MileageReimbursementRatesConnection>;
  notificationsSent?: Maybe<NotificationsSentConnection>;
  patientCtsmStatus?: Maybe<PatientCtsmStatusDto>;
  patientData?: Maybe<PatientDataConnection>;
  patientDatum?: Maybe<PatientData>;
  patientPaymentDetail?: Maybe<PatientData>;
  patientPaymentDetails?: Maybe<PatientPaymentDetailsConnection>;
  patientPortalAccessRequestById?: Maybe<GetPatientPortalAccessRequestByIdResult>;
  patientStatus?: Maybe<PatientStatus>;
  patientStatuses?: Maybe<PatientStatusesConnection>;
  patientUser?: Maybe<PatientUser>;
  patientUserFcmToken?: Maybe<PatientUserFcmToken>;
  patientUserFcmTokens?: Maybe<PatientUserFcmToken>;
  patientUserNotification?: Maybe<PatientUserNotification>;
  patientUserNotifications?: Maybe<PatientUserNotificationsConnection>;
  reimbursementRequest?: Maybe<ReimbursementRequest>;
  reimbursementRequests?: Maybe<ReimbursementRequestsConnection>;
  site?: Maybe<Site>;
  sites?: Maybe<SitesConnection>;
  stipendRequest?: Maybe<StipendRequest>;
  stipendRequests?: Maybe<StipendRequestsConnection>;
  studies?: Maybe<StudiesConnection>;
  study?: Maybe<Study>;
  studyActiveExpenses: Array<ActiveStudyExpenses>;
  studyExpense?: Maybe<StudyExpense>;
  studyExpenses?: Maybe<StudyExpensesConnection>;
  travelRequest?: Maybe<TravelRequest>;
  travelRequests?: Maybe<TravelRequestsConnection>;
  visitName?: Maybe<VisitName>;
  visitNames?: Maybe<VisitNamesConnection>;
};


export type QueryCaregiverArgs = {
  where?: InputMaybe<CaregiverFilterInput>;
};


export type QueryCaregiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CaregiverSortInput>>;
  where?: InputMaybe<CaregiverFilterInput>;
};


export type QueryClinTrakVisitNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PatientVisitSortInput>>;
  studyId: Scalars['Int']['input'];
  where?: InputMaybe<PatientVisitFilterInput>;
};


export type QueryCountriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CountrySortInput>>;
  where?: InputMaybe<CountryFilterInput>;
};


export type QueryCountryArgs = {
  where?: InputMaybe<CountryFilterInput>;
};


export type QueryCurrenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CurrencyInfoSortInput>>;
  where?: InputMaybe<CurrencyInfoFilterInput>;
};


export type QueryCurrencyArgs = {
  where?: InputMaybe<CurrencyInfoFilterInput>;
};


export type QueryExpenseArgs = {
  where?: InputMaybe<ExpenseFilterInput>;
};


export type QueryExpensesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ExpenseSortInput>>;
  where?: InputMaybe<ExpenseFilterInput>;
};


export type QueryMileageReimbursementRateArgs = {
  where?: InputMaybe<MileageReimbursementRateFilterInput>;
};


export type QueryMileageReimbursementRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MileageReimbursementRateSortInput>>;
  where?: InputMaybe<MileageReimbursementRateFilterInput>;
};


export type QueryNotificationsSentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<NotificationSentSortInput>>;
  where?: InputMaybe<NotificationSentFilterInput>;
};


export type QueryPatientDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PatientDataSortInput>>;
  where?: InputMaybe<PatientDataFilterInput>;
};


export type QueryPatientDatumArgs = {
  where?: InputMaybe<PatientDataFilterInput>;
};


export type QueryPatientPaymentDetailArgs = {
  where?: InputMaybe<PatientDataFilterInput>;
};


export type QueryPatientPaymentDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PatientDataSortInput>>;
  where?: InputMaybe<PatientDataFilterInput>;
};


export type QueryPatientPortalAccessRequestByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPatientStatusArgs = {
  where?: InputMaybe<PatientStatusFilterInput>;
};


export type QueryPatientStatusesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PatientStatusSortInput>>;
  where?: InputMaybe<PatientStatusFilterInput>;
};


export type QueryPatientUserArgs = {
  where?: InputMaybe<PatientUserFilterInput>;
};


export type QueryPatientUserFcmTokenArgs = {
  where?: InputMaybe<PatientUserFcmTokenFilterInput>;
};


export type QueryPatientUserFcmTokensArgs = {
  where?: InputMaybe<PatientUserFcmTokenFilterInput>;
};


export type QueryPatientUserNotificationArgs = {
  where?: InputMaybe<PatientUserNotificationFilterInput>;
};


export type QueryPatientUserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PatientUserNotificationSortInput>>;
  where?: InputMaybe<PatientUserNotificationFilterInput>;
};


export type QueryReimbursementRequestArgs = {
  where?: InputMaybe<ReimbursementRequestFilterInput>;
};


export type QueryReimbursementRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReimbursementRequestSortInput>>;
  where?: InputMaybe<ReimbursementRequestFilterInput>;
};


export type QuerySitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SiteSortInput>>;
  where?: InputMaybe<SiteFilterInput>;
};


export type QueryStipendRequestArgs = {
  where?: InputMaybe<StipendRequestFilterInput>;
};


export type QueryStipendRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<StipendRequestSortInput>>;
  where?: InputMaybe<StipendRequestFilterInput>;
};


export type QueryStudiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<StudySortInput>>;
  where?: InputMaybe<StudyFilterInput>;
};


export type QueryStudyArgs = {
  where?: InputMaybe<StudyFilterInput>;
};


export type QueryStudyActiveExpensesArgs = {
  studyId: Scalars['Int']['input'];
  where?: InputMaybe<ActiveStudyExpensesFilterInput>;
};


export type QueryStudyExpenseArgs = {
  where?: InputMaybe<StudyExpenseFilterInput>;
};


export type QueryStudyExpensesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<StudyExpenseSortInput>>;
  where?: InputMaybe<StudyExpenseFilterInput>;
};


export type QueryTravelRequestArgs = {
  where?: InputMaybe<TravelRequestFilterInput>;
};


export type QueryTravelRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TravelRequestSortInput>>;
  where?: InputMaybe<TravelRequestFilterInput>;
};


export type QueryVisitNameArgs = {
  where?: InputMaybe<VisitNameFilterInput>;
};


export type QueryVisitNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VisitNameSortInput>>;
  where?: InputMaybe<VisitNameFilterInput>;
};

export type RefreshTokenFilterInput = {
  and?: InputMaybe<Array<RefreshTokenFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  expiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RefreshTokenFilterInput>>;
  patientUser?: InputMaybe<PatientUserFilterInput>;
};

export type RefreshTokenFromBodyInput = {
  refreshToken: Scalars['String']['input'];
};

export type RefreshTokenFromBodyPayload = {
  authResult?: Maybe<AuthResult>;
};

export type RefreshTokenFromCookiePayload = {
  authResult?: Maybe<AuthResult>;
};

export type RefreshTokenSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  expiresAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  patientUser?: InputMaybe<PatientUserSortInput>;
};

export type RegisterPatientInput = {
  accessRequestId: Scalars['UUID']['input'];
  appLanguage: Scalars['String']['input'];
  dateOfBirth: Scalars['Date']['input'];
  password: Scalars['String']['input'];
};

export type RegisterPatientPayload = {
  authResult?: Maybe<AuthResult>;
};

export type ReimbursementRequest = {
  additionalDetails?: Maybe<Scalars['String']['output']>;
  completedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  completingUserId?: Maybe<Scalars['Int']['output']>;
  completingUserName?: Maybe<Scalars['String']['output']>;
  createdTimestamp?: Maybe<Scalars['DateTime']['output']>;
  deducted?: Maybe<Scalars['Decimal']['output']>;
  deductedCurrency?: Maybe<Scalars['String']['output']>;
  deductedUsd?: Maybe<Scalars['Decimal']['output']>;
  erReportingPeriod?: Maybe<Scalars['String']['output']>;
  erTrackingId?: Maybe<Scalars['String']['output']>;
  flaggedDuplicate: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastEditTimestamp?: Maybe<Scalars['DateTime']['output']>;
  liasonInitials?: Maybe<Scalars['String']['output']>;
  merchant?: Maybe<Scalars['Int']['output']>;
  modifiedBy: Scalars['String']['output'];
  patient: Patient;
  patientId: Scalars['Int']['output'];
  reimbursementRequestApprovalStatusLog: Array<ReimbursementRequestApprovalStatusLog>;
  reimbursementTransaction: Array<ReimbursementTransaction>;
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  statusId: Scalars['Int']['output'];
  submittedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  submittingUserId?: Maybe<Scalars['Int']['output']>;
  submittingUserName?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Decimal']['output']>;
  totalAmountAuthorized?: Maybe<Scalars['Decimal']['output']>;
  totalCurrency?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['Date']['output']>;
  travelerInstructions?: Maybe<Scalars['String']['output']>;
  visitEndDate?: Maybe<Scalars['DateTime']['output']>;
  visitEndTime?: Maybe<Scalars['String']['output']>;
  visitName?: Maybe<VisitName>;
  visitNameId?: Maybe<Scalars['Int']['output']>;
  visitStartDate?: Maybe<Scalars['Date']['output']>;
  visitStartTime?: Maybe<Scalars['String']['output']>;
};

export type ReimbursementRequestApprovalStatusLog = {
  actionWasPerformedInPatientPortal: Scalars['Boolean']['output'];
  anonymized: Scalars['Boolean']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  request: ReimbursementRequest;
  requestApprovalStatusId: Scalars['Int']['output'];
  requestId: Scalars['Int']['output'];
  responsibleUserEmail: Scalars['String']['output'];
  responsibleUserName: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type ReimbursementRequestApprovalStatusLogFilterInput = {
  actionWasPerformedInPatientPortal?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ReimbursementRequestApprovalStatusLogFilterInput>>;
  anonymized?: InputMaybe<BooleanOperationFilterInput>;
  details?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ReimbursementRequestApprovalStatusLogFilterInput>>;
  request?: InputMaybe<ReimbursementRequestFilterInput>;
  requestApprovalStatusId?: InputMaybe<IntOperationFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  responsibleUserEmail?: InputMaybe<StringOperationFilterInput>;
  responsibleUserName?: InputMaybe<StringOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ReimbursementRequestDtoInput = {
  id: Scalars['Int']['input'];
  reimbursementTransaction: Array<ReimbursementTransactionDtoInput>;
  totalCurrency: Scalars['String']['input'];
  visitNameId?: InputMaybe<Scalars['Int']['input']>;
  visitStartDate: Scalars['Date']['input'];
};

export type ReimbursementRequestFilterInput = {
  additionalDetails?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ReimbursementRequestFilterInput>>;
  completedTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  completingUserId?: InputMaybe<IntOperationFilterInput>;
  completingUserName?: InputMaybe<StringOperationFilterInput>;
  createdTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  deducted?: InputMaybe<DecimalOperationFilterInput>;
  deductedCurrency?: InputMaybe<StringOperationFilterInput>;
  deductedUsd?: InputMaybe<DecimalOperationFilterInput>;
  erReportingPeriod?: InputMaybe<StringOperationFilterInput>;
  erTrackingId?: InputMaybe<StringOperationFilterInput>;
  flaggedDuplicate?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastEditTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  liasonInitials?: InputMaybe<StringOperationFilterInput>;
  merchant?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReimbursementRequestFilterInput>>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  reimbursementRequestApprovalStatusLog?: InputMaybe<ListFilterInputTypeOfReimbursementRequestApprovalStatusLogFilterInput>;
  reimbursementTransaction?: InputMaybe<ListFilterInputTypeOfReimbursementTransactionFilterInput>;
  statusChangedAt?: InputMaybe<DateTimeOperationFilterInput>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  submittedTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  submittingUserId?: InputMaybe<IntOperationFilterInput>;
  submittingUserName?: InputMaybe<StringOperationFilterInput>;
  totalAmount?: InputMaybe<DecimalOperationFilterInput>;
  totalAmountAuthorized?: InputMaybe<DecimalOperationFilterInput>;
  totalCurrency?: InputMaybe<StringOperationFilterInput>;
  transactionDate?: InputMaybe<DateOperationFilterInput>;
  travelerInstructions?: InputMaybe<StringOperationFilterInput>;
  visitEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  visitEndTime?: InputMaybe<StringOperationFilterInput>;
  visitName?: InputMaybe<VisitNameFilterInput>;
  visitNameId?: InputMaybe<IntOperationFilterInput>;
  visitStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  visitStartTime?: InputMaybe<StringOperationFilterInput>;
};

export type ReimbursementRequestSortInput = {
  additionalDetails?: InputMaybe<SortEnumType>;
  completedTimestamp?: InputMaybe<SortEnumType>;
  completingUserId?: InputMaybe<SortEnumType>;
  completingUserName?: InputMaybe<SortEnumType>;
  createdTimestamp?: InputMaybe<SortEnumType>;
  deducted?: InputMaybe<SortEnumType>;
  deductedCurrency?: InputMaybe<SortEnumType>;
  deductedUsd?: InputMaybe<SortEnumType>;
  erReportingPeriod?: InputMaybe<SortEnumType>;
  erTrackingId?: InputMaybe<SortEnumType>;
  flaggedDuplicate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastEditTimestamp?: InputMaybe<SortEnumType>;
  liasonInitials?: InputMaybe<SortEnumType>;
  merchant?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  statusChangedAt?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
  submittedTimestamp?: InputMaybe<SortEnumType>;
  submittingUserId?: InputMaybe<SortEnumType>;
  submittingUserName?: InputMaybe<SortEnumType>;
  totalAmount?: InputMaybe<SortEnumType>;
  totalAmountAuthorized?: InputMaybe<SortEnumType>;
  totalCurrency?: InputMaybe<SortEnumType>;
  transactionDate?: InputMaybe<SortEnumType>;
  travelerInstructions?: InputMaybe<SortEnumType>;
  visitEndDate?: InputMaybe<SortEnumType>;
  visitEndTime?: InputMaybe<SortEnumType>;
  visitName?: InputMaybe<VisitNameSortInput>;
  visitNameId?: InputMaybe<SortEnumType>;
  visitStartDate?: InputMaybe<SortEnumType>;
  visitStartTime?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ReimbursementRequestsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ReimbursementRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReimbursementRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReimbursementRequestsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReimbursementRequest;
};

export type ReimbursementTransaction = {
  amount: Scalars['Decimal']['output'];
  authorizedAmount?: Maybe<Scalars['Decimal']['output']>;
  authorizedAmountUsd?: Maybe<Scalars['Decimal']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  expense?: Maybe<Expense>;
  expenseId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isIncomplete: Scalars['Boolean']['output'];
  manualTotalCalculation: Scalars['Boolean']['output'];
  mileageComments?: Maybe<Scalars['String']['output']>;
  mileageDistanceUnits?: Maybe<Scalars['String']['output']>;
  mileageEndLocation?: Maybe<Scalars['String']['output']>;
  mileageReimbursementCountry?: Maybe<Scalars['String']['output']>;
  mileageReimbursementRatePerUnit?: Maybe<Scalars['Float']['output']>;
  mileageStartLocation?: Maybe<Scalars['String']['output']>;
  mileageTotalDistance?: Maybe<Scalars['Decimal']['output']>;
  modifiedBy: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  request: ReimbursementRequest;
  requestId: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
  transactionAttachmentInfo?: Maybe<TransactionAttachmentInfo>;
  transactionAttachmentInfoId?: Maybe<Scalars['Int']['output']>;
};

export type ReimbursementTransactionDtoInput = {
  amount: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
  expenseId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isIncomplete: Scalars['Boolean']['input'];
  manualTotalCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  mileageComments?: InputMaybe<Scalars['String']['input']>;
  mileageDistanceUnits?: InputMaybe<Scalars['String']['input']>;
  mileageEndLocation?: InputMaybe<Scalars['String']['input']>;
  mileageReimbursementCountry?: InputMaybe<Scalars['String']['input']>;
  mileageReimbursementRatePerUnit?: InputMaybe<Scalars['String']['input']>;
  mileageStartLocation?: InputMaybe<Scalars['String']['input']>;
  mileageTotalDistance?: InputMaybe<Scalars['Decimal']['input']>;
  requestId: Scalars['Int']['input'];
  timestamp: Scalars['Date']['input'];
};

export type ReimbursementTransactionFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<ReimbursementTransactionFilterInput>>;
  authorizedAmount?: InputMaybe<DecimalOperationFilterInput>;
  authorizedAmountUsd?: InputMaybe<DecimalOperationFilterInput>;
  category?: InputMaybe<StringOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  expense?: InputMaybe<ExpenseFilterInput>;
  expenseId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isIncomplete?: InputMaybe<BooleanOperationFilterInput>;
  manualTotalCalculation?: InputMaybe<BooleanOperationFilterInput>;
  mileageComments?: InputMaybe<StringOperationFilterInput>;
  mileageDistanceUnits?: InputMaybe<StringOperationFilterInput>;
  mileageEndLocation?: InputMaybe<StringOperationFilterInput>;
  mileageReimbursementCountry?: InputMaybe<StringOperationFilterInput>;
  mileageReimbursementRatePerUnit?: InputMaybe<DecimalOperationFilterInput>;
  mileageStartLocation?: InputMaybe<StringOperationFilterInput>;
  mileageTotalDistance?: InputMaybe<DecimalOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReimbursementTransactionFilterInput>>;
  request?: InputMaybe<ReimbursementRequestFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
  transactionAttachmentInfo?: InputMaybe<TransactionAttachmentInfoFilterInput>;
  transactionAttachmentInfoId?: InputMaybe<IntOperationFilterInput>;
};

export type RemovePatientFcmTokenInput = {
  deviceId: Scalars['String']['input'];
};

export type RemovePatientFcmTokenPayload = {
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetPasswordInput = {
  email: Scalars['String']['input'];
};

export type ResetPasswordPayload = {
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveDraftReimbursementRequestInput = {
  dto: ReimbursementRequestDtoInput;
};

export type SaveDraftReimbursementRequestPayload = {
  reimbursementRequest?: Maybe<ReimbursementRequest>;
};

export type SaveDraftTravelRequestInput = {
  dto: TravelRequestModelInput;
};

export type SaveDraftTravelRequestPayload = {
  travelRequest?: Maybe<TravelRequest>;
};

export type SavePatientUserFcmTokenInput = {
  patientUserFcmTokenDto: PatientUserFcmTokenDtoInput;
};

export type SavePatientUserFcmTokenPayload = {
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type SetPatientUserNotificationDefaultsPayload = {
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type SetPatientUserNotificationsInput = {
  updatedNotifications: Array<PatientUserNotificationDtoInput>;
};

export type SetPatientUserNotificationsPayload = {
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ShortOperationFilterInput = {
  eq?: InputMaybe<Scalars['Short']['input']>;
  gt?: InputMaybe<Scalars['Short']['input']>;
  gte?: InputMaybe<Scalars['Short']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Short']['input']>>>;
  lt?: InputMaybe<Scalars['Short']['input']>;
  lte?: InputMaybe<Scalars['Short']['input']>;
  neq?: InputMaybe<Scalars['Short']['input']>;
  ngt?: InputMaybe<Scalars['Short']['input']>;
  ngte?: InputMaybe<Scalars['Short']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Short']['input']>>>;
  nlt?: InputMaybe<Scalars['Short']['input']>;
  nlte?: InputMaybe<Scalars['Short']['input']>;
};

export type Site = {
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  allowPpinvitations?: Maybe<Scalars['Boolean']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutionName: Scalars['String']['output'];
  isReviewedByCrc: Scalars['Boolean']['output'];
  isShippingAddressSameAsPrimary: Scalars['Boolean']['output'];
  lastReminderDate?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy: Scalars['String']['output'];
  patient: Array<Patient>;
  paymentPayQuicker: Scalars['Boolean']['output'];
  pilastName: Scalars['String']['output'];
  preRegisteredDate?: Maybe<Scalars['DateTime']['output']>;
  primaryCrcEmailToInvite?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  reimbursementSupport: Scalars['Boolean']['output'];
  shippingAddress1?: Maybe<Scalars['String']['output']>;
  shippingAddress2?: Maybe<Scalars['String']['output']>;
  shippingCity?: Maybe<Scalars['String']['output']>;
  shippingCountry?: Maybe<Scalars['String']['output']>;
  shippingRegion?: Maybe<Scalars['String']['output']>;
  shippingState?: Maybe<Scalars['String']['output']>;
  shippingZipcode?: Maybe<Scalars['String']['output']>;
  siteNumber: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['Int']['output'];
  stipendSupport: Scalars['Boolean']['output'];
  study: Study;
  studyId: Scalars['Int']['output'];
  travelServiceSupport: Scalars['Boolean']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type SiteFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  allowPpinvitations?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<SiteFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  institutionName?: InputMaybe<StringOperationFilterInput>;
  isReviewedByCrc?: InputMaybe<BooleanOperationFilterInput>;
  isShippingAddressSameAsPrimary?: InputMaybe<BooleanOperationFilterInput>;
  lastReminderDate?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteFilterInput>>;
  patient?: InputMaybe<ListFilterInputTypeOfPatientFilterInput>;
  paymentPayQuicker?: InputMaybe<BooleanOperationFilterInput>;
  pilastName?: InputMaybe<StringOperationFilterInput>;
  preRegisteredDate?: InputMaybe<DateTimeOperationFilterInput>;
  primaryCrcEmailToInvite?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  reimbursementSupport?: InputMaybe<BooleanOperationFilterInput>;
  shippingAddress1?: InputMaybe<StringOperationFilterInput>;
  shippingAddress2?: InputMaybe<StringOperationFilterInput>;
  shippingCity?: InputMaybe<StringOperationFilterInput>;
  shippingCountry?: InputMaybe<StringOperationFilterInput>;
  shippingRegion?: InputMaybe<StringOperationFilterInput>;
  shippingState?: InputMaybe<StringOperationFilterInput>;
  shippingZipcode?: InputMaybe<StringOperationFilterInput>;
  siteNumber?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  stipendSupport?: InputMaybe<BooleanOperationFilterInput>;
  study?: InputMaybe<StudyFilterInput>;
  studyId?: InputMaybe<IntOperationFilterInput>;
  travelServiceSupport?: InputMaybe<BooleanOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type SiteSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  allowPpinvitations?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  institutionName?: InputMaybe<SortEnumType>;
  isReviewedByCrc?: InputMaybe<SortEnumType>;
  isShippingAddressSameAsPrimary?: InputMaybe<SortEnumType>;
  lastReminderDate?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  paymentPayQuicker?: InputMaybe<SortEnumType>;
  pilastName?: InputMaybe<SortEnumType>;
  preRegisteredDate?: InputMaybe<SortEnumType>;
  primaryCrcEmailToInvite?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  reimbursementSupport?: InputMaybe<SortEnumType>;
  shippingAddress1?: InputMaybe<SortEnumType>;
  shippingAddress2?: InputMaybe<SortEnumType>;
  shippingCity?: InputMaybe<SortEnumType>;
  shippingCountry?: InputMaybe<SortEnumType>;
  shippingRegion?: InputMaybe<SortEnumType>;
  shippingState?: InputMaybe<SortEnumType>;
  shippingZipcode?: InputMaybe<SortEnumType>;
  siteNumber?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
  stipendSupport?: InputMaybe<SortEnumType>;
  study?: InputMaybe<StudySortInput>;
  studyId?: InputMaybe<SortEnumType>;
  travelServiceSupport?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SitesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<SitesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Site>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SitesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Site;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StipendRequest = {
  additionalDetails?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Decimal']['output']>;
  authorizedAmount?: Maybe<Scalars['Decimal']['output']>;
  authorizedAmountUsd?: Maybe<Scalars['Decimal']['output']>;
  completingUserId?: Maybe<Scalars['Int']['output']>;
  createdTimestamp?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deducted?: Maybe<Scalars['Decimal']['output']>;
  deductedCurrency?: Maybe<Scalars['String']['output']>;
  deductedUsd?: Maybe<Scalars['Decimal']['output']>;
  erReportingPeriod?: Maybe<Scalars['String']['output']>;
  erTrackingId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchant?: Maybe<Scalars['Int']['output']>;
  modifiedBy: Scalars['String']['output'];
  patient: Patient;
  patientId: Scalars['Int']['output'];
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  statusId: Scalars['Int']['output'];
  travelerInstructions?: Maybe<Scalars['String']['output']>;
  visitName?: Maybe<VisitName>;
  visitNameId?: Maybe<Scalars['Int']['output']>;
  visitStartDate?: Maybe<Scalars['Date']['output']>;
  visitStartTime?: Maybe<Scalars['String']['output']>;
};

export type StipendRequestFilterInput = {
  additionalDetails?: InputMaybe<StringOperationFilterInput>;
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<StipendRequestFilterInput>>;
  authorizedAmount?: InputMaybe<DecimalOperationFilterInput>;
  authorizedAmountUsd?: InputMaybe<DecimalOperationFilterInput>;
  completingUserId?: InputMaybe<IntOperationFilterInput>;
  createdTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  deducted?: InputMaybe<DecimalOperationFilterInput>;
  deductedCurrency?: InputMaybe<StringOperationFilterInput>;
  deductedUsd?: InputMaybe<DecimalOperationFilterInput>;
  erReportingPeriod?: InputMaybe<StringOperationFilterInput>;
  erTrackingId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  merchant?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StipendRequestFilterInput>>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  statusChangedAt?: InputMaybe<DateTimeOperationFilterInput>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  travelerInstructions?: InputMaybe<StringOperationFilterInput>;
  visitName?: InputMaybe<VisitNameFilterInput>;
  visitNameId?: InputMaybe<IntOperationFilterInput>;
  visitStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  visitStartTime?: InputMaybe<StringOperationFilterInput>;
};

export type StipendRequestSortInput = {
  additionalDetails?: InputMaybe<SortEnumType>;
  amount?: InputMaybe<SortEnumType>;
  authorizedAmount?: InputMaybe<SortEnumType>;
  authorizedAmountUsd?: InputMaybe<SortEnumType>;
  completingUserId?: InputMaybe<SortEnumType>;
  createdTimestamp?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  deducted?: InputMaybe<SortEnumType>;
  deductedCurrency?: InputMaybe<SortEnumType>;
  deductedUsd?: InputMaybe<SortEnumType>;
  erReportingPeriod?: InputMaybe<SortEnumType>;
  erTrackingId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  merchant?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  statusChangedAt?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
  travelerInstructions?: InputMaybe<SortEnumType>;
  visitName?: InputMaybe<VisitNameSortInput>;
  visitNameId?: InputMaybe<SortEnumType>;
  visitStartDate?: InputMaybe<SortEnumType>;
  visitStartTime?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type StipendRequestsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<StipendRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<StipendRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StipendRequestsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: StipendRequest;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type StudiesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<StudiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Study>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StudiesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Study;
};

export type Study = {
  code: Scalars['String']['output'];
  hasMultipleVisitSchedules: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isApproved: Scalars['Boolean']['output'];
  isFromClinTrak: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  protocol: Scalars['String']['output'];
  site: Array<Site>;
  sponsor: Scalars['String']['output'];
  studyExpense: Array<StudyExpense>;
  studyLogoInfo?: Maybe<StudyLogoInfo>;
  studyLogoInfoId?: Maybe<Scalars['Int']['output']>;
  studyTravelOption: Array<StudyTravelOption>;
  supportTierId: Scalars['Int']['output'];
  visitName: Array<VisitName>;
};

export type StudyExpense = {
  expense: Expense;
  expenseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  modifiedBy: Scalars['String']['output'];
  study: Study;
  studyId: Scalars['Int']['output'];
};

export type StudyExpenseFilterInput = {
  and?: InputMaybe<Array<StudyExpenseFilterInput>>;
  expense?: InputMaybe<ExpenseFilterInput>;
  expenseId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StudyExpenseFilterInput>>;
  study?: InputMaybe<StudyFilterInput>;
  studyId?: InputMaybe<IntOperationFilterInput>;
};

export type StudyExpenseSortInput = {
  expense?: InputMaybe<ExpenseSortInput>;
  expenseId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  study?: InputMaybe<StudySortInput>;
  studyId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type StudyExpensesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<StudyExpensesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<StudyExpense>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StudyExpensesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: StudyExpense;
};

export type StudyFilterInput = {
  and?: InputMaybe<Array<StudyFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  hasMultipleVisitSchedules?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isApproved?: InputMaybe<BooleanOperationFilterInput>;
  isFromClinTrak?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StudyFilterInput>>;
  protocol?: InputMaybe<StringOperationFilterInput>;
  site?: InputMaybe<ListFilterInputTypeOfSiteFilterInput>;
  sponsor?: InputMaybe<StringOperationFilterInput>;
  studyExpense?: InputMaybe<ListFilterInputTypeOfStudyExpenseFilterInput>;
  studyLogoInfo?: InputMaybe<StudyLogoInfoFilterInput>;
  studyLogoInfoId?: InputMaybe<IntOperationFilterInput>;
  studyTravelOption?: InputMaybe<ListFilterInputTypeOfStudyTravelOptionFilterInput>;
  supportTierId?: InputMaybe<IntOperationFilterInput>;
  visitName?: InputMaybe<ListFilterInputTypeOfVisitNameFilterInput>;
};

export type StudyLogoInfo = {
  contentType: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifiedBy: Scalars['String']['output'];
  study: Array<Study>;
  uniqueIdentifier: Scalars['String']['output'];
  uploadDate: Scalars['DateTime']['output'];
};

export type StudyLogoInfoFilterInput = {
  and?: InputMaybe<Array<StudyLogoInfoFilterInput>>;
  contentType?: InputMaybe<StringOperationFilterInput>;
  extension?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StudyLogoInfoFilterInput>>;
  study?: InputMaybe<ListFilterInputTypeOfStudyFilterInput>;
  uniqueIdentifier?: InputMaybe<StringOperationFilterInput>;
  uploadDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type StudyLogoInfoSortInput = {
  contentType?: InputMaybe<SortEnumType>;
  extension?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  uniqueIdentifier?: InputMaybe<SortEnumType>;
  uploadDate?: InputMaybe<SortEnumType>;
};

export type StudySortInput = {
  code?: InputMaybe<SortEnumType>;
  hasMultipleVisitSchedules?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isApproved?: InputMaybe<SortEnumType>;
  isFromClinTrak?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  protocol?: InputMaybe<SortEnumType>;
  sponsor?: InputMaybe<SortEnumType>;
  studyLogoInfo?: InputMaybe<StudyLogoInfoSortInput>;
  studyLogoInfoId?: InputMaybe<SortEnumType>;
  supportTierId?: InputMaybe<SortEnumType>;
};

export type StudyTravelOption = {
  modifiedBy: Scalars['String']['output'];
  study: Study;
  studyId: Scalars['Int']['output'];
  travelOption: TravelOption;
  travelOptionId: Scalars['Int']['output'];
};

export type StudyTravelOptionFilterInput = {
  and?: InputMaybe<Array<StudyTravelOptionFilterInput>>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StudyTravelOptionFilterInput>>;
  study?: InputMaybe<StudyFilterInput>;
  studyId?: InputMaybe<IntOperationFilterInput>;
  travelOption?: InputMaybe<TravelOptionFilterInput>;
  travelOptionId?: InputMaybe<IntOperationFilterInput>;
};

export type SubmitPatientEditRequestPayload = {
  successPatientEditRequestResponseDto?: Maybe<SuccessPatientEditRequestResponseDto>;
};

export type SubmitReimbursementRequestInput = {
  dto: ReimbursementRequestDtoInput;
};

export type SubmitReimbursementRequestPayload = {
  reimbursementRequest?: Maybe<ReimbursementRequest>;
};

export type SubmitTravelRequestInput = {
  dto: TravelRequestModelInput;
};

export type SubmitTravelRequestPayload = {
  travelRequest?: Maybe<TravelRequest>;
};

export type SuccessPatientEditRequestResponseDto = {
  saveSuccessful: Scalars['Boolean']['output'];
};

export type TransactionAttachmentInfo = {
  contentType: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifiedBy: Scalars['String']['output'];
  reimbursementTransaction: Array<ReimbursementTransaction>;
  uniqueIdentifier: Scalars['String']['output'];
  uploadDate: Scalars['DateTime']['output'];
};

export type TransactionAttachmentInfoFilterInput = {
  and?: InputMaybe<Array<TransactionAttachmentInfoFilterInput>>;
  contentType?: InputMaybe<StringOperationFilterInput>;
  extension?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TransactionAttachmentInfoFilterInput>>;
  reimbursementTransaction?: InputMaybe<ListFilterInputTypeOfReimbursementTransactionFilterInput>;
  uniqueIdentifier?: InputMaybe<StringOperationFilterInput>;
  uploadDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type TravelOption = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  studyTravelOption: Array<StudyTravelOption>;
};

export type TravelOptionFilterInput = {
  and?: InputMaybe<Array<TravelOptionFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelOptionFilterInput>>;
  studyTravelOption?: InputMaybe<ListFilterInputTypeOfStudyTravelOptionFilterInput>;
};

export type TravelRequest = {
  additionalDetails?: Maybe<Scalars['String']['output']>;
  approvalRequired?: Maybe<Scalars['Boolean']['output']>;
  carServiceAttachmentInfoId?: Maybe<Scalars['Int']['output']>;
  carServiceMerchant?: Maybe<Scalars['Int']['output']>;
  carServiceReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  carServiceRequests?: Maybe<Scalars['String']['output']>;
  carServiceRequired?: Maybe<Scalars['Boolean']['output']>;
  carServiceTransactionAmount?: Maybe<Scalars['Decimal']['output']>;
  carServiceTransactionCurrency?: Maybe<Scalars['String']['output']>;
  carServiceTransactionDate?: Maybe<Scalars['DateTime']['output']>;
  carServiceUsdExpense?: Maybe<Scalars['Decimal']['output']>;
  caregiver?: Maybe<Scalars['Boolean']['output']>;
  completedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  completingUserId?: Maybe<Scalars['Int']['output']>;
  completingUserName?: Maybe<Scalars['String']['output']>;
  createdTimestamp?: Maybe<Scalars['DateTime']['output']>;
  erReportingPeriod?: Maybe<Scalars['String']['output']>;
  erTrackingId?: Maybe<Scalars['String']['output']>;
  flightAttachmentInfoId?: Maybe<Scalars['Int']['output']>;
  flightMerchant?: Maybe<Scalars['Int']['output']>;
  flightReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  flightRequestDetails?: Maybe<TravelRequestFlightTravelDetails>;
  flightRequestDetailsId?: Maybe<Scalars['Int']['output']>;
  flightRequests?: Maybe<Scalars['String']['output']>;
  flightRequired?: Maybe<Scalars['Boolean']['output']>;
  flightTransactionAmount?: Maybe<Scalars['Decimal']['output']>;
  flightTransactionCurrency?: Maybe<Scalars['String']['output']>;
  flightTransactionDate?: Maybe<Scalars['DateTime']['output']>;
  flightUsdExpense?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  lastEditTimestamp?: Maybe<Scalars['DateTime']['output']>;
  lodgingAttachmentInfoId?: Maybe<Scalars['Int']['output']>;
  lodgingCheckInDate?: Maybe<Scalars['Date']['output']>;
  lodgingCheckOutDate?: Maybe<Scalars['Date']['output']>;
  lodgingDateRequired: Scalars['Boolean']['output'];
  lodgingMerchant?: Maybe<Scalars['Int']['output']>;
  lodgingReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  lodgingRequests?: Maybe<Scalars['String']['output']>;
  lodgingRequired?: Maybe<Scalars['Boolean']['output']>;
  lodgingTransactionAmount?: Maybe<Scalars['Decimal']['output']>;
  lodgingTransactionCurrency?: Maybe<Scalars['String']['output']>;
  lodgingTransactionDate?: Maybe<Scalars['DateTime']['output']>;
  lodgingUsdExpense?: Maybe<Scalars['Decimal']['output']>;
  modifiedBy: Scalars['String']['output'];
  otherAttachmentInfoId?: Maybe<Scalars['Int']['output']>;
  otherMerchant?: Maybe<Scalars['Int']['output']>;
  otherReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  otherRequests?: Maybe<Scalars['String']['output']>;
  otherServiceRequired?: Maybe<Scalars['Boolean']['output']>;
  otherTransactionAmount?: Maybe<Scalars['Decimal']['output']>;
  otherTransactionCurrency?: Maybe<Scalars['String']['output']>;
  otherTransactionDate?: Maybe<Scalars['DateTime']['output']>;
  otherUsdExpense?: Maybe<Scalars['Decimal']['output']>;
  patient: Patient;
  patientId: Scalars['Int']['output'];
  rentalCarAttachmentInfoId?: Maybe<Scalars['Int']['output']>;
  rentalCarCountry?: Maybe<Scalars['String']['output']>;
  rentalCarDropOffDate?: Maybe<Scalars['Date']['output']>;
  rentalCarDropOffTime?: Maybe<Scalars['String']['output']>;
  rentalCarLocation?: Maybe<Scalars['String']['output']>;
  rentalCarMerchant?: Maybe<Scalars['Int']['output']>;
  rentalCarPickUpDate?: Maybe<Scalars['Date']['output']>;
  rentalCarPickUpTime?: Maybe<Scalars['String']['output']>;
  rentalCarReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  rentalCarRequests?: Maybe<Scalars['String']['output']>;
  rentalCarRequired: Scalars['Boolean']['output'];
  rentalCarTransactionAmount?: Maybe<Scalars['Decimal']['output']>;
  rentalCarTransactionCurrency?: Maybe<Scalars['String']['output']>;
  rentalCarTransactionDate?: Maybe<Scalars['DateTime']['output']>;
  rentalCarUsdExpense?: Maybe<Scalars['Decimal']['output']>;
  rentalCarUseFlightDate?: Maybe<Scalars['Boolean']['output']>;
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  statusId: Scalars['Int']['output'];
  submittedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  submittingUserId?: Maybe<Scalars['Int']['output']>;
  submittingUserName?: Maybe<Scalars['String']['output']>;
  trainAttachmentInfoId?: Maybe<Scalars['Int']['output']>;
  trainMerchant?: Maybe<Scalars['Int']['output']>;
  trainReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  trainRequests?: Maybe<Scalars['String']['output']>;
  trainRequired?: Maybe<Scalars['Boolean']['output']>;
  trainTransactionAmount?: Maybe<Scalars['Decimal']['output']>;
  trainTransactionCurrency?: Maybe<Scalars['String']['output']>;
  trainTransactionDate?: Maybe<Scalars['DateTime']['output']>;
  trainTravelDetailsForPatient?: Maybe<TravelRequestTrainTravelDetails>;
  trainTravelDetailsForPatientId?: Maybe<Scalars['Int']['output']>;
  trainUsdExpense?: Maybe<Scalars['Decimal']['output']>;
  travelRequestApprovalStatusLog: Array<TravelRequestApprovalStatusLog>;
  travelRequestCaregiver: Array<TravelRequestCaregiver>;
  travelRequestTransferData: Array<TravelRequestTransferData>;
  travelRestrictions?: Maybe<Scalars['String']['output']>;
  travelTransaction: Array<TravelTransaction>;
  travelerInstructions?: Maybe<Scalars['String']['output']>;
  visitEndDate?: Maybe<Scalars['DateTime']['output']>;
  visitEndTime?: Maybe<Scalars['String']['output']>;
  visitName?: Maybe<VisitName>;
  visitNameId?: Maybe<Scalars['Int']['output']>;
  visitStartDate?: Maybe<Scalars['Date']['output']>;
  visitStartTime?: Maybe<Scalars['String']['output']>;
};

export type TravelRequestApprovalStatusLog = {
  actionWasPerformedInPatientPortal: Scalars['Boolean']['output'];
  anonymized: Scalars['Boolean']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  request: TravelRequest;
  requestApprovalStatusId: Scalars['Int']['output'];
  requestId: Scalars['Int']['output'];
  responsibleUserEmail: Scalars['String']['output'];
  responsibleUserName: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type TravelRequestApprovalStatusLogFilterInput = {
  actionWasPerformedInPatientPortal?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TravelRequestApprovalStatusLogFilterInput>>;
  anonymized?: InputMaybe<BooleanOperationFilterInput>;
  details?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<TravelRequestApprovalStatusLogFilterInput>>;
  request?: InputMaybe<TravelRequestFilterInput>;
  requestApprovalStatusId?: InputMaybe<IntOperationFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  responsibleUserEmail?: InputMaybe<StringOperationFilterInput>;
  responsibleUserName?: InputMaybe<StringOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
};

export type TravelRequestCaregiver = {
  caregiver: Caregiver;
  caregiverId: Scalars['Int']['output'];
  caregiverName: Scalars['String']['output'];
  createdTimestamp: Scalars['DateTime']['output'];
  flightRequestDetails?: Maybe<TravelRequestFlightTravelDetails>;
  flightRequestDetailsId?: Maybe<Scalars['Int']['output']>;
  flightRequestTheSameAsPatient: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  trainRequestDetails?: Maybe<TravelRequestTrainTravelDetails>;
  trainRequestDetailsId?: Maybe<Scalars['Int']['output']>;
  trainRequestTheSameAsPatient?: Maybe<Scalars['Boolean']['output']>;
  travelRequest: TravelRequest;
  travelRequestId: Scalars['Int']['output'];
};

export type TravelRequestCaregiverFilterInput = {
  and?: InputMaybe<Array<TravelRequestCaregiverFilterInput>>;
  caregiver?: InputMaybe<CaregiverFilterInput>;
  caregiverId?: InputMaybe<IntOperationFilterInput>;
  caregiverName?: InputMaybe<StringOperationFilterInput>;
  createdTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  flightRequestDetails?: InputMaybe<TravelRequestFlightTravelDetailsFilterInput>;
  flightRequestDetailsId?: InputMaybe<IntOperationFilterInput>;
  flightRequestTheSameAsPatient?: InputMaybe<BooleanOperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelRequestCaregiverFilterInput>>;
  trainRequestDetails?: InputMaybe<TravelRequestTrainTravelDetailsFilterInput>;
  trainRequestDetailsId?: InputMaybe<IntOperationFilterInput>;
  trainRequestTheSameAsPatient?: InputMaybe<BooleanOperationFilterInput>;
  travelRequest?: InputMaybe<TravelRequestFilterInput>;
  travelRequestId?: InputMaybe<IntOperationFilterInput>;
};

export type TravelRequestCaregiverModelInput = {
  caregiverId: Scalars['Int']['input'];
  caregiverName: Scalars['String']['input'];
  flightRequestDetails?: InputMaybe<TravelRequestFlightTravelDetailsModelInput>;
  flightRequestDetailsId?: InputMaybe<Scalars['Int']['input']>;
  flightRequestTheSameAsPatient: Scalars['Boolean']['input'];
  isPrimary: Scalars['Boolean']['input'];
  trainRequestDetails?: InputMaybe<TravelRequestTrainTravelDetailsModelInput>;
  trainRequestDetailsId?: InputMaybe<Scalars['Int']['input']>;
  trainRequestTheSameAsPatient?: InputMaybe<Scalars['Boolean']['input']>;
  travelRequestId: Scalars['Int']['input'];
};

export type TravelRequestFilterInput = {
  additionalDetails?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<TravelRequestFilterInput>>;
  approvalRequired?: InputMaybe<BooleanOperationFilterInput>;
  carServiceAttachmentInfoId?: InputMaybe<IntOperationFilterInput>;
  carServiceMerchant?: InputMaybe<IntOperationFilterInput>;
  carServiceReceiptDate?: InputMaybe<DateTimeOperationFilterInput>;
  carServiceRequests?: InputMaybe<StringOperationFilterInput>;
  carServiceRequired?: InputMaybe<BooleanOperationFilterInput>;
  carServiceTransactionAmount?: InputMaybe<DecimalOperationFilterInput>;
  carServiceTransactionCurrency?: InputMaybe<StringOperationFilterInput>;
  carServiceTransactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  carServiceUsdExpense?: InputMaybe<DecimalOperationFilterInput>;
  caregiver?: InputMaybe<BooleanOperationFilterInput>;
  completedTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  completingUserId?: InputMaybe<IntOperationFilterInput>;
  completingUserName?: InputMaybe<StringOperationFilterInput>;
  createdTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  erReportingPeriod?: InputMaybe<StringOperationFilterInput>;
  erTrackingId?: InputMaybe<StringOperationFilterInput>;
  flightAttachmentInfoId?: InputMaybe<IntOperationFilterInput>;
  flightMerchant?: InputMaybe<IntOperationFilterInput>;
  flightReceiptDate?: InputMaybe<DateTimeOperationFilterInput>;
  flightRequestDetails?: InputMaybe<TravelRequestFlightTravelDetailsFilterInput>;
  flightRequestDetailsId?: InputMaybe<IntOperationFilterInput>;
  flightRequests?: InputMaybe<StringOperationFilterInput>;
  flightRequired?: InputMaybe<BooleanOperationFilterInput>;
  flightTransactionAmount?: InputMaybe<DecimalOperationFilterInput>;
  flightTransactionCurrency?: InputMaybe<StringOperationFilterInput>;
  flightTransactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  flightUsdExpense?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastEditTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  lodgingAttachmentInfoId?: InputMaybe<IntOperationFilterInput>;
  lodgingCheckInDate?: InputMaybe<DateOperationFilterInput>;
  lodgingCheckOutDate?: InputMaybe<DateOperationFilterInput>;
  lodgingDateRequired?: InputMaybe<BooleanOperationFilterInput>;
  lodgingMerchant?: InputMaybe<IntOperationFilterInput>;
  lodgingReceiptDate?: InputMaybe<DateTimeOperationFilterInput>;
  lodgingRequests?: InputMaybe<StringOperationFilterInput>;
  lodgingRequired?: InputMaybe<BooleanOperationFilterInput>;
  lodgingTransactionAmount?: InputMaybe<DecimalOperationFilterInput>;
  lodgingTransactionCurrency?: InputMaybe<StringOperationFilterInput>;
  lodgingTransactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  lodgingUsdExpense?: InputMaybe<DecimalOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelRequestFilterInput>>;
  otherAttachmentInfoId?: InputMaybe<IntOperationFilterInput>;
  otherMerchant?: InputMaybe<IntOperationFilterInput>;
  otherReceiptDate?: InputMaybe<DateTimeOperationFilterInput>;
  otherRequests?: InputMaybe<StringOperationFilterInput>;
  otherServiceRequired?: InputMaybe<BooleanOperationFilterInput>;
  otherTransactionAmount?: InputMaybe<DecimalOperationFilterInput>;
  otherTransactionCurrency?: InputMaybe<StringOperationFilterInput>;
  otherTransactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  otherUsdExpense?: InputMaybe<DecimalOperationFilterInput>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  rentalCarAttachmentInfoId?: InputMaybe<IntOperationFilterInput>;
  rentalCarCountry?: InputMaybe<StringOperationFilterInput>;
  rentalCarDropOffDate?: InputMaybe<DateOperationFilterInput>;
  rentalCarDropOffTime?: InputMaybe<StringOperationFilterInput>;
  rentalCarLocation?: InputMaybe<StringOperationFilterInput>;
  rentalCarMerchant?: InputMaybe<IntOperationFilterInput>;
  rentalCarPickUpDate?: InputMaybe<DateOperationFilterInput>;
  rentalCarPickUpTime?: InputMaybe<StringOperationFilterInput>;
  rentalCarReceiptDate?: InputMaybe<DateTimeOperationFilterInput>;
  rentalCarRequests?: InputMaybe<StringOperationFilterInput>;
  rentalCarRequired?: InputMaybe<BooleanOperationFilterInput>;
  rentalCarTransactionAmount?: InputMaybe<DecimalOperationFilterInput>;
  rentalCarTransactionCurrency?: InputMaybe<StringOperationFilterInput>;
  rentalCarTransactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  rentalCarUsdExpense?: InputMaybe<DecimalOperationFilterInput>;
  rentalCarUseFlightDate?: InputMaybe<BooleanOperationFilterInput>;
  statusChangedAt?: InputMaybe<DateTimeOperationFilterInput>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  submittedTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  submittingUserId?: InputMaybe<IntOperationFilterInput>;
  submittingUserName?: InputMaybe<StringOperationFilterInput>;
  trainAttachmentInfoId?: InputMaybe<IntOperationFilterInput>;
  trainMerchant?: InputMaybe<IntOperationFilterInput>;
  trainReceiptDate?: InputMaybe<DateTimeOperationFilterInput>;
  trainRequests?: InputMaybe<StringOperationFilterInput>;
  trainRequired?: InputMaybe<BooleanOperationFilterInput>;
  trainTransactionAmount?: InputMaybe<DecimalOperationFilterInput>;
  trainTransactionCurrency?: InputMaybe<StringOperationFilterInput>;
  trainTransactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  trainTravelDetailsForPatient?: InputMaybe<TravelRequestTrainTravelDetailsFilterInput>;
  trainTravelDetailsForPatientId?: InputMaybe<IntOperationFilterInput>;
  trainUsdExpense?: InputMaybe<DecimalOperationFilterInput>;
  travelRequestApprovalStatusLog?: InputMaybe<ListFilterInputTypeOfTravelRequestApprovalStatusLogFilterInput>;
  travelRequestCaregiver?: InputMaybe<ListFilterInputTypeOfTravelRequestCaregiverFilterInput>;
  travelRequestTransferData?: InputMaybe<ListFilterInputTypeOfTravelRequestTransferDataFilterInput>;
  travelRestrictions?: InputMaybe<StringOperationFilterInput>;
  travelTransaction?: InputMaybe<ListFilterInputTypeOfTravelTransactionFilterInput>;
  travelerInstructions?: InputMaybe<StringOperationFilterInput>;
  visitEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  visitEndTime?: InputMaybe<StringOperationFilterInput>;
  visitName?: InputMaybe<VisitNameFilterInput>;
  visitNameId?: InputMaybe<IntOperationFilterInput>;
  visitStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  visitStartTime?: InputMaybe<StringOperationFilterInput>;
};

export type TravelRequestFlightTravelDetails = {
  airportDestination?: Maybe<Scalars['String']['output']>;
  airportOrigin: Scalars['String']['output'];
  departureDate: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  modifiedBy: Scalars['String']['output'];
  returnDate?: Maybe<Scalars['Date']['output']>;
  specialRequests?: Maybe<Scalars['String']['output']>;
  travelRequest: Array<TravelRequest>;
  travelRequestCaregiver: Array<TravelRequestCaregiver>;
  travelType: Scalars['Byte']['output'];
};

export type TravelRequestFlightTravelDetailsFilterInput = {
  airportDestination?: InputMaybe<StringOperationFilterInput>;
  airportOrigin?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<TravelRequestFlightTravelDetailsFilterInput>>;
  departureDate?: InputMaybe<DateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelRequestFlightTravelDetailsFilterInput>>;
  returnDate?: InputMaybe<DateOperationFilterInput>;
  specialRequests?: InputMaybe<StringOperationFilterInput>;
  travelRequest?: InputMaybe<ListFilterInputTypeOfTravelRequestFilterInput>;
  travelRequestCaregiver?: InputMaybe<ListFilterInputTypeOfTravelRequestCaregiverFilterInput>;
  travelType?: InputMaybe<ByteOperationFilterInput>;
};

export type TravelRequestFlightTravelDetailsModelInput = {
  airportDestination?: InputMaybe<Scalars['String']['input']>;
  airportOrigin: Scalars['String']['input'];
  departureDate: Scalars['Date']['input'];
  id: Scalars['Int']['input'];
  returnDate?: InputMaybe<Scalars['Date']['input']>;
  specialRequests?: InputMaybe<Scalars['String']['input']>;
  travelType: Scalars['Byte']['input'];
};

export type TravelRequestFlightTravelDetailsSortInput = {
  airportDestination?: InputMaybe<SortEnumType>;
  airportOrigin?: InputMaybe<SortEnumType>;
  departureDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  returnDate?: InputMaybe<SortEnumType>;
  specialRequests?: InputMaybe<SortEnumType>;
  travelType?: InputMaybe<SortEnumType>;
};

export type TravelRequestModelInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  carServiceAttachmentInfoId?: InputMaybe<Scalars['Int']['input']>;
  carServiceReceiptDate?: InputMaybe<Scalars['Date']['input']>;
  carServiceRequests?: InputMaybe<Scalars['String']['input']>;
  carServiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  carServiceTransactionAmount?: InputMaybe<Scalars['Decimal']['input']>;
  carServiceTransactionCurrency?: InputMaybe<Scalars['String']['input']>;
  carServiceTransactionDate?: InputMaybe<Scalars['Date']['input']>;
  caregiver?: InputMaybe<Scalars['Boolean']['input']>;
  completingUserId?: InputMaybe<Scalars['Int']['input']>;
  completingUserName?: InputMaybe<Scalars['String']['input']>;
  flightAttachmentInfoId?: InputMaybe<Scalars['Int']['input']>;
  flightReceiptDate?: InputMaybe<Scalars['Date']['input']>;
  flightRequestDetails?: InputMaybe<TravelRequestFlightTravelDetailsModelInput>;
  flightRequestDetailsId?: InputMaybe<Scalars['Int']['input']>;
  flightRequests?: InputMaybe<Scalars['String']['input']>;
  flightRequired?: InputMaybe<Scalars['Boolean']['input']>;
  flightTransactionAmount?: InputMaybe<Scalars['Decimal']['input']>;
  flightTransactionCurrency?: InputMaybe<Scalars['String']['input']>;
  flightTransactionDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['Int']['input'];
  lodgingAttachmentInfoId?: InputMaybe<Scalars['Int']['input']>;
  lodgingCheckInDate?: InputMaybe<Scalars['Date']['input']>;
  lodgingCheckOutDate?: InputMaybe<Scalars['Date']['input']>;
  lodgingDateRequired: Scalars['Boolean']['input'];
  lodgingReceiptDate?: InputMaybe<Scalars['Date']['input']>;
  lodgingRequests?: InputMaybe<Scalars['String']['input']>;
  lodgingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  lodgingTransactionAmount?: InputMaybe<Scalars['Decimal']['input']>;
  lodgingTransactionCurrency?: InputMaybe<Scalars['String']['input']>;
  lodgingTransactionDate?: InputMaybe<Scalars['Date']['input']>;
  otherAttachmentInfoId?: InputMaybe<Scalars['Int']['input']>;
  otherReceiptDate?: InputMaybe<Scalars['Date']['input']>;
  otherRequests?: InputMaybe<Scalars['String']['input']>;
  otherServiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  otherTransactionAmount?: InputMaybe<Scalars['Decimal']['input']>;
  otherTransactionCurrency?: InputMaybe<Scalars['String']['input']>;
  otherTransactionDate?: InputMaybe<Scalars['Date']['input']>;
  rentalCarAttachmentInfoId?: InputMaybe<Scalars['Int']['input']>;
  rentalCarCountry?: InputMaybe<Scalars['String']['input']>;
  rentalCarDropOffDate?: InputMaybe<Scalars['Date']['input']>;
  rentalCarDropOffTime?: InputMaybe<Scalars['String']['input']>;
  rentalCarLocation?: InputMaybe<Scalars['String']['input']>;
  rentalCarPickUpDate?: InputMaybe<Scalars['Date']['input']>;
  rentalCarPickUpTime?: InputMaybe<Scalars['String']['input']>;
  rentalCarReceiptDate?: InputMaybe<Scalars['Date']['input']>;
  rentalCarRequests?: InputMaybe<Scalars['String']['input']>;
  rentalCarRequired: Scalars['Boolean']['input'];
  rentalCarTransactionAmount?: InputMaybe<Scalars['Decimal']['input']>;
  rentalCarTransactionCurrency?: InputMaybe<Scalars['String']['input']>;
  rentalCarTransactionDate?: InputMaybe<Scalars['Date']['input']>;
  rentalCarUseFlightDate?: InputMaybe<Scalars['Boolean']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  trainAttachmentInfoId?: InputMaybe<Scalars['Int']['input']>;
  trainReceiptDate?: InputMaybe<Scalars['Date']['input']>;
  trainRequests?: InputMaybe<Scalars['String']['input']>;
  trainRequired?: InputMaybe<Scalars['Boolean']['input']>;
  trainTransactionAmount?: InputMaybe<Scalars['Decimal']['input']>;
  trainTransactionCurrency?: InputMaybe<Scalars['String']['input']>;
  trainTransactionDate?: InputMaybe<Scalars['Date']['input']>;
  trainTravelDetailsForPatient?: InputMaybe<TravelRequestTrainTravelDetailsModelInput>;
  trainTravelDetailsForPatientId?: InputMaybe<Scalars['Int']['input']>;
  travelRequestCaregiver: Array<TravelRequestCaregiverModelInput>;
  travelRequestTransferData: Array<TravelRequestTransferDataModelInput>;
  travelRestrictions?: InputMaybe<Scalars['String']['input']>;
  travelerInstructions?: InputMaybe<Scalars['String']['input']>;
  visitEndDate: Scalars['Date']['input'];
  visitEndTime: Scalars['String']['input'];
  visitNameId?: InputMaybe<Scalars['Int']['input']>;
  visitStartDate: Scalars['Date']['input'];
  visitStartTime: Scalars['String']['input'];
};

export type TravelRequestSortInput = {
  additionalDetails?: InputMaybe<SortEnumType>;
  approvalRequired?: InputMaybe<SortEnumType>;
  carServiceAttachmentInfoId?: InputMaybe<SortEnumType>;
  carServiceMerchant?: InputMaybe<SortEnumType>;
  carServiceReceiptDate?: InputMaybe<SortEnumType>;
  carServiceRequests?: InputMaybe<SortEnumType>;
  carServiceRequired?: InputMaybe<SortEnumType>;
  carServiceTransactionAmount?: InputMaybe<SortEnumType>;
  carServiceTransactionCurrency?: InputMaybe<SortEnumType>;
  carServiceTransactionDate?: InputMaybe<SortEnumType>;
  carServiceUsdExpense?: InputMaybe<SortEnumType>;
  caregiver?: InputMaybe<SortEnumType>;
  completedTimestamp?: InputMaybe<SortEnumType>;
  completingUserId?: InputMaybe<SortEnumType>;
  completingUserName?: InputMaybe<SortEnumType>;
  createdTimestamp?: InputMaybe<SortEnumType>;
  erReportingPeriod?: InputMaybe<SortEnumType>;
  erTrackingId?: InputMaybe<SortEnumType>;
  flightAttachmentInfoId?: InputMaybe<SortEnumType>;
  flightMerchant?: InputMaybe<SortEnumType>;
  flightReceiptDate?: InputMaybe<SortEnumType>;
  flightRequestDetails?: InputMaybe<TravelRequestFlightTravelDetailsSortInput>;
  flightRequestDetailsId?: InputMaybe<SortEnumType>;
  flightRequests?: InputMaybe<SortEnumType>;
  flightRequired?: InputMaybe<SortEnumType>;
  flightTransactionAmount?: InputMaybe<SortEnumType>;
  flightTransactionCurrency?: InputMaybe<SortEnumType>;
  flightTransactionDate?: InputMaybe<SortEnumType>;
  flightUsdExpense?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastEditTimestamp?: InputMaybe<SortEnumType>;
  lodgingAttachmentInfoId?: InputMaybe<SortEnumType>;
  lodgingCheckInDate?: InputMaybe<SortEnumType>;
  lodgingCheckOutDate?: InputMaybe<SortEnumType>;
  lodgingDateRequired?: InputMaybe<SortEnumType>;
  lodgingMerchant?: InputMaybe<SortEnumType>;
  lodgingReceiptDate?: InputMaybe<SortEnumType>;
  lodgingRequests?: InputMaybe<SortEnumType>;
  lodgingRequired?: InputMaybe<SortEnumType>;
  lodgingTransactionAmount?: InputMaybe<SortEnumType>;
  lodgingTransactionCurrency?: InputMaybe<SortEnumType>;
  lodgingTransactionDate?: InputMaybe<SortEnumType>;
  lodgingUsdExpense?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  otherAttachmentInfoId?: InputMaybe<SortEnumType>;
  otherMerchant?: InputMaybe<SortEnumType>;
  otherReceiptDate?: InputMaybe<SortEnumType>;
  otherRequests?: InputMaybe<SortEnumType>;
  otherServiceRequired?: InputMaybe<SortEnumType>;
  otherTransactionAmount?: InputMaybe<SortEnumType>;
  otherTransactionCurrency?: InputMaybe<SortEnumType>;
  otherTransactionDate?: InputMaybe<SortEnumType>;
  otherUsdExpense?: InputMaybe<SortEnumType>;
  patient?: InputMaybe<PatientSortInput>;
  patientId?: InputMaybe<SortEnumType>;
  rentalCarAttachmentInfoId?: InputMaybe<SortEnumType>;
  rentalCarCountry?: InputMaybe<SortEnumType>;
  rentalCarDropOffDate?: InputMaybe<SortEnumType>;
  rentalCarDropOffTime?: InputMaybe<SortEnumType>;
  rentalCarLocation?: InputMaybe<SortEnumType>;
  rentalCarMerchant?: InputMaybe<SortEnumType>;
  rentalCarPickUpDate?: InputMaybe<SortEnumType>;
  rentalCarPickUpTime?: InputMaybe<SortEnumType>;
  rentalCarReceiptDate?: InputMaybe<SortEnumType>;
  rentalCarRequests?: InputMaybe<SortEnumType>;
  rentalCarRequired?: InputMaybe<SortEnumType>;
  rentalCarTransactionAmount?: InputMaybe<SortEnumType>;
  rentalCarTransactionCurrency?: InputMaybe<SortEnumType>;
  rentalCarTransactionDate?: InputMaybe<SortEnumType>;
  rentalCarUsdExpense?: InputMaybe<SortEnumType>;
  rentalCarUseFlightDate?: InputMaybe<SortEnumType>;
  statusChangedAt?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
  submittedTimestamp?: InputMaybe<SortEnumType>;
  submittingUserId?: InputMaybe<SortEnumType>;
  submittingUserName?: InputMaybe<SortEnumType>;
  trainAttachmentInfoId?: InputMaybe<SortEnumType>;
  trainMerchant?: InputMaybe<SortEnumType>;
  trainReceiptDate?: InputMaybe<SortEnumType>;
  trainRequests?: InputMaybe<SortEnumType>;
  trainRequired?: InputMaybe<SortEnumType>;
  trainTransactionAmount?: InputMaybe<SortEnumType>;
  trainTransactionCurrency?: InputMaybe<SortEnumType>;
  trainTransactionDate?: InputMaybe<SortEnumType>;
  trainTravelDetailsForPatient?: InputMaybe<TravelRequestTrainTravelDetailsSortInput>;
  trainTravelDetailsForPatientId?: InputMaybe<SortEnumType>;
  trainUsdExpense?: InputMaybe<SortEnumType>;
  travelRestrictions?: InputMaybe<SortEnumType>;
  travelerInstructions?: InputMaybe<SortEnumType>;
  visitEndDate?: InputMaybe<SortEnumType>;
  visitEndTime?: InputMaybe<SortEnumType>;
  visitName?: InputMaybe<VisitNameSortInput>;
  visitNameId?: InputMaybe<SortEnumType>;
  visitStartDate?: InputMaybe<SortEnumType>;
  visitStartTime?: InputMaybe<SortEnumType>;
};

export type TravelRequestSpendData = {
  carServiceSpend: Scalars['Float']['output'];
  debitCardSpend: Scalars['Float']['output'];
  flightSpend: Scalars['Float']['output'];
  hotelSpend: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  mealSpend: Scalars['Float']['output'];
  mileageSpend: Scalars['Float']['output'];
  modifiedBy: Scalars['String']['output'];
  otherSpend: Scalars['Float']['output'];
  parkingSpend: Scalars['Float']['output'];
  patient: Patient;
  patientId: Scalars['Int']['output'];
  taxiSpend: Scalars['Float']['output'];
  trainSpend: Scalars['Float']['output'];
  translationSpend: Scalars['Float']['output'];
  visaSpend: Scalars['Float']['output'];
  visit: VisitName;
  visitId: Scalars['Int']['output'];
};

export type TravelRequestSpendDataFilterInput = {
  and?: InputMaybe<Array<TravelRequestSpendDataFilterInput>>;
  carServiceSpend?: InputMaybe<FloatOperationFilterInput>;
  debitCardSpend?: InputMaybe<FloatOperationFilterInput>;
  flightSpend?: InputMaybe<FloatOperationFilterInput>;
  hotelSpend?: InputMaybe<FloatOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  mealSpend?: InputMaybe<FloatOperationFilterInput>;
  mileageSpend?: InputMaybe<FloatOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelRequestSpendDataFilterInput>>;
  otherSpend?: InputMaybe<FloatOperationFilterInput>;
  parkingSpend?: InputMaybe<FloatOperationFilterInput>;
  patient?: InputMaybe<PatientFilterInput>;
  patientId?: InputMaybe<IntOperationFilterInput>;
  taxiSpend?: InputMaybe<FloatOperationFilterInput>;
  trainSpend?: InputMaybe<FloatOperationFilterInput>;
  translationSpend?: InputMaybe<FloatOperationFilterInput>;
  visaSpend?: InputMaybe<FloatOperationFilterInput>;
  visit?: InputMaybe<VisitNameFilterInput>;
  visitId?: InputMaybe<IntOperationFilterInput>;
};

export type TravelRequestTrainTravelDetails = {
  departureDate: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  isRoundTrip: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  returnDate?: Maybe<Scalars['Date']['output']>;
  specialRequests?: Maybe<Scalars['String']['output']>;
  trainStationDestination?: Maybe<Scalars['String']['output']>;
  trainStationOrigin: Scalars['String']['output'];
  travelRequest?: Maybe<TravelRequest>;
  travelRequestCaregiver: Array<TravelRequestCaregiver>;
};

export type TravelRequestTrainTravelDetailsFilterInput = {
  and?: InputMaybe<Array<TravelRequestTrainTravelDetailsFilterInput>>;
  departureDate?: InputMaybe<DateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isRoundTrip?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelRequestTrainTravelDetailsFilterInput>>;
  returnDate?: InputMaybe<DateOperationFilterInput>;
  specialRequests?: InputMaybe<StringOperationFilterInput>;
  trainStationDestination?: InputMaybe<StringOperationFilterInput>;
  trainStationOrigin?: InputMaybe<StringOperationFilterInput>;
  travelRequest?: InputMaybe<TravelRequestFilterInput>;
  travelRequestCaregiver?: InputMaybe<ListFilterInputTypeOfTravelRequestCaregiverFilterInput>;
};

export type TravelRequestTrainTravelDetailsModelInput = {
  departureDate: Scalars['Date']['input'];
  id: Scalars['Int']['input'];
  isRoundTrip: Scalars['Boolean']['input'];
  returnDate?: InputMaybe<Scalars['Date']['input']>;
  specialRequests?: InputMaybe<Scalars['String']['input']>;
  trainStationDestination?: InputMaybe<Scalars['String']['input']>;
  trainStationOrigin: Scalars['String']['input'];
};

export type TravelRequestTrainTravelDetailsSortInput = {
  departureDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isRoundTrip?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  returnDate?: InputMaybe<SortEnumType>;
  specialRequests?: InputMaybe<SortEnumType>;
  trainStationDestination?: InputMaybe<SortEnumType>;
  trainStationOrigin?: InputMaybe<SortEnumType>;
  travelRequest?: InputMaybe<TravelRequestSortInput>;
};

export type TravelRequestTransferData = {
  dropoffAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifiedBy: Scalars['String']['output'];
  pickupAddress: Scalars['String']['output'];
  pickupDateTime?: Maybe<Scalars['DateTime']['output']>;
  request: TravelRequest;
  requestId: Scalars['Int']['output'];
};

export type TravelRequestTransferDataFilterInput = {
  and?: InputMaybe<Array<TravelRequestTransferDataFilterInput>>;
  dropoffAddress?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelRequestTransferDataFilterInput>>;
  pickupAddress?: InputMaybe<StringOperationFilterInput>;
  pickupDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  request?: InputMaybe<TravelRequestFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
};

export type TravelRequestTransferDataModelInput = {
  dropoffAddress: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  pickupAddress: Scalars['String']['input'];
  pickupDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A connection to a list of items. */
export type TravelRequestsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<TravelRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TravelRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TravelRequestsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TravelRequest;
};

export type TravelTransaction = {
  amount: Scalars['Decimal']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
  travelRequest: TravelRequest;
  travelRequestId: Scalars['Int']['output'];
};

export type TravelTransactionFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<TravelTransactionFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelTransactionFilterInput>>;
  transactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  travelRequest?: InputMaybe<TravelRequestFilterInput>;
  travelRequestId?: InputMaybe<IntOperationFilterInput>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type VisitName = {
  id: Scalars['ID']['output'];
  modifiedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reimbursementRequest: Array<ReimbursementRequest>;
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Byte']['output'];
  stipendRequest: Array<StipendRequest>;
  study: Study;
  studyId: Scalars['Int']['output'];
  travelRequest: Array<TravelRequest>;
  travelRequestSpendData: Array<TravelRequestSpendData>;
  visitGroupId?: Maybe<Scalars['Int']['output']>;
};


export type VisitNameReimbursementRequestArgs = {
  where?: InputMaybe<ReimbursementRequestFilterInput>;
};


export type VisitNameStipendRequestArgs = {
  where?: InputMaybe<StipendRequestFilterInput>;
};


export type VisitNameTravelRequestArgs = {
  where?: InputMaybe<TravelRequestFilterInput>;
};

export type VisitNameFilterInput = {
  and?: InputMaybe<Array<VisitNameFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VisitNameFilterInput>>;
  reimbursementRequest?: InputMaybe<ListFilterInputTypeOfReimbursementRequestFilterInput>;
  scheduled?: InputMaybe<BooleanOperationFilterInput>;
  sortOrder?: InputMaybe<ByteOperationFilterInput>;
  stipendRequest?: InputMaybe<ListFilterInputTypeOfStipendRequestFilterInput>;
  study?: InputMaybe<StudyFilterInput>;
  studyId?: InputMaybe<IntOperationFilterInput>;
  travelRequest?: InputMaybe<ListFilterInputTypeOfTravelRequestFilterInput>;
  travelRequestSpendData?: InputMaybe<ListFilterInputTypeOfTravelRequestSpendDataFilterInput>;
  visitGroupId?: InputMaybe<IntOperationFilterInput>;
};

export type VisitNameSortInput = {
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  scheduled?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  study?: InputMaybe<StudySortInput>;
  studyId?: InputMaybe<SortEnumType>;
  visitGroupId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VisitNamesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<VisitNamesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VisitName>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VisitNamesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VisitName;
};

export type VisitScheduleRequestItem = {
  amount?: Maybe<Scalars['Decimal']['output']>;
  amountCurrency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  statusId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  visitStartDate?: Maybe<Scalars['DateTime']['output']>;
};

export type VisitScheduleRequestItemFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  amountCurrency?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<VisitScheduleRequestItemFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<VisitScheduleRequestItemFilterInput>>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  visitStartDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type GetPatientUserLanguageQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
}>;


export type GetPatientUserLanguageQuery = { patientUser?: { id: string, applicationLanguage: string } | null };

export type GetPatientNotificationsSentQueryVariables = Exact<{
  numberOfElements: Scalars['Int']['input'];
  endCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPatientNotificationsSentQuery = { notificationsSent?: { edges?: Array<{ cursor: string, node: { id: string, notificationEventKey: string, targetGroup: string, targetId: number, createDatetime: string, title?: string | null } }> | null, pageInfo: { hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetClinTrakVisitNamesQueryVariables = Exact<{
  studyId: Scalars['Int']['input'];
}>;


export type GetClinTrakVisitNamesQuery = { clinTrakVisitNames?: { nodes?: Array<{ id: string, visitName: string, sortOrder: number, visitNameType: number, sortOrderDate?: string | null, actualDate?: string | null, scheduledDate?: string | null, requestCount: number, title?: string | null, scheduled?: boolean | null, visitGroupId?: number | null, visitGroupName?: string | null, clinTrakPatientVisits?: Array<{ patientVisitId: any, statusAbbreviation?: string | null, statusDescription?: string | null, patientVisitMasterId: any, isActive: boolean, patientId: any, actualDate?: string | null, scheduledDate?: string | null }> | null, requests?: Array<{ id: number, statusId: number, type: string, amount?: any | null, amountCurrency?: string | null, visitStartDate?: string | null }> | null }> | null } | null };

export type GetStudyDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudyDetailsQuery = { currentPatient?: { id: string, patientPaymentDetails?: { preferredCurrency?: string | null } | null, patientData?: { patientId: number, firstName: string } | null, site: { id: string, institutionName: string, pilastName: string, study: { id: string, studyLogoInfoId?: number | null, sponsor: string, protocol: string } } } | null };

export type GetPatientCtsmStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientCtsmStatusQuery = { patientCtsmStatus?: { statusName?: string | null } | null };

export type GetPatientDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientDetailsQuery = { currentPatient?: { id: string, accessRamp: boolean, accessWalker: boolean, accessWheelChair: boolean, accessibilityRequirements?: string | null, airTravelRequired: boolean, airlinePrimary?: string | null, airlineSecondary?: string | null, allergies?: string | null, groundTransportRequired: boolean, hotelChainPrimary?: string | null, internationTravelRequired: boolean, lodgingRequired: boolean, rentalCarRequired: boolean, seatPreference?: string | null, patientNum: string, trainRequired: boolean, site: { siteNumber: string, travelServiceSupport: boolean, reimbursementSupport: boolean, stipendSupport: boolean, study: { sponsor: string, protocol: string } }, patientData?: { address1: string, address2?: string | null, airlineRewardsPrimary?: string | null, airlineRewardsSecondary?: string | null, airlineSpecialNeeds?: string | null, birthDate?: string | null, city: string, country: string, email: string, firstName: string, gender?: string | null, groundSpecialNeeds?: string | null, hasConsentForm: boolean, knownTravelerNum?: string | null, lastName: string, lodgingRoomPreference?: string | null, lodgingSpecialNeeds?: string | null, middleName?: string | null, passportCountry?: string | null, passportExpiration?: any | null, passportIssue?: any | null, passportNum?: string | null, phone: string, preferredLang: string, rentalCarFrequentTravelerNum?: string | null, state?: string | null, trainSpecialNeeds?: string | null, zipcode?: string | null } | null, patientPaymentDetails?: { preferredCurrency?: string | null, preferredPayment?: string | null, paymentRecipientRole?: string | null } | null, status: { id: string }, caregiver: Array<{ id: string, isDeleted?: boolean | null, patientId: number, firstName: string, middleName?: string | null, lastName: string, isPrimary: boolean, relationship?: string | null, phone?: string | null, email?: string | null, preferredLang: string, gender?: string | null, birthDate?: string | null, addressSameAsPatient: boolean, address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipcode?: string | null, passportCountry?: string | null, passportIssue?: any | null, passportExpiration?: any | null, passportNum?: string | null, details?: string | null }>, patientEditRequest?: { patientId: number, id: number, preferredLang?: string | null, phone?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, country?: string | null, profileChangeDetails?: string | null, isSubmitted: boolean, airlinePrimary?: string | null, airlineSecondary?: string | null, airlineRewardsPrimary?: string | null, airlineRewardsSecondary?: string | null, seatPreference?: string | null, knownTravelerNum?: string | null, airlineSpecialNeeds?: string | null, trainSpecialNeeds?: string | null, passportNum?: string | null, passportCountry?: string | null, passportExpiration?: any | null, passportIssue?: any | null, hotelChainPrimary?: string | null, lodgingRoomPreference?: string | null, allergies?: string | null, lodgingSpecialNeeds?: string | null, rentalCarFrequentTravelerNum?: string | null, groundSpecialNeeds?: string | null, lastUpdateTimestamp: string, caregiverEditRequest: Array<{ caregiverId: number, patientEditRequestId: number, addressSameAsPatient?: boolean | null, id: number, phone?: string | null, preferredLang?: string | null, address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipcode?: string | null, passportCountry?: string | null, passportIssue?: any | null, passportExpiration?: any | null, passportNum?: string | null }> } | null } | null };

export type GetPatientRequestsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientRequestsListQuery = { currentPatient?: { reimbursementRequest: Array<{ id: string, visitStartDate?: any | null, statusId: number, totalCurrency?: string | null, totalAmountAuthorized?: any | null, visitName?: { name: string } | null }>, travelRequest: Array<{ id: string, visitStartDate?: any | null, statusId: number, visitName?: { name: string } | null }>, stipendRequest: Array<{ id: string, visitStartDate?: any | null, statusId: number, authorizedAmount?: any | null, currency?: string | null, visitName?: { name: string } | null }> } | null };

export type GetMileageReimbursementRateQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
  date: Scalars['Date']['input'];
}>;


export type GetMileageReimbursementRateQuery = { mileageReimbursementRates?: { nodes?: Array<{ mileageReimbursementRatePerUnit: number, mileageDistanceUnits: string, effectiveDate: any, countryCode: string, currencyCode: string }> | null } | null };

export type GetReimbursementRequestQueryVariables = Exact<{
  requestId: Scalars['Int']['input'];
}>;


export type GetReimbursementRequestQuery = { reimbursementRequest?: { id: string, visitNameId?: number | null, createdTimestamp?: string | null, visitStartDate?: any | null, totalCurrency?: string | null, statusId: number, travelerInstructions?: string | null, totalAmount?: any | null, totalAmountAuthorized?: any | null, visitName?: { name: string } | null, reimbursementTransaction: Array<{ id: string, expenseId?: number | null, amount: any, authorizedAmount?: any | null, currency?: string | null, timestamp: string, transactionAttachmentInfoId?: number | null, mileageStartLocation?: string | null, mileageEndLocation?: string | null, mileageTotalDistance?: any | null, mileageDistanceUnits?: string | null, mileageReimbursementCountry?: string | null, mileageReimbursementRatePerUnit?: number | null, mileageComments?: string | null, manualTotalCalculation: boolean, isIncomplete: boolean, notes?: string | null }> } | null };

export type GetReimbursementRequestDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReimbursementRequestDataQuery = { currentPatient?: { patientPaymentDetails?: { preferredCurrency?: string | null } | null, site: { pilastName: string, institutionName: string, address1: string, address2?: string | null, city: string, zipcode?: string | null, state?: string | null, country: string, study: { id: string, sponsor: string, visitName: Array<{ name: string, id: string, sortOrder: any }> } } } | null };

export type GetReimbursementRequestExpensesQueryVariables = Exact<{
  studyId: Scalars['Int']['input'];
}>;


export type GetReimbursementRequestExpensesQuery = { studyActiveExpenses: Array<{ id?: number | null, studyId?: number | null, expenseId: number, expenseKey: string }> };

export type SubmitReimbursementRequestMutationVariables = Exact<{
  dto: ReimbursementRequestDtoInput;
}>;


export type SubmitReimbursementRequestMutation = { submitReimbursementRequest: { reimbursementRequest?: { id: string, reimbursementTransaction: Array<{ id: string }> } | null } };

export type SaveDraftReimbursementRequestMutationVariables = Exact<{
  dto: ReimbursementRequestDtoInput;
}>;


export type SaveDraftReimbursementRequestMutation = { saveDraftReimbursementRequest: { reimbursementRequest?: { id: string, reimbursementTransaction: Array<{ id: string }> } | null } };

export type GetRequestStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestStateQuery = { currentPatient?: { id: string, site: { id: string, study: { id: string, visitName: Array<{ id: string, name: string, sortOrder: any }> } } } | null };

export type GetVisitNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVisitNamesQuery = { currentPatient?: { id: string, site: { id: string, study: { id: string, visitName: Array<{ id: string, name: string, sortOrder: any }> } } } | null };

export type GetStipendRequestDataQueryVariables = Exact<{
  requestId: Scalars['Int']['input'];
}>;


export type GetStipendRequestDataQuery = { stipendRequest?: { visitStartDate?: any | null, statusId: number, amount?: any | null, authorizedAmount?: any | null, authorizedAmountUsd?: any | null, currency?: string | null, createdTimestamp?: string | null, travelerInstructions?: string | null, visitName?: { name: string } | null, patient: { site: { pilastName: string, institutionName: string, address1: string, address2?: string | null, city: string, zipcode?: string | null, country: string, state?: string | null, study: { sponsor: string } } } } | null };

export type GetSiteAddressDataToRequestQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteAddressDataToRequestQuery = { site?: { id: string, address1: string, address2?: string | null, city: string, state?: string | null, zipcode?: string | null, country: string, pilastName: string, institutionName: string, study: { sponsor: string } } | null };

export type GetTravelRequestDetailedDataQueryVariables = Exact<{
  requestId: Scalars['Int']['input'];
}>;


export type GetTravelRequestDetailedDataQuery = { travelRequest?: { id: string, visitNameId?: number | null, visitStartDate?: any | null, visitStartTime?: string | null, visitEndDate?: string | null, visitEndTime?: string | null, travelerInstructions?: string | null, caregiver?: boolean | null, approvalRequired?: boolean | null, flightRequired?: boolean | null, flightReceiptDate?: string | null, flightTransactionAmount?: any | null, flightTransactionCurrency?: string | null, flightRequests?: string | null, flightAttachmentInfoId?: number | null, flightRequestDetailsId?: number | null, trainRequired?: boolean | null, trainReceiptDate?: string | null, trainTransactionAmount?: any | null, trainTransactionCurrency?: string | null, trainRequests?: string | null, trainAttachmentInfoId?: number | null, trainTravelDetailsForPatientId?: number | null, lodgingRequired?: boolean | null, lodgingCheckInDate?: any | null, lodgingCheckOutDate?: any | null, lodgingDateRequired: boolean, lodgingReceiptDate?: string | null, lodgingTransactionAmount?: any | null, lodgingTransactionCurrency?: string | null, lodgingRequests?: string | null, lodgingAttachmentInfoId?: number | null, carServiceRequired?: boolean | null, carServiceReceiptDate?: string | null, carServiceTransactionAmount?: any | null, carServiceTransactionCurrency?: string | null, carServiceRequests?: string | null, carServiceAttachmentInfoId?: number | null, rentalCarRequired: boolean, rentalCarReceiptDate?: string | null, rentalCarTransactionAmount?: any | null, rentalCarTransactionCurrency?: string | null, rentalCarUseFlightDate?: boolean | null, rentalCarPickUpDate?: any | null, rentalCarPickUpTime?: string | null, rentalCarDropOffDate?: any | null, rentalCarDropOffTime?: string | null, rentalCarLocation?: string | null, rentalCarCountry?: string | null, rentalCarRequests?: string | null, rentalCarAttachmentInfoId?: number | null, otherServiceRequired?: boolean | null, otherReceiptDate?: string | null, otherTransactionAmount?: any | null, otherTransactionCurrency?: string | null, otherRequests?: string | null, otherAttachmentInfoId?: number | null, travelRestrictions?: string | null, createdTimestamp?: string | null, lastEditTimestamp?: string | null, submittedTimestamp?: string | null, completedTimestamp?: string | null, submittingUserName?: string | null, completingUserName?: string | null, additionalDetails?: string | null, statusId: number, visitName?: { name: string } | null, flightRequestDetails?: { id: number, travelType: any, airportOrigin: string, airportDestination?: string | null, departureDate: any, returnDate?: any | null, specialRequests?: string | null, travelRequestCaregiver: Array<{ caregiverName: string, isPrimary: boolean, flightRequestTheSameAsPatient: boolean, createdTimestamp: string }> } | null, trainTravelDetailsForPatient?: { id: number, isRoundTrip: boolean, trainStationOrigin: string, trainStationDestination?: string | null, departureDate: any, returnDate?: any | null, specialRequests?: string | null } | null, travelTransaction: Array<{ id: number, label: string, amount: any, currency?: string | null, transactionDate: string }>, travelRequestTransferData: Array<{ id: number, pickupDateTime?: string | null, pickupAddress: string, dropoffAddress: string }>, travelRequestCaregiver: Array<{ caregiverId: number, travelRequestId: number, caregiverName: string, isPrimary: boolean, flightRequestTheSameAsPatient: boolean, flightRequestDetailsId?: number | null, trainRequestTheSameAsPatient?: boolean | null, trainRequestDetailsId?: number | null, caregiver: { id: string, firstName: string, middleName?: string | null, lastName: string, relationship?: string | null, isPrimary: boolean }, flightRequestDetails?: { id: number, travelType: any, airportOrigin: string, airportDestination?: string | null, departureDate: any, returnDate?: any | null, specialRequests?: string | null } | null, trainRequestDetails?: { id: number, trainStationOrigin: string, trainStationDestination?: string | null, departureDate: any, returnDate?: any | null, specialRequests?: string | null, isRoundTrip: boolean } | null }> } | null };

export type GetCarRentalPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCarRentalPreferencesQuery = { currentPatient?: { patientData?: { rentalCarFrequentTravelerNum?: string | null } | null } | null };

export type GetCarServicePreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCarServicePreferencesQuery = { currentPatient?: { patientData?: { groundSpecialNeeds?: string | null } | null } | null };

export type GetFlightPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFlightPreferencesQuery = { currentPatient?: { airlinePrimary?: string | null, airlineSecondary?: string | null, seatPreference?: string | null, patientData?: { airlineRewardsPrimary?: string | null, airlineRewardsSecondary?: string | null, knownTravelerNum?: string | null, airlineSpecialNeeds?: string | null } | null } | null };

export type GetCaregiversQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCaregiversQuery = { currentPatient?: { caregiver: Array<{ id: string, firstName: string, middleName?: string | null, lastName: string, relationship?: string | null, isPrimary: boolean, isDeleted?: boolean | null }> } | null };

export type GetPatientQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientQuery = { currentPatient?: { patientData?: { firstName: string, middleName?: string | null, lastName: string } | null } | null };

export type GetLodgingPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLodgingPreferencesQuery = { currentPatient?: { hotelChainPrimary?: string | null, allergies?: string | null, patientData?: { lodgingRoomPreference?: string | null, lodgingSpecialNeeds?: string | null } | null } | null };

export type SaveDraftTravelRequestMutationVariables = Exact<{
  dto: TravelRequestModelInput;
}>;


export type SaveDraftTravelRequestMutation = { saveDraftTravelRequest: { travelRequest?: { id: string } | null } };

export type SubmitTravelRequestMutationVariables = Exact<{
  dto: TravelRequestModelInput;
}>;


export type SubmitTravelRequestMutation = { submitTravelRequest: { travelRequest?: { id: string } | null } };

export type GetTrainPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrainPreferencesQuery = { currentPatient?: { patientData?: { trainSpecialNeeds?: string | null } | null } | null };

export type ChangeLoggedPatientPasswordMutationVariables = Exact<{
  input: ChangeLoggedPatientPasswordInput;
}>;


export type ChangeLoggedPatientPasswordMutation = { changeLoggedPatientPassword: { boolean?: boolean | null } };

export type ChangePatientUserLanguageMutationVariables = Exact<{
  input: ChangePatientUserLanguageInput;
}>;


export type ChangePatientUserLanguageMutation = { changePatientUserLanguage: { boolean?: boolean | null } };

export type GetPatientUserNotificationsQueryVariables = Exact<{
  templateIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetPatientUserNotificationsQuery = { patientUserNotifications?: { nodes?: Array<{ id: string, templateId: string, allowPushNotification?: boolean | null, allowEmailNotification?: boolean | null }> | null } | null };

export type SetPatientUserNotificationsMutationVariables = Exact<{
  input: SetPatientUserNotificationsInput;
}>;


export type SetPatientUserNotificationsMutation = { setPatientUserNotifications: { boolean?: boolean | null } };

export type ChangePasswordInResetPasswordScenarioMutationVariables = Exact<{
  input: ChangePasswordInPasswordResetScenarioInput;
}>;


export type ChangePasswordInResetPasswordScenarioMutation = { changePasswordInPasswordResetScenario: { boolean?: boolean | null } };

export type DeletePatientEditRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type DeletePatientEditRequestMutation = { deletePatientEditRequest: { successPatientEditRequestResponseDto?: { saveSuccessful: boolean } | null } };

export type EditPatientDataMutationVariables = Exact<{
  input: EditPatientInput;
}>;


export type EditPatientDataMutation = { editPatient: { successPatientEditRequestResponseDto?: { saveSuccessful: boolean } | null } };

export type PatientUserFcmTokenQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type PatientUserFcmTokenQuery = { patientUserFcmToken?: { id: string, deviceId: string, fcmToken: string, fcmTokenExpirationDate: string } | null };

export type GetPatientVisitGroupIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientVisitGroupIdQuery = { currentPatient?: { patientData?: { visitGroupId?: number | null } | null } | null };

export type GetRegistrationInfoQueryVariables = Exact<{
  accessRequestId: Scalars['UUID']['input'];
}>;


export type GetRegistrationInfoQuery = { patientPortalAccessRequestById?: { email: string, id: number } | null };

export type GetSiteSupportTierQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteSupportTierQuery = { currentPatient?: { site: { travelServiceSupport: boolean, reimbursementSupport: boolean } } | null };

export type GetVisitNamesByVisitGroupIdQueryVariables = Exact<{
  visitGroupId: Scalars['Int']['input'];
}>;


export type GetVisitNamesByVisitGroupIdQuery = { visitNames?: { nodes?: Array<{ id: string, name: string, sortOrder: any }> | null } | null };

export type LoginMutationVariables = Exact<{
  input: LoginPatientInput;
}>;


export type LoginMutation = { loginPatient: { authResult?: { jwtAccessToken: string, refreshToken: string } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { logoutPatient: { boolean?: boolean | null } };

export type RefreshTokenFromBodyMutationVariables = Exact<{
  input: RefreshTokenFromBodyInput;
}>;


export type RefreshTokenFromBodyMutation = { refreshTokenFromBody: { authResult?: { jwtAccessToken: string, refreshToken: string } | null } };

export type RefreshTokenFromCookieMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenFromCookieMutation = { refreshTokenFromCookie: { authResult?: { jwtAccessToken: string, refreshToken: string } | null } };

export type RegisterPatientMutationVariables = Exact<{
  input: RegisterPatientInput;
}>;


export type RegisterPatientMutation = { registerPatient: { authResult?: { jwtAccessToken: string, refreshToken: string } | null } };

export type RemovePatientFcmTokenMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type RemovePatientFcmTokenMutation = { removePatientFcmToken: { boolean?: boolean | null } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { resetPassword: { boolean?: boolean | null } };

export type SavePatientUserFcmTokenMutationVariables = Exact<{
  dto: PatientUserFcmTokenDtoInput;
}>;


export type SavePatientUserFcmTokenMutation = { savePatientUserFcmToken: { boolean?: boolean | null } };

export type SubmitPatientEditRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitPatientEditRequestMutation = { submitPatientEditRequest: { successPatientEditRequestResponseDto?: { saveSuccessful: boolean } | null } };

export type SetPatientUserNotificationDefaultsMutationVariables = Exact<{ [key: string]: never; }>;


export type SetPatientUserNotificationDefaultsMutation = { setPatientUserNotificationDefaults: { boolean?: boolean | null } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { countries?: { nodes?: Array<{ name: string, threeCharCode: string, isActive: boolean, regionType?: string | null }> | null } | null };

export type GetCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrenciesQuery = { currencies?: { nodes?: Array<{ isocode: string }> | null } | null };

export type GetPatientSiteStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientSiteStatusQuery = { currentPatient?: { site: { statusId: number } } | null };

export type GetStudyTravelOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudyTravelOptionsQuery = { currentPatient?: { site: { study: { studyTravelOption: Array<{ travelOption: { name: string } }> } } } | null };

export const GetPatientUserLanguageDocument = gql`
    query getPatientUserLanguage($patientId: Int!) {
  patientUser(where: {patientId: {eq: $patientId}}) {
    id
    applicationLanguage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientUserLanguageGQL extends Apollo.Query<GetPatientUserLanguageQuery, GetPatientUserLanguageQueryVariables> {
    override document = GetPatientUserLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientNotificationsSentDocument = gql`
    query getPatientNotificationsSent($numberOfElements: Int!, $endCursor: String) {
  notificationsSent(first: $numberOfElements, after: $endCursor) {
    edges {
      cursor
      node {
        id
        notificationEventKey
        targetGroup
        targetId
        createDatetime
        title
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientNotificationsSentGQL extends Apollo.Query<GetPatientNotificationsSentQuery, GetPatientNotificationsSentQueryVariables> {
    override document = GetPatientNotificationsSentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClinTrakVisitNamesDocument = gql`
    query getClinTrakVisitNames($studyId: Int!) {
  clinTrakVisitNames(studyId: $studyId) {
    nodes {
      id
      visitName
      sortOrder
      visitNameType
      sortOrderDate
      actualDate
      scheduledDate
      requestCount
      title
      clinTrakPatientVisits {
        patientVisitId
        statusAbbreviation
        statusDescription
        patientVisitMasterId
        isActive
        patientId
        actualDate
        scheduledDate
      }
      scheduled
      visitGroupId
      visitGroupName
      requests {
        id
        statusId
        type
        amount
        amountCurrency
        visitStartDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClinTrakVisitNamesGQL extends Apollo.Query<GetClinTrakVisitNamesQuery, GetClinTrakVisitNamesQueryVariables> {
    override document = GetClinTrakVisitNamesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStudyDetailsDocument = gql`
    query getStudyDetails {
  currentPatient {
    id
    patientPaymentDetails {
      preferredCurrency
    }
    patientData {
      patientId
      firstName
    }
    site {
      id
      institutionName
      pilastName
      study {
        id
        studyLogoInfoId
        sponsor
        protocol
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStudyDetailsGQL extends Apollo.Query<GetStudyDetailsQuery, GetStudyDetailsQueryVariables> {
    override document = GetStudyDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientCtsmStatusDocument = gql`
    query getPatientCtsmStatus {
  patientCtsmStatus {
    statusName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientCtsmStatusGQL extends Apollo.Query<GetPatientCtsmStatusQuery, GetPatientCtsmStatusQueryVariables> {
    override document = GetPatientCtsmStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientDetailsDocument = gql`
    query getPatientDetails {
  currentPatient {
    id
    site {
      study {
        sponsor
        protocol
      }
      siteNumber
      travelServiceSupport
      reimbursementSupport
      stipendSupport
    }
    accessRamp
    accessWalker
    accessWheelChair
    accessibilityRequirements
    airTravelRequired
    airlinePrimary
    airlineSecondary
    allergies
    groundTransportRequired
    hotelChainPrimary
    internationTravelRequired
    lodgingRequired
    patientData {
      address1
      address2
      airlineRewardsPrimary
      airlineRewardsSecondary
      airlineSpecialNeeds
      birthDate
      city
      country
      email
      firstName
      gender
      groundSpecialNeeds
      hasConsentForm
      knownTravelerNum
      lastName
      lodgingRoomPreference
      lodgingSpecialNeeds
      middleName
      passportCountry
      passportExpiration
      passportIssue
      passportNum
      phone
      preferredLang
      rentalCarFrequentTravelerNum
      state
      trainSpecialNeeds
      zipcode
    }
    patientPaymentDetails {
      preferredCurrency
      preferredPayment
      paymentRecipientRole
    }
    rentalCarRequired
    seatPreference
    status {
      id
    }
    patientNum
    trainRequired
    caregiver {
      id
      isDeleted
      patientId
      firstName
      middleName
      lastName
      isPrimary
      relationship
      phone
      email
      preferredLang
      gender
      birthDate
      addressSameAsPatient
      address1
      address2
      city
      country
      state
      zipcode
      passportCountry
      passportIssue
      passportExpiration
      passportNum
      details
    }
    patientEditRequest {
      patientId
      id
      preferredLang
      phone
      address1
      address2
      city
      state
      zipcode
      country
      profileChangeDetails
      isSubmitted
      airlinePrimary
      airlineSecondary
      airlineRewardsPrimary
      airlineRewardsSecondary
      seatPreference
      knownTravelerNum
      airlineSpecialNeeds
      trainSpecialNeeds
      passportNum
      passportCountry
      passportExpiration
      passportIssue
      hotelChainPrimary
      lodgingRoomPreference
      allergies
      lodgingSpecialNeeds
      rentalCarFrequentTravelerNum
      groundSpecialNeeds
      lastUpdateTimestamp
      caregiverEditRequest {
        caregiverId
        patientEditRequestId
        addressSameAsPatient
        id
        phone
        preferredLang
        address1
        address2
        city
        country
        state
        zipcode
        passportCountry
        passportIssue
        passportExpiration
        passportNum
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientDetailsGQL extends Apollo.Query<GetPatientDetailsQuery, GetPatientDetailsQueryVariables> {
    override document = GetPatientDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientRequestsListDocument = gql`
    query getPatientRequestsList {
  currentPatient {
    reimbursementRequest {
      id
      visitName {
        name
      }
      visitStartDate
      statusId
      totalCurrency
      totalAmountAuthorized
    }
    travelRequest {
      id
      visitName {
        name
      }
      visitStartDate
      statusId
    }
    stipendRequest {
      id
      visitName {
        name
      }
      visitStartDate
      statusId
      authorizedAmount
      currency
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientRequestsListGQL extends Apollo.Query<GetPatientRequestsListQuery, GetPatientRequestsListQueryVariables> {
    override document = GetPatientRequestsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMileageReimbursementRateDocument = gql`
    query getMileageReimbursementRate($countryCode: String!, $currencyCode: String!, $date: Date!) {
  mileageReimbursementRates(
    where: {currencyCode: {eq: $currencyCode}, countryCode: {eq: $countryCode}, effectiveDate: {lte: $date}}
    order: {effectiveDate: DESC}
    first: 1
  ) {
    nodes {
      mileageReimbursementRatePerUnit
      mileageDistanceUnits
      effectiveDate
      countryCode
      currencyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMileageReimbursementRateGQL extends Apollo.Query<GetMileageReimbursementRateQuery, GetMileageReimbursementRateQueryVariables> {
    override document = GetMileageReimbursementRateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReimbursementRequestDocument = gql`
    query getReimbursementRequest($requestId: Int!) {
  reimbursementRequest(where: {id: {eq: $requestId}}) {
    id
    visitNameId
    visitName {
      name
    }
    reimbursementTransaction {
      id
      expenseId
      amount
      authorizedAmount
      currency
      timestamp
      transactionAttachmentInfoId
      mileageStartLocation
      mileageEndLocation
      mileageTotalDistance
      mileageDistanceUnits
      mileageReimbursementCountry
      mileageReimbursementRatePerUnit
      mileageDistanceUnits
      mileageComments
      manualTotalCalculation
      isIncomplete
      notes
    }
    createdTimestamp
    visitStartDate
    totalCurrency
    statusId
    travelerInstructions
    totalAmount
    totalAmountAuthorized
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReimbursementRequestGQL extends Apollo.Query<GetReimbursementRequestQuery, GetReimbursementRequestQueryVariables> {
    override document = GetReimbursementRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReimbursementRequestDataDocument = gql`
    query getReimbursementRequestData {
  currentPatient {
    patientPaymentDetails {
      preferredCurrency
    }
    site {
      pilastName
      institutionName
      address1
      address2
      city
      zipcode
      state
      country
      study {
        id
        sponsor
        visitName {
          name
          id
          sortOrder
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReimbursementRequestDataGQL extends Apollo.Query<GetReimbursementRequestDataQuery, GetReimbursementRequestDataQueryVariables> {
    override document = GetReimbursementRequestDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReimbursementRequestExpensesDocument = gql`
    query getReimbursementRequestExpenses($studyId: Int!) {
  studyActiveExpenses(studyId: $studyId) {
    id
    studyId
    expenseId
    expenseKey
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReimbursementRequestExpensesGQL extends Apollo.Query<GetReimbursementRequestExpensesQuery, GetReimbursementRequestExpensesQueryVariables> {
    override document = GetReimbursementRequestExpensesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitReimbursementRequestDocument = gql`
    mutation submitReimbursementRequest($dto: ReimbursementRequestDtoInput!) {
  submitReimbursementRequest(input: {dto: $dto}) {
    reimbursementRequest {
      id
      reimbursementTransaction {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitReimbursementRequestGQL extends Apollo.Mutation<SubmitReimbursementRequestMutation, SubmitReimbursementRequestMutationVariables> {
    override document = SubmitReimbursementRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveDraftReimbursementRequestDocument = gql`
    mutation saveDraftReimbursementRequest($dto: ReimbursementRequestDtoInput!) {
  saveDraftReimbursementRequest(input: {dto: $dto}) {
    reimbursementRequest {
      id
      reimbursementTransaction {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveDraftReimbursementRequestGQL extends Apollo.Mutation<SaveDraftReimbursementRequestMutation, SaveDraftReimbursementRequestMutationVariables> {
    override document = SaveDraftReimbursementRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRequestStateDocument = gql`
    query getRequestState {
  currentPatient {
    id
    site {
      id
      study {
        id
        visitName {
          id
          name
          sortOrder
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestStateGQL extends Apollo.Query<GetRequestStateQuery, GetRequestStateQueryVariables> {
    override document = GetRequestStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVisitNamesDocument = gql`
    query getVisitNames {
  currentPatient {
    id
    site {
      id
      study {
        id
        visitName {
          id
          name
          sortOrder
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVisitNamesGQL extends Apollo.Query<GetVisitNamesQuery, GetVisitNamesQueryVariables> {
    override document = GetVisitNamesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStipendRequestDataDocument = gql`
    query getStipendRequestData($requestId: Int!) {
  stipendRequest(where: {id: {eq: $requestId}}) {
    visitName {
      name
    }
    visitStartDate
    patient {
      site {
        study {
          sponsor
        }
        pilastName
        institutionName
        address1
        address2
        city
        zipcode
        country
        state
      }
    }
    statusId
    amount
    authorizedAmount
    authorizedAmountUsd
    currency
    createdTimestamp
    travelerInstructions
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStipendRequestDataGQL extends Apollo.Query<GetStipendRequestDataQuery, GetStipendRequestDataQueryVariables> {
    override document = GetStipendRequestDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSiteAddressDataToRequestDocument = gql`
    query getSiteAddressDataToRequest {
  site {
    id
    address1
    address2
    city
    state
    zipcode
    country
    pilastName
    institutionName
    address1
    address2
    study {
      sponsor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSiteAddressDataToRequestGQL extends Apollo.Query<GetSiteAddressDataToRequestQuery, GetSiteAddressDataToRequestQueryVariables> {
    override document = GetSiteAddressDataToRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTravelRequestDetailedDataDocument = gql`
    query getTravelRequestDetailedData($requestId: Int!) {
  travelRequest(where: {id: {eq: $requestId}}) {
    id
    visitNameId
    visitName {
      name
    }
    visitStartDate
    visitStartTime
    visitEndDate
    visitEndTime
    travelerInstructions
    caregiver
    approvalRequired
    flightRequired
    flightReceiptDate
    flightTransactionAmount
    flightTransactionCurrency
    flightTransactionCurrency
    flightRequests
    flightAttachmentInfoId
    flightRequestDetailsId
    flightRequestDetails {
      id
      travelType
      airportOrigin
      airportDestination
      departureDate
      returnDate
      specialRequests
      travelRequestCaregiver {
        caregiverName
        isPrimary
        flightRequestTheSameAsPatient
        createdTimestamp
      }
    }
    trainRequired
    trainReceiptDate
    trainTransactionAmount
    trainTransactionCurrency
    trainTransactionCurrency
    trainRequests
    trainAttachmentInfoId
    trainTravelDetailsForPatientId
    trainTravelDetailsForPatient {
      id
      isRoundTrip
      trainStationOrigin
      trainStationDestination
      departureDate
      returnDate
      specialRequests
    }
    lodgingRequired
    lodgingCheckInDate
    lodgingCheckOutDate
    lodgingDateRequired
    lodgingReceiptDate
    lodgingTransactionAmount
    lodgingTransactionCurrency
    lodgingRequests
    lodgingAttachmentInfoId
    carServiceRequired
    carServiceReceiptDate
    carServiceTransactionAmount
    carServiceTransactionCurrency
    carServiceRequests
    carServiceAttachmentInfoId
    rentalCarRequired
    rentalCarReceiptDate
    rentalCarTransactionAmount
    rentalCarTransactionCurrency
    rentalCarUseFlightDate
    rentalCarPickUpDate
    rentalCarPickUpTime
    rentalCarDropOffDate
    rentalCarDropOffTime
    rentalCarLocation
    rentalCarCountry
    rentalCarRequests
    rentalCarAttachmentInfoId
    otherServiceRequired
    otherReceiptDate
    otherTransactionAmount
    otherTransactionCurrency
    otherRequests
    otherAttachmentInfoId
    travelRestrictions
    createdTimestamp
    lastEditTimestamp
    submittedTimestamp
    completedTimestamp
    submittingUserName
    completingUserName
    additionalDetails
    statusId
    travelTransaction {
      id
      label
      amount
      currency
      transactionDate
    }
    travelRequestTransferData {
      id
      pickupDateTime
      pickupAddress
      dropoffAddress
    }
    travelRequestCaregiver {
      caregiverId
      caregiver {
        id
        firstName
        middleName
        lastName
        relationship
        isPrimary
      }
      travelRequestId
      caregiverName
      isPrimary
      flightRequestTheSameAsPatient
      flightRequestDetailsId
      flightRequestDetails {
        id
        travelType
        airportOrigin
        airportDestination
        departureDate
        returnDate
        specialRequests
      }
      trainRequestTheSameAsPatient
      trainRequestDetailsId
      trainRequestDetails {
        id
        trainStationOrigin
        trainStationDestination
        departureDate
        returnDate
        specialRequests
        isRoundTrip
      }
    }
    travelerInstructions
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTravelRequestDetailedDataGQL extends Apollo.Query<GetTravelRequestDetailedDataQuery, GetTravelRequestDetailedDataQueryVariables> {
    override document = GetTravelRequestDetailedDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCarRentalPreferencesDocument = gql`
    query getCarRentalPreferences {
  currentPatient {
    patientData {
      rentalCarFrequentTravelerNum
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCarRentalPreferencesGQL extends Apollo.Query<GetCarRentalPreferencesQuery, GetCarRentalPreferencesQueryVariables> {
    override document = GetCarRentalPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCarServicePreferencesDocument = gql`
    query getCarServicePreferences {
  currentPatient {
    patientData {
      groundSpecialNeeds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCarServicePreferencesGQL extends Apollo.Query<GetCarServicePreferencesQuery, GetCarServicePreferencesQueryVariables> {
    override document = GetCarServicePreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightPreferencesDocument = gql`
    query getFlightPreferences {
  currentPatient {
    airlinePrimary
    airlineSecondary
    seatPreference
    patientData {
      airlineRewardsPrimary
      airlineRewardsSecondary
      knownTravelerNum
      airlineSpecialNeeds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightPreferencesGQL extends Apollo.Query<GetFlightPreferencesQuery, GetFlightPreferencesQueryVariables> {
    override document = GetFlightPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCaregiversDocument = gql`
    query getCaregivers {
  currentPatient {
    caregiver {
      id
      firstName
      middleName
      lastName
      relationship
      isPrimary
      isDeleted
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCaregiversGQL extends Apollo.Query<GetCaregiversQuery, GetCaregiversQueryVariables> {
    override document = GetCaregiversDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientDocument = gql`
    query getPatient {
  currentPatient {
    patientData {
      firstName
      middleName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientGQL extends Apollo.Query<GetPatientQuery, GetPatientQueryVariables> {
    override document = GetPatientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLodgingPreferencesDocument = gql`
    query getLodgingPreferences {
  currentPatient {
    hotelChainPrimary
    allergies
    patientData {
      lodgingRoomPreference
      lodgingSpecialNeeds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLodgingPreferencesGQL extends Apollo.Query<GetLodgingPreferencesQuery, GetLodgingPreferencesQueryVariables> {
    override document = GetLodgingPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveDraftTravelRequestDocument = gql`
    mutation saveDraftTravelRequest($dto: TravelRequestModelInput!) {
  saveDraftTravelRequest(input: {dto: $dto}) {
    travelRequest {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveDraftTravelRequestGQL extends Apollo.Mutation<SaveDraftTravelRequestMutation, SaveDraftTravelRequestMutationVariables> {
    override document = SaveDraftTravelRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitTravelRequestDocument = gql`
    mutation submitTravelRequest($dto: TravelRequestModelInput!) {
  submitTravelRequest(input: {dto: $dto}) {
    travelRequest {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitTravelRequestGQL extends Apollo.Mutation<SubmitTravelRequestMutation, SubmitTravelRequestMutationVariables> {
    override document = SubmitTravelRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTrainPreferencesDocument = gql`
    query getTrainPreferences {
  currentPatient {
    patientData {
      trainSpecialNeeds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTrainPreferencesGQL extends Apollo.Query<GetTrainPreferencesQuery, GetTrainPreferencesQueryVariables> {
    override document = GetTrainPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeLoggedPatientPasswordDocument = gql`
    mutation changeLoggedPatientPassword($input: ChangeLoggedPatientPasswordInput!) {
  changeLoggedPatientPassword(input: $input) {
    boolean
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeLoggedPatientPasswordGQL extends Apollo.Mutation<ChangeLoggedPatientPasswordMutation, ChangeLoggedPatientPasswordMutationVariables> {
    override document = ChangeLoggedPatientPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePatientUserLanguageDocument = gql`
    mutation changePatientUserLanguage($input: ChangePatientUserLanguageInput!) {
  changePatientUserLanguage(input: $input) {
    boolean
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePatientUserLanguageGQL extends Apollo.Mutation<ChangePatientUserLanguageMutation, ChangePatientUserLanguageMutationVariables> {
    override document = ChangePatientUserLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientUserNotificationsDocument = gql`
    query getPatientUserNotifications($templateIds: [String!]!) {
  patientUserNotifications(where: {templateId: {in: $templateIds}}) {
    nodes {
      id
      templateId
      allowPushNotification
      allowEmailNotification
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientUserNotificationsGQL extends Apollo.Query<GetPatientUserNotificationsQuery, GetPatientUserNotificationsQueryVariables> {
    override document = GetPatientUserNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetPatientUserNotificationsDocument = gql`
    mutation setPatientUserNotifications($input: SetPatientUserNotificationsInput!) {
  setPatientUserNotifications(input: $input) {
    boolean
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetPatientUserNotificationsGQL extends Apollo.Mutation<SetPatientUserNotificationsMutation, SetPatientUserNotificationsMutationVariables> {
    override document = SetPatientUserNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePasswordInResetPasswordScenarioDocument = gql`
    mutation changePasswordInResetPasswordScenario($input: ChangePasswordInPasswordResetScenarioInput!) {
  changePasswordInPasswordResetScenario(input: $input) {
    boolean
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePasswordInResetPasswordScenarioGQL extends Apollo.Mutation<ChangePasswordInResetPasswordScenarioMutation, ChangePasswordInResetPasswordScenarioMutationVariables> {
    override document = ChangePasswordInResetPasswordScenarioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePatientEditRequestDocument = gql`
    mutation deletePatientEditRequest {
  deletePatientEditRequest {
    successPatientEditRequestResponseDto {
      saveSuccessful
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePatientEditRequestGQL extends Apollo.Mutation<DeletePatientEditRequestMutation, DeletePatientEditRequestMutationVariables> {
    override document = DeletePatientEditRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditPatientDataDocument = gql`
    mutation editPatientData($input: EditPatientInput!) {
  editPatient(input: $input) {
    successPatientEditRequestResponseDto {
      saveSuccessful
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditPatientDataGQL extends Apollo.Mutation<EditPatientDataMutation, EditPatientDataMutationVariables> {
    override document = EditPatientDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PatientUserFcmTokenDocument = gql`
    query PatientUserFcmToken($deviceId: String!) {
  patientUserFcmToken(where: {deviceId: {eq: $deviceId}}) {
    id
    deviceId
    fcmToken
    fcmTokenExpirationDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PatientUserFcmTokenGQL extends Apollo.Query<PatientUserFcmTokenQuery, PatientUserFcmTokenQueryVariables> {
    override document = PatientUserFcmTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientVisitGroupIdDocument = gql`
    query getPatientVisitGroupId {
  currentPatient {
    patientData {
      visitGroupId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientVisitGroupIdGQL extends Apollo.Query<GetPatientVisitGroupIdQuery, GetPatientVisitGroupIdQueryVariables> {
    override document = GetPatientVisitGroupIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegistrationInfoDocument = gql`
    query getRegistrationInfo($accessRequestId: UUID!) {
  patientPortalAccessRequestById(id: $accessRequestId) {
    email
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegistrationInfoGQL extends Apollo.Query<GetRegistrationInfoQuery, GetRegistrationInfoQueryVariables> {
    override document = GetRegistrationInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSiteSupportTierDocument = gql`
    query getSiteSupportTier {
  currentPatient {
    site {
      travelServiceSupport
      reimbursementSupport
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSiteSupportTierGQL extends Apollo.Query<GetSiteSupportTierQuery, GetSiteSupportTierQueryVariables> {
    override document = GetSiteSupportTierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVisitNamesByVisitGroupIdDocument = gql`
    query getVisitNamesByVisitGroupId($visitGroupId: Int!) {
  visitNames(where: {visitGroupId: {eq: $visitGroupId}}) {
    nodes {
      id
      name
      sortOrder
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVisitNamesByVisitGroupIdGQL extends Apollo.Query<GetVisitNamesByVisitGroupIdQuery, GetVisitNamesByVisitGroupIdQueryVariables> {
    override document = GetVisitNamesByVisitGroupIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation login($input: LoginPatientInput!) {
  loginPatient(input: $input) {
    authResult {
      jwtAccessToken
      refreshToken
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    override document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogoutDocument = gql`
    mutation logout {
  logoutPatient {
    boolean
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogoutGQL extends Apollo.Mutation<LogoutMutation, LogoutMutationVariables> {
    override document = LogoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshTokenFromBodyDocument = gql`
    mutation refreshTokenFromBody($input: RefreshTokenFromBodyInput!) {
  refreshTokenFromBody(input: $input) {
    authResult {
      jwtAccessToken
      refreshToken
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshTokenFromBodyGQL extends Apollo.Mutation<RefreshTokenFromBodyMutation, RefreshTokenFromBodyMutationVariables> {
    override document = RefreshTokenFromBodyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshTokenFromCookieDocument = gql`
    mutation refreshTokenFromCookie {
  refreshTokenFromCookie {
    authResult {
      jwtAccessToken
      refreshToken
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshTokenFromCookieGQL extends Apollo.Mutation<RefreshTokenFromCookieMutation, RefreshTokenFromCookieMutationVariables> {
    override document = RefreshTokenFromCookieDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterPatientDocument = gql`
    mutation registerPatient($input: RegisterPatientInput!) {
  registerPatient(input: $input) {
    authResult {
      jwtAccessToken
      refreshToken
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterPatientGQL extends Apollo.Mutation<RegisterPatientMutation, RegisterPatientMutationVariables> {
    override document = RegisterPatientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemovePatientFcmTokenDocument = gql`
    mutation removePatientFcmToken($deviceId: String!) {
  removePatientFcmToken(input: {deviceId: $deviceId}) {
    boolean
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemovePatientFcmTokenGQL extends Apollo.Mutation<RemovePatientFcmTokenMutation, RemovePatientFcmTokenMutationVariables> {
    override document = RemovePatientFcmTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    boolean
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    override document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SavePatientUserFcmTokenDocument = gql`
    mutation savePatientUserFcmToken($dto: PatientUserFcmTokenDtoInput!) {
  savePatientUserFcmToken(input: {patientUserFcmTokenDto: $dto}) {
    boolean
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SavePatientUserFcmTokenGQL extends Apollo.Mutation<SavePatientUserFcmTokenMutation, SavePatientUserFcmTokenMutationVariables> {
    override document = SavePatientUserFcmTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitPatientEditRequestDocument = gql`
    mutation submitPatientEditRequest {
  submitPatientEditRequest {
    successPatientEditRequestResponseDto {
      saveSuccessful
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitPatientEditRequestGQL extends Apollo.Mutation<SubmitPatientEditRequestMutation, SubmitPatientEditRequestMutationVariables> {
    override document = SubmitPatientEditRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetPatientUserNotificationDefaultsDocument = gql`
    mutation SetPatientUserNotificationDefaults {
  setPatientUserNotificationDefaults {
    boolean
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetPatientUserNotificationDefaultsGQL extends Apollo.Mutation<SetPatientUserNotificationDefaultsMutation, SetPatientUserNotificationDefaultsMutationVariables> {
    override document = SetPatientUserNotificationDefaultsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountriesDocument = gql`
    query getCountries {
  countries {
    nodes {
      name
      threeCharCode
      isActive
      regionType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    override document = GetCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrenciesDocument = gql`
    query getCurrencies {
  currencies {
    nodes {
      isocode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrenciesGQL extends Apollo.Query<GetCurrenciesQuery, GetCurrenciesQueryVariables> {
    override document = GetCurrenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPatientSiteStatusDocument = gql`
    query getPatientSiteStatus {
  currentPatient {
    site {
      statusId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPatientSiteStatusGQL extends Apollo.Query<GetPatientSiteStatusQuery, GetPatientSiteStatusQueryVariables> {
    override document = GetPatientSiteStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStudyTravelOptionsDocument = gql`
    query getStudyTravelOptions {
  currentPatient {
    site {
      study {
        studyTravelOption {
          travelOption {
            name
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStudyTravelOptionsGQL extends Apollo.Query<GetStudyTravelOptionsQuery, GetStudyTravelOptionsQueryVariables> {
    override document = GetStudyTravelOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;





/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ActiveStudyExpenses: ResolverTypeWrapper<ActiveStudyExpenses>;
  ActiveStudyExpensesFilterInput: ActiveStudyExpensesFilterInput;
  ApplyPolicy: ApplyPolicy;
  AuthResult: ResolverTypeWrapper<AuthResult>;
  BooleanOperationFilterInput: BooleanOperationFilterInput;
  Byte: ResolverTypeWrapper<Scalars['Byte']['output']>;
  ByteOperationFilterInput: ByteOperationFilterInput;
  Caregiver: ResolverTypeWrapper<Caregiver>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  CaregiverEditRequest: ResolverTypeWrapper<CaregiverEditRequest>;
  CaregiverEditRequestDtoInput: CaregiverEditRequestDtoInput;
  CaregiverEditRequestFilterInput: CaregiverEditRequestFilterInput;
  CaregiverEditRequestSortInput: CaregiverEditRequestSortInput;
  CaregiverFilterInput: CaregiverFilterInput;
  CaregiverSortInput: CaregiverSortInput;
  CaregiversConnection: ResolverTypeWrapper<CaregiversConnection>;
  CaregiversEdge: ResolverTypeWrapper<CaregiversEdge>;
  ChangeLoggedPatientPasswordInput: ChangeLoggedPatientPasswordInput;
  ChangeLoggedPatientPasswordPayload: ResolverTypeWrapper<ChangeLoggedPatientPasswordPayload>;
  ChangePasswordInPasswordResetScenarioInput: ChangePasswordInPasswordResetScenarioInput;
  ChangePasswordInPasswordResetScenarioPayload: ResolverTypeWrapper<ChangePasswordInPasswordResetScenarioPayload>;
  ChangePatientUserLanguageInput: ChangePatientUserLanguageInput;
  ChangePatientUserLanguagePayload: ResolverTypeWrapper<ChangePatientUserLanguagePayload>;
  ClinTrakPatientVisit: ResolverTypeWrapper<ClinTrakPatientVisit>;
  ClinTrakPatientVisitFilterInput: ClinTrakPatientVisitFilterInput;
  ClinTrakVisitNamesConnection: ResolverTypeWrapper<ClinTrakVisitNamesConnection>;
  ClinTrakVisitNamesEdge: ResolverTypeWrapper<ClinTrakVisitNamesEdge>;
  CountriesConnection: ResolverTypeWrapper<CountriesConnection>;
  CountriesEdge: ResolverTypeWrapper<CountriesEdge>;
  Country: ResolverTypeWrapper<Country>;
  CountryFilterInput: CountryFilterInput;
  CountrySortInput: CountrySortInput;
  CurrenciesConnection: ResolverTypeWrapper<CurrenciesConnection>;
  CurrenciesEdge: ResolverTypeWrapper<CurrenciesEdge>;
  CurrencyInfo: ResolverTypeWrapper<CurrencyInfo>;
  CurrencyInfoFilterInput: CurrencyInfoFilterInput;
  CurrencyInfoSortInput: CurrencyInfoSortInput;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateOperationFilterInput: DateOperationFilterInput;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DateTimeOperationFilterInput: DateTimeOperationFilterInput;
  Decimal: ResolverTypeWrapper<Scalars['Decimal']['output']>;
  DecimalOperationFilterInput: DecimalOperationFilterInput;
  DeletePatientEditRequestPayload: ResolverTypeWrapper<DeletePatientEditRequestPayload>;
  EditPatientInput: EditPatientInput;
  EditPatientPayload: ResolverTypeWrapper<EditPatientPayload>;
  Expense: ResolverTypeWrapper<Expense>;
  ExpenseFilterInput: ExpenseFilterInput;
  ExpenseSortInput: ExpenseSortInput;
  ExpensesConnection: ResolverTypeWrapper<ExpensesConnection>;
  ExpensesEdge: ResolverTypeWrapper<ExpensesEdge>;
  FloatOperationFilterInput: FloatOperationFilterInput;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GetPatientPortalAccessRequestByIdResult: ResolverTypeWrapper<GetPatientPortalAccessRequestByIdResult>;
  IntOperationFilterInput: IntOperationFilterInput;
  ListFilterInputTypeOfCaregiverEditRequestFilterInput: ListFilterInputTypeOfCaregiverEditRequestFilterInput;
  ListFilterInputTypeOfCaregiverFilterInput: ListFilterInputTypeOfCaregiverFilterInput;
  ListFilterInputTypeOfClinTrakPatientVisitFilterInput: ListFilterInputTypeOfClinTrakPatientVisitFilterInput;
  ListFilterInputTypeOfNotificationSentFilterInput: ListFilterInputTypeOfNotificationSentFilterInput;
  ListFilterInputTypeOfPatientFilterInput: ListFilterInputTypeOfPatientFilterInput;
  ListFilterInputTypeOfPatientUserFcmTokenFilterInput: ListFilterInputTypeOfPatientUserFcmTokenFilterInput;
  ListFilterInputTypeOfPatientUserNotificationFilterInput: ListFilterInputTypeOfPatientUserNotificationFilterInput;
  ListFilterInputTypeOfReimbursementRequestApprovalStatusLogFilterInput: ListFilterInputTypeOfReimbursementRequestApprovalStatusLogFilterInput;
  ListFilterInputTypeOfReimbursementRequestFilterInput: ListFilterInputTypeOfReimbursementRequestFilterInput;
  ListFilterInputTypeOfReimbursementTransactionFilterInput: ListFilterInputTypeOfReimbursementTransactionFilterInput;
  ListFilterInputTypeOfSiteFilterInput: ListFilterInputTypeOfSiteFilterInput;
  ListFilterInputTypeOfStipendRequestFilterInput: ListFilterInputTypeOfStipendRequestFilterInput;
  ListFilterInputTypeOfStudyExpenseFilterInput: ListFilterInputTypeOfStudyExpenseFilterInput;
  ListFilterInputTypeOfStudyFilterInput: ListFilterInputTypeOfStudyFilterInput;
  ListFilterInputTypeOfStudyTravelOptionFilterInput: ListFilterInputTypeOfStudyTravelOptionFilterInput;
  ListFilterInputTypeOfTravelRequestApprovalStatusLogFilterInput: ListFilterInputTypeOfTravelRequestApprovalStatusLogFilterInput;
  ListFilterInputTypeOfTravelRequestCaregiverFilterInput: ListFilterInputTypeOfTravelRequestCaregiverFilterInput;
  ListFilterInputTypeOfTravelRequestFilterInput: ListFilterInputTypeOfTravelRequestFilterInput;
  ListFilterInputTypeOfTravelRequestSpendDataFilterInput: ListFilterInputTypeOfTravelRequestSpendDataFilterInput;
  ListFilterInputTypeOfTravelRequestTransferDataFilterInput: ListFilterInputTypeOfTravelRequestTransferDataFilterInput;
  ListFilterInputTypeOfTravelTransactionFilterInput: ListFilterInputTypeOfTravelTransactionFilterInput;
  ListFilterInputTypeOfVisitNameFilterInput: ListFilterInputTypeOfVisitNameFilterInput;
  ListFilterInputTypeOfVisitScheduleRequestItemFilterInput: ListFilterInputTypeOfVisitScheduleRequestItemFilterInput;
  LoginPatientInput: LoginPatientInput;
  LoginPatientPayload: ResolverTypeWrapper<LoginPatientPayload>;
  LogoutPatientPayload: ResolverTypeWrapper<LogoutPatientPayload>;
  MileageReimbursementRate: ResolverTypeWrapper<MileageReimbursementRate>;
  MileageReimbursementRateFilterInput: MileageReimbursementRateFilterInput;
  MileageReimbursementRateSortInput: MileageReimbursementRateSortInput;
  MileageReimbursementRatesConnection: ResolverTypeWrapper<MileageReimbursementRatesConnection>;
  MileageReimbursementRatesEdge: ResolverTypeWrapper<MileageReimbursementRatesEdge>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  NotificationSent: ResolverTypeWrapper<NotificationSent>;
  NotificationSentFilterInput: NotificationSentFilterInput;
  NotificationSentSortInput: NotificationSentSortInput;
  NotificationsSentConnection: ResolverTypeWrapper<NotificationsSentConnection>;
  NotificationsSentEdge: ResolverTypeWrapper<NotificationsSentEdge>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PasswordResetRequest: ResolverTypeWrapper<PasswordResetRequest>;
  PasswordResetRequestFilterInput: PasswordResetRequestFilterInput;
  PasswordResetRequestSortInput: PasswordResetRequestSortInput;
  Patient: ResolverTypeWrapper<Patient>;
  PatientCtsmStatusDto: ResolverTypeWrapper<PatientCtsmStatusDto>;
  PatientData: ResolverTypeWrapper<PatientData>;
  PatientDataConnection: ResolverTypeWrapper<PatientDataConnection>;
  PatientDataEdge: ResolverTypeWrapper<PatientDataEdge>;
  PatientDataFilterInput: PatientDataFilterInput;
  PatientDataSortInput: PatientDataSortInput;
  PatientEditRequest: ResolverTypeWrapper<PatientEditRequest>;
  PatientEditRequestDtoInput: PatientEditRequestDtoInput;
  PatientEditRequestFilterInput: PatientEditRequestFilterInput;
  PatientEditRequestSortInput: PatientEditRequestSortInput;
  PatientFilterInput: PatientFilterInput;
  PatientPaymentDetails: ResolverTypeWrapper<PatientPaymentDetails>;
  PatientPaymentDetailsConnection: ResolverTypeWrapper<PatientPaymentDetailsConnection>;
  PatientPaymentDetailsEdge: ResolverTypeWrapper<PatientPaymentDetailsEdge>;
  PatientPaymentDetailsFilterInput: PatientPaymentDetailsFilterInput;
  PatientPaymentDetailsSortInput: PatientPaymentDetailsSortInput;
  PatientPortalAccessRequest: ResolverTypeWrapper<PatientPortalAccessRequest>;
  PatientPortalAccessRequestFilterInput: PatientPortalAccessRequestFilterInput;
  PatientPortalAccessRequestSortInput: PatientPortalAccessRequestSortInput;
  PatientSortInput: PatientSortInput;
  PatientStatus: ResolverTypeWrapper<PatientStatus>;
  PatientStatusFilterInput: PatientStatusFilterInput;
  PatientStatusSortInput: PatientStatusSortInput;
  PatientStatusesConnection: ResolverTypeWrapper<PatientStatusesConnection>;
  PatientStatusesEdge: ResolverTypeWrapper<PatientStatusesEdge>;
  PatientUser: ResolverTypeWrapper<PatientUser>;
  PatientUserFcmToken: ResolverTypeWrapper<PatientUserFcmToken>;
  PatientUserFcmTokenDtoInput: PatientUserFcmTokenDtoInput;
  PatientUserFcmTokenFilterInput: PatientUserFcmTokenFilterInput;
  PatientUserFilterInput: PatientUserFilterInput;
  PatientUserNotification: ResolverTypeWrapper<PatientUserNotification>;
  PatientUserNotificationDtoInput: PatientUserNotificationDtoInput;
  PatientUserNotificationFilterInput: PatientUserNotificationFilterInput;
  PatientUserNotificationSortInput: PatientUserNotificationSortInput;
  PatientUserNotificationsConnection: ResolverTypeWrapper<PatientUserNotificationsConnection>;
  PatientUserNotificationsEdge: ResolverTypeWrapper<PatientUserNotificationsEdge>;
  PatientUserPassword: ResolverTypeWrapper<PatientUserPassword>;
  PatientUserPasswordFilterInput: PatientUserPasswordFilterInput;
  PatientUserPasswordSortInput: PatientUserPasswordSortInput;
  PatientUserSortInput: PatientUserSortInput;
  PatientVisit: ResolverTypeWrapper<PatientVisit>;
  PatientVisitFilterInput: PatientVisitFilterInput;
  PatientVisitSortInput: PatientVisitSortInput;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  RefreshTokenFilterInput: RefreshTokenFilterInput;
  RefreshTokenFromBodyInput: RefreshTokenFromBodyInput;
  RefreshTokenFromBodyPayload: ResolverTypeWrapper<RefreshTokenFromBodyPayload>;
  RefreshTokenFromCookiePayload: ResolverTypeWrapper<RefreshTokenFromCookiePayload>;
  RefreshTokenSortInput: RefreshTokenSortInput;
  RegisterPatientInput: RegisterPatientInput;
  RegisterPatientPayload: ResolverTypeWrapper<RegisterPatientPayload>;
  ReimbursementRequest: ResolverTypeWrapper<ReimbursementRequest>;
  ReimbursementRequestApprovalStatusLog: ResolverTypeWrapper<ReimbursementRequestApprovalStatusLog>;
  ReimbursementRequestApprovalStatusLogFilterInput: ReimbursementRequestApprovalStatusLogFilterInput;
  ReimbursementRequestDtoInput: ReimbursementRequestDtoInput;
  ReimbursementRequestFilterInput: ReimbursementRequestFilterInput;
  ReimbursementRequestSortInput: ReimbursementRequestSortInput;
  ReimbursementRequestsConnection: ResolverTypeWrapper<ReimbursementRequestsConnection>;
  ReimbursementRequestsEdge: ResolverTypeWrapper<ReimbursementRequestsEdge>;
  ReimbursementTransaction: ResolverTypeWrapper<ReimbursementTransaction>;
  ReimbursementTransactionDtoInput: ReimbursementTransactionDtoInput;
  ReimbursementTransactionFilterInput: ReimbursementTransactionFilterInput;
  RemovePatientFcmTokenInput: RemovePatientFcmTokenInput;
  RemovePatientFcmTokenPayload: ResolverTypeWrapper<RemovePatientFcmTokenPayload>;
  ResetPasswordInput: ResetPasswordInput;
  ResetPasswordPayload: ResolverTypeWrapper<ResetPasswordPayload>;
  SaveDraftReimbursementRequestInput: SaveDraftReimbursementRequestInput;
  SaveDraftReimbursementRequestPayload: ResolverTypeWrapper<SaveDraftReimbursementRequestPayload>;
  SaveDraftTravelRequestInput: SaveDraftTravelRequestInput;
  SaveDraftTravelRequestPayload: ResolverTypeWrapper<SaveDraftTravelRequestPayload>;
  SavePatientUserFcmTokenInput: SavePatientUserFcmTokenInput;
  SavePatientUserFcmTokenPayload: ResolverTypeWrapper<SavePatientUserFcmTokenPayload>;
  SetPatientUserNotificationDefaultsPayload: ResolverTypeWrapper<SetPatientUserNotificationDefaultsPayload>;
  SetPatientUserNotificationsInput: SetPatientUserNotificationsInput;
  SetPatientUserNotificationsPayload: ResolverTypeWrapper<SetPatientUserNotificationsPayload>;
  Short: ResolverTypeWrapper<Scalars['Short']['output']>;
  ShortOperationFilterInput: ShortOperationFilterInput;
  Site: ResolverTypeWrapper<Site>;
  SiteFilterInput: SiteFilterInput;
  SiteSortInput: SiteSortInput;
  SitesConnection: ResolverTypeWrapper<SitesConnection>;
  SitesEdge: ResolverTypeWrapper<SitesEdge>;
  SortEnumType: SortEnumType;
  StipendRequest: ResolverTypeWrapper<StipendRequest>;
  StipendRequestFilterInput: StipendRequestFilterInput;
  StipendRequestSortInput: StipendRequestSortInput;
  StipendRequestsConnection: ResolverTypeWrapper<StipendRequestsConnection>;
  StipendRequestsEdge: ResolverTypeWrapper<StipendRequestsEdge>;
  StringOperationFilterInput: StringOperationFilterInput;
  StudiesConnection: ResolverTypeWrapper<StudiesConnection>;
  StudiesEdge: ResolverTypeWrapper<StudiesEdge>;
  Study: ResolverTypeWrapper<Study>;
  StudyExpense: ResolverTypeWrapper<StudyExpense>;
  StudyExpenseFilterInput: StudyExpenseFilterInput;
  StudyExpenseSortInput: StudyExpenseSortInput;
  StudyExpensesConnection: ResolverTypeWrapper<StudyExpensesConnection>;
  StudyExpensesEdge: ResolverTypeWrapper<StudyExpensesEdge>;
  StudyFilterInput: StudyFilterInput;
  StudyLogoInfo: ResolverTypeWrapper<StudyLogoInfo>;
  StudyLogoInfoFilterInput: StudyLogoInfoFilterInput;
  StudyLogoInfoSortInput: StudyLogoInfoSortInput;
  StudySortInput: StudySortInput;
  StudyTravelOption: ResolverTypeWrapper<StudyTravelOption>;
  StudyTravelOptionFilterInput: StudyTravelOptionFilterInput;
  SubmitPatientEditRequestPayload: ResolverTypeWrapper<SubmitPatientEditRequestPayload>;
  SubmitReimbursementRequestInput: SubmitReimbursementRequestInput;
  SubmitReimbursementRequestPayload: ResolverTypeWrapper<SubmitReimbursementRequestPayload>;
  SubmitTravelRequestInput: SubmitTravelRequestInput;
  SubmitTravelRequestPayload: ResolverTypeWrapper<SubmitTravelRequestPayload>;
  SuccessPatientEditRequestResponseDto: ResolverTypeWrapper<SuccessPatientEditRequestResponseDto>;
  TransactionAttachmentInfo: ResolverTypeWrapper<TransactionAttachmentInfo>;
  TransactionAttachmentInfoFilterInput: TransactionAttachmentInfoFilterInput;
  TravelOption: ResolverTypeWrapper<TravelOption>;
  TravelOptionFilterInput: TravelOptionFilterInput;
  TravelRequest: ResolverTypeWrapper<TravelRequest>;
  TravelRequestApprovalStatusLog: ResolverTypeWrapper<TravelRequestApprovalStatusLog>;
  TravelRequestApprovalStatusLogFilterInput: TravelRequestApprovalStatusLogFilterInput;
  TravelRequestCaregiver: ResolverTypeWrapper<TravelRequestCaregiver>;
  TravelRequestCaregiverFilterInput: TravelRequestCaregiverFilterInput;
  TravelRequestCaregiverModelInput: TravelRequestCaregiverModelInput;
  TravelRequestFilterInput: TravelRequestFilterInput;
  TravelRequestFlightTravelDetails: ResolverTypeWrapper<TravelRequestFlightTravelDetails>;
  TravelRequestFlightTravelDetailsFilterInput: TravelRequestFlightTravelDetailsFilterInput;
  TravelRequestFlightTravelDetailsModelInput: TravelRequestFlightTravelDetailsModelInput;
  TravelRequestFlightTravelDetailsSortInput: TravelRequestFlightTravelDetailsSortInput;
  TravelRequestModelInput: TravelRequestModelInput;
  TravelRequestSortInput: TravelRequestSortInput;
  TravelRequestSpendData: ResolverTypeWrapper<TravelRequestSpendData>;
  TravelRequestSpendDataFilterInput: TravelRequestSpendDataFilterInput;
  TravelRequestTrainTravelDetails: ResolverTypeWrapper<TravelRequestTrainTravelDetails>;
  TravelRequestTrainTravelDetailsFilterInput: TravelRequestTrainTravelDetailsFilterInput;
  TravelRequestTrainTravelDetailsModelInput: TravelRequestTrainTravelDetailsModelInput;
  TravelRequestTrainTravelDetailsSortInput: TravelRequestTrainTravelDetailsSortInput;
  TravelRequestTransferData: ResolverTypeWrapper<TravelRequestTransferData>;
  TravelRequestTransferDataFilterInput: TravelRequestTransferDataFilterInput;
  TravelRequestTransferDataModelInput: TravelRequestTransferDataModelInput;
  TravelRequestsConnection: ResolverTypeWrapper<TravelRequestsConnection>;
  TravelRequestsEdge: ResolverTypeWrapper<TravelRequestsEdge>;
  TravelTransaction: ResolverTypeWrapper<TravelTransaction>;
  TravelTransactionFilterInput: TravelTransactionFilterInput;
  UUID: ResolverTypeWrapper<Scalars['UUID']['output']>;
  UuidOperationFilterInput: UuidOperationFilterInput;
  VisitName: ResolverTypeWrapper<VisitName>;
  VisitNameFilterInput: VisitNameFilterInput;
  VisitNameSortInput: VisitNameSortInput;
  VisitNamesConnection: ResolverTypeWrapper<VisitNamesConnection>;
  VisitNamesEdge: ResolverTypeWrapper<VisitNamesEdge>;
  VisitScheduleRequestItem: ResolverTypeWrapper<VisitScheduleRequestItem>;
  VisitScheduleRequestItemFilterInput: VisitScheduleRequestItemFilterInput;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ActiveStudyExpenses: ActiveStudyExpenses;
  ActiveStudyExpensesFilterInput: ActiveStudyExpensesFilterInput;
  AuthResult: AuthResult;
  BooleanOperationFilterInput: BooleanOperationFilterInput;
  Byte: Scalars['Byte']['output'];
  ByteOperationFilterInput: ByteOperationFilterInput;
  Caregiver: Caregiver;
  ID: Scalars['ID']['output'];
  CaregiverEditRequest: CaregiverEditRequest;
  CaregiverEditRequestDtoInput: CaregiverEditRequestDtoInput;
  CaregiverEditRequestFilterInput: CaregiverEditRequestFilterInput;
  CaregiverEditRequestSortInput: CaregiverEditRequestSortInput;
  CaregiverFilterInput: CaregiverFilterInput;
  CaregiverSortInput: CaregiverSortInput;
  CaregiversConnection: CaregiversConnection;
  CaregiversEdge: CaregiversEdge;
  ChangeLoggedPatientPasswordInput: ChangeLoggedPatientPasswordInput;
  ChangeLoggedPatientPasswordPayload: ChangeLoggedPatientPasswordPayload;
  ChangePasswordInPasswordResetScenarioInput: ChangePasswordInPasswordResetScenarioInput;
  ChangePasswordInPasswordResetScenarioPayload: ChangePasswordInPasswordResetScenarioPayload;
  ChangePatientUserLanguageInput: ChangePatientUserLanguageInput;
  ChangePatientUserLanguagePayload: ChangePatientUserLanguagePayload;
  ClinTrakPatientVisit: ClinTrakPatientVisit;
  ClinTrakPatientVisitFilterInput: ClinTrakPatientVisitFilterInput;
  ClinTrakVisitNamesConnection: ClinTrakVisitNamesConnection;
  ClinTrakVisitNamesEdge: ClinTrakVisitNamesEdge;
  CountriesConnection: CountriesConnection;
  CountriesEdge: CountriesEdge;
  Country: Country;
  CountryFilterInput: CountryFilterInput;
  CountrySortInput: CountrySortInput;
  CurrenciesConnection: CurrenciesConnection;
  CurrenciesEdge: CurrenciesEdge;
  CurrencyInfo: CurrencyInfo;
  CurrencyInfoFilterInput: CurrencyInfoFilterInput;
  CurrencyInfoSortInput: CurrencyInfoSortInput;
  Date: Scalars['Date']['output'];
  DateOperationFilterInput: DateOperationFilterInput;
  DateTime: Scalars['DateTime']['output'];
  DateTimeOperationFilterInput: DateTimeOperationFilterInput;
  Decimal: Scalars['Decimal']['output'];
  DecimalOperationFilterInput: DecimalOperationFilterInput;
  DeletePatientEditRequestPayload: DeletePatientEditRequestPayload;
  EditPatientInput: EditPatientInput;
  EditPatientPayload: EditPatientPayload;
  Expense: Expense;
  ExpenseFilterInput: ExpenseFilterInput;
  ExpenseSortInput: ExpenseSortInput;
  ExpensesConnection: ExpensesConnection;
  ExpensesEdge: ExpensesEdge;
  FloatOperationFilterInput: FloatOperationFilterInput;
  Float: Scalars['Float']['output'];
  GetPatientPortalAccessRequestByIdResult: GetPatientPortalAccessRequestByIdResult;
  IntOperationFilterInput: IntOperationFilterInput;
  ListFilterInputTypeOfCaregiverEditRequestFilterInput: ListFilterInputTypeOfCaregiverEditRequestFilterInput;
  ListFilterInputTypeOfCaregiverFilterInput: ListFilterInputTypeOfCaregiverFilterInput;
  ListFilterInputTypeOfClinTrakPatientVisitFilterInput: ListFilterInputTypeOfClinTrakPatientVisitFilterInput;
  ListFilterInputTypeOfNotificationSentFilterInput: ListFilterInputTypeOfNotificationSentFilterInput;
  ListFilterInputTypeOfPatientFilterInput: ListFilterInputTypeOfPatientFilterInput;
  ListFilterInputTypeOfPatientUserFcmTokenFilterInput: ListFilterInputTypeOfPatientUserFcmTokenFilterInput;
  ListFilterInputTypeOfPatientUserNotificationFilterInput: ListFilterInputTypeOfPatientUserNotificationFilterInput;
  ListFilterInputTypeOfReimbursementRequestApprovalStatusLogFilterInput: ListFilterInputTypeOfReimbursementRequestApprovalStatusLogFilterInput;
  ListFilterInputTypeOfReimbursementRequestFilterInput: ListFilterInputTypeOfReimbursementRequestFilterInput;
  ListFilterInputTypeOfReimbursementTransactionFilterInput: ListFilterInputTypeOfReimbursementTransactionFilterInput;
  ListFilterInputTypeOfSiteFilterInput: ListFilterInputTypeOfSiteFilterInput;
  ListFilterInputTypeOfStipendRequestFilterInput: ListFilterInputTypeOfStipendRequestFilterInput;
  ListFilterInputTypeOfStudyExpenseFilterInput: ListFilterInputTypeOfStudyExpenseFilterInput;
  ListFilterInputTypeOfStudyFilterInput: ListFilterInputTypeOfStudyFilterInput;
  ListFilterInputTypeOfStudyTravelOptionFilterInput: ListFilterInputTypeOfStudyTravelOptionFilterInput;
  ListFilterInputTypeOfTravelRequestApprovalStatusLogFilterInput: ListFilterInputTypeOfTravelRequestApprovalStatusLogFilterInput;
  ListFilterInputTypeOfTravelRequestCaregiverFilterInput: ListFilterInputTypeOfTravelRequestCaregiverFilterInput;
  ListFilterInputTypeOfTravelRequestFilterInput: ListFilterInputTypeOfTravelRequestFilterInput;
  ListFilterInputTypeOfTravelRequestSpendDataFilterInput: ListFilterInputTypeOfTravelRequestSpendDataFilterInput;
  ListFilterInputTypeOfTravelRequestTransferDataFilterInput: ListFilterInputTypeOfTravelRequestTransferDataFilterInput;
  ListFilterInputTypeOfTravelTransactionFilterInput: ListFilterInputTypeOfTravelTransactionFilterInput;
  ListFilterInputTypeOfVisitNameFilterInput: ListFilterInputTypeOfVisitNameFilterInput;
  ListFilterInputTypeOfVisitScheduleRequestItemFilterInput: ListFilterInputTypeOfVisitScheduleRequestItemFilterInput;
  LoginPatientInput: LoginPatientInput;
  LoginPatientPayload: LoginPatientPayload;
  LogoutPatientPayload: LogoutPatientPayload;
  MileageReimbursementRate: MileageReimbursementRate;
  MileageReimbursementRateFilterInput: MileageReimbursementRateFilterInput;
  MileageReimbursementRateSortInput: MileageReimbursementRateSortInput;
  MileageReimbursementRatesConnection: MileageReimbursementRatesConnection;
  MileageReimbursementRatesEdge: MileageReimbursementRatesEdge;
  Mutation: Record<PropertyKey, never>;
  NotificationSent: NotificationSent;
  NotificationSentFilterInput: NotificationSentFilterInput;
  NotificationSentSortInput: NotificationSentSortInput;
  NotificationsSentConnection: NotificationsSentConnection;
  NotificationsSentEdge: NotificationsSentEdge;
  PageInfo: PageInfo;
  PasswordResetRequest: PasswordResetRequest;
  PasswordResetRequestFilterInput: PasswordResetRequestFilterInput;
  PasswordResetRequestSortInput: PasswordResetRequestSortInput;
  Patient: Patient;
  PatientCtsmStatusDto: PatientCtsmStatusDto;
  PatientData: PatientData;
  PatientDataConnection: PatientDataConnection;
  PatientDataEdge: PatientDataEdge;
  PatientDataFilterInput: PatientDataFilterInput;
  PatientDataSortInput: PatientDataSortInput;
  PatientEditRequest: PatientEditRequest;
  PatientEditRequestDtoInput: PatientEditRequestDtoInput;
  PatientEditRequestFilterInput: PatientEditRequestFilterInput;
  PatientEditRequestSortInput: PatientEditRequestSortInput;
  PatientFilterInput: PatientFilterInput;
  PatientPaymentDetails: PatientPaymentDetails;
  PatientPaymentDetailsConnection: PatientPaymentDetailsConnection;
  PatientPaymentDetailsEdge: PatientPaymentDetailsEdge;
  PatientPaymentDetailsFilterInput: PatientPaymentDetailsFilterInput;
  PatientPaymentDetailsSortInput: PatientPaymentDetailsSortInput;
  PatientPortalAccessRequest: PatientPortalAccessRequest;
  PatientPortalAccessRequestFilterInput: PatientPortalAccessRequestFilterInput;
  PatientPortalAccessRequestSortInput: PatientPortalAccessRequestSortInput;
  PatientSortInput: PatientSortInput;
  PatientStatus: PatientStatus;
  PatientStatusFilterInput: PatientStatusFilterInput;
  PatientStatusSortInput: PatientStatusSortInput;
  PatientStatusesConnection: PatientStatusesConnection;
  PatientStatusesEdge: PatientStatusesEdge;
  PatientUser: PatientUser;
  PatientUserFcmToken: PatientUserFcmToken;
  PatientUserFcmTokenDtoInput: PatientUserFcmTokenDtoInput;
  PatientUserFcmTokenFilterInput: PatientUserFcmTokenFilterInput;
  PatientUserFilterInput: PatientUserFilterInput;
  PatientUserNotification: PatientUserNotification;
  PatientUserNotificationDtoInput: PatientUserNotificationDtoInput;
  PatientUserNotificationFilterInput: PatientUserNotificationFilterInput;
  PatientUserNotificationSortInput: PatientUserNotificationSortInput;
  PatientUserNotificationsConnection: PatientUserNotificationsConnection;
  PatientUserNotificationsEdge: PatientUserNotificationsEdge;
  PatientUserPassword: PatientUserPassword;
  PatientUserPasswordFilterInput: PatientUserPasswordFilterInput;
  PatientUserPasswordSortInput: PatientUserPasswordSortInput;
  PatientUserSortInput: PatientUserSortInput;
  PatientVisit: PatientVisit;
  PatientVisitFilterInput: PatientVisitFilterInput;
  PatientVisitSortInput: PatientVisitSortInput;
  Query: Record<PropertyKey, never>;
  RefreshTokenFilterInput: RefreshTokenFilterInput;
  RefreshTokenFromBodyInput: RefreshTokenFromBodyInput;
  RefreshTokenFromBodyPayload: RefreshTokenFromBodyPayload;
  RefreshTokenFromCookiePayload: RefreshTokenFromCookiePayload;
  RefreshTokenSortInput: RefreshTokenSortInput;
  RegisterPatientInput: RegisterPatientInput;
  RegisterPatientPayload: RegisterPatientPayload;
  ReimbursementRequest: ReimbursementRequest;
  ReimbursementRequestApprovalStatusLog: ReimbursementRequestApprovalStatusLog;
  ReimbursementRequestApprovalStatusLogFilterInput: ReimbursementRequestApprovalStatusLogFilterInput;
  ReimbursementRequestDtoInput: ReimbursementRequestDtoInput;
  ReimbursementRequestFilterInput: ReimbursementRequestFilterInput;
  ReimbursementRequestSortInput: ReimbursementRequestSortInput;
  ReimbursementRequestsConnection: ReimbursementRequestsConnection;
  ReimbursementRequestsEdge: ReimbursementRequestsEdge;
  ReimbursementTransaction: ReimbursementTransaction;
  ReimbursementTransactionDtoInput: ReimbursementTransactionDtoInput;
  ReimbursementTransactionFilterInput: ReimbursementTransactionFilterInput;
  RemovePatientFcmTokenInput: RemovePatientFcmTokenInput;
  RemovePatientFcmTokenPayload: RemovePatientFcmTokenPayload;
  ResetPasswordInput: ResetPasswordInput;
  ResetPasswordPayload: ResetPasswordPayload;
  SaveDraftReimbursementRequestInput: SaveDraftReimbursementRequestInput;
  SaveDraftReimbursementRequestPayload: SaveDraftReimbursementRequestPayload;
  SaveDraftTravelRequestInput: SaveDraftTravelRequestInput;
  SaveDraftTravelRequestPayload: SaveDraftTravelRequestPayload;
  SavePatientUserFcmTokenInput: SavePatientUserFcmTokenInput;
  SavePatientUserFcmTokenPayload: SavePatientUserFcmTokenPayload;
  SetPatientUserNotificationDefaultsPayload: SetPatientUserNotificationDefaultsPayload;
  SetPatientUserNotificationsInput: SetPatientUserNotificationsInput;
  SetPatientUserNotificationsPayload: SetPatientUserNotificationsPayload;
  Short: Scalars['Short']['output'];
  ShortOperationFilterInput: ShortOperationFilterInput;
  Site: Site;
  SiteFilterInput: SiteFilterInput;
  SiteSortInput: SiteSortInput;
  SitesConnection: SitesConnection;
  SitesEdge: SitesEdge;
  StipendRequest: StipendRequest;
  StipendRequestFilterInput: StipendRequestFilterInput;
  StipendRequestSortInput: StipendRequestSortInput;
  StipendRequestsConnection: StipendRequestsConnection;
  StipendRequestsEdge: StipendRequestsEdge;
  StringOperationFilterInput: StringOperationFilterInput;
  StudiesConnection: StudiesConnection;
  StudiesEdge: StudiesEdge;
  Study: Study;
  StudyExpense: StudyExpense;
  StudyExpenseFilterInput: StudyExpenseFilterInput;
  StudyExpenseSortInput: StudyExpenseSortInput;
  StudyExpensesConnection: StudyExpensesConnection;
  StudyExpensesEdge: StudyExpensesEdge;
  StudyFilterInput: StudyFilterInput;
  StudyLogoInfo: StudyLogoInfo;
  StudyLogoInfoFilterInput: StudyLogoInfoFilterInput;
  StudyLogoInfoSortInput: StudyLogoInfoSortInput;
  StudySortInput: StudySortInput;
  StudyTravelOption: StudyTravelOption;
  StudyTravelOptionFilterInput: StudyTravelOptionFilterInput;
  SubmitPatientEditRequestPayload: SubmitPatientEditRequestPayload;
  SubmitReimbursementRequestInput: SubmitReimbursementRequestInput;
  SubmitReimbursementRequestPayload: SubmitReimbursementRequestPayload;
  SubmitTravelRequestInput: SubmitTravelRequestInput;
  SubmitTravelRequestPayload: SubmitTravelRequestPayload;
  SuccessPatientEditRequestResponseDto: SuccessPatientEditRequestResponseDto;
  TransactionAttachmentInfo: TransactionAttachmentInfo;
  TransactionAttachmentInfoFilterInput: TransactionAttachmentInfoFilterInput;
  TravelOption: TravelOption;
  TravelOptionFilterInput: TravelOptionFilterInput;
  TravelRequest: TravelRequest;
  TravelRequestApprovalStatusLog: TravelRequestApprovalStatusLog;
  TravelRequestApprovalStatusLogFilterInput: TravelRequestApprovalStatusLogFilterInput;
  TravelRequestCaregiver: TravelRequestCaregiver;
  TravelRequestCaregiverFilterInput: TravelRequestCaregiverFilterInput;
  TravelRequestCaregiverModelInput: TravelRequestCaregiverModelInput;
  TravelRequestFilterInput: TravelRequestFilterInput;
  TravelRequestFlightTravelDetails: TravelRequestFlightTravelDetails;
  TravelRequestFlightTravelDetailsFilterInput: TravelRequestFlightTravelDetailsFilterInput;
  TravelRequestFlightTravelDetailsModelInput: TravelRequestFlightTravelDetailsModelInput;
  TravelRequestFlightTravelDetailsSortInput: TravelRequestFlightTravelDetailsSortInput;
  TravelRequestModelInput: TravelRequestModelInput;
  TravelRequestSortInput: TravelRequestSortInput;
  TravelRequestSpendData: TravelRequestSpendData;
  TravelRequestSpendDataFilterInput: TravelRequestSpendDataFilterInput;
  TravelRequestTrainTravelDetails: TravelRequestTrainTravelDetails;
  TravelRequestTrainTravelDetailsFilterInput: TravelRequestTrainTravelDetailsFilterInput;
  TravelRequestTrainTravelDetailsModelInput: TravelRequestTrainTravelDetailsModelInput;
  TravelRequestTrainTravelDetailsSortInput: TravelRequestTrainTravelDetailsSortInput;
  TravelRequestTransferData: TravelRequestTransferData;
  TravelRequestTransferDataFilterInput: TravelRequestTransferDataFilterInput;
  TravelRequestTransferDataModelInput: TravelRequestTransferDataModelInput;
  TravelRequestsConnection: TravelRequestsConnection;
  TravelRequestsEdge: TravelRequestsEdge;
  TravelTransaction: TravelTransaction;
  TravelTransactionFilterInput: TravelTransactionFilterInput;
  UUID: Scalars['UUID']['output'];
  UuidOperationFilterInput: UuidOperationFilterInput;
  VisitName: VisitName;
  VisitNameFilterInput: VisitNameFilterInput;
  VisitNameSortInput: VisitNameSortInput;
  VisitNamesConnection: VisitNamesConnection;
  VisitNamesEdge: VisitNamesEdge;
  VisitScheduleRequestItem: VisitScheduleRequestItem;
  VisitScheduleRequestItemFilterInput: VisitScheduleRequestItemFilterInput;
  String: Scalars['String']['output'];
  Int: Scalars['Int']['output'];
  Boolean: Scalars['Boolean']['output'];
};

export type CostDirectiveArgs = {
  weight: Scalars['String']['input'];
};

export type CostDirectiveResolver<Result, Parent, ContextType = any, Args = CostDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ListSizeDirectiveArgs = {
  assumedSize?: Maybe<Scalars['Int']['input']>;
  requireOneSlicingArgument?: Scalars['Boolean']['input'];
  sizedFields?: Maybe<Array<Scalars['String']['input']>>;
  slicingArguments?: Maybe<Array<Scalars['String']['input']>>;
};

export type ListSizeDirectiveResolver<Result, Parent, ContextType = any, Args = ListSizeDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type NgModuleDirectiveArgs = {
  module: Scalars['String']['input'];
};

export type NgModuleDirectiveResolver<Result, Parent, ContextType = any, Args = NgModuleDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type NamedClientDirectiveArgs = {
  name: Scalars['String']['input'];
};

export type NamedClientDirectiveResolver<Result, Parent, ContextType = any, Args = NamedClientDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ActiveStudyExpensesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveStudyExpenses'] = ResolversParentTypes['ActiveStudyExpenses']> = {
  expenseId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  expenseKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  studyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type AuthResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthResult'] = ResolversParentTypes['AuthResult']> = {
  jwtAccessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export interface ByteScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Byte'], any> {
  name: 'Byte';
}

export type CaregiverResolvers<ContextType = any, ParentType extends ResolversParentTypes['Caregiver'] = ResolversParentTypes['Caregiver']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressSameAsPatient?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  caregiverEditRequest?: Resolver<Maybe<ResolversTypes['CaregiverEditRequest']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passportCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passportExpiration?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  passportIssue?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  passportNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredLang?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  relationship?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  travelRequestCaregiver?: Resolver<Array<ResolversTypes['TravelRequestCaregiver']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CaregiverEditRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaregiverEditRequest'] = ResolversParentTypes['CaregiverEditRequest']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressSameAsPatient?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  caregiver?: Resolver<ResolversTypes['Caregiver'], ParentType, ContextType>;
  caregiverId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passportCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passportExpiration?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  passportIssue?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  passportNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patientEditRequest?: Resolver<ResolversTypes['PatientEditRequest'], ParentType, ContextType>;
  patientEditRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredLang?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CaregiversConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaregiversConnection'] = ResolversParentTypes['CaregiversConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['CaregiversEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Caregiver']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CaregiversEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaregiversEdge'] = ResolversParentTypes['CaregiversEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Caregiver'], ParentType, ContextType>;
};

export type ChangeLoggedPatientPasswordPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeLoggedPatientPasswordPayload'] = ResolversParentTypes['ChangeLoggedPatientPasswordPayload']> = {
  boolean?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ChangePasswordInPasswordResetScenarioPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangePasswordInPasswordResetScenarioPayload'] = ResolversParentTypes['ChangePasswordInPasswordResetScenarioPayload']> = {
  boolean?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ChangePatientUserLanguagePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangePatientUserLanguagePayload'] = ResolversParentTypes['ChangePatientUserLanguagePayload']> = {
  boolean?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ClinTrakPatientVisitResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClinTrakPatientVisit'] = ResolversParentTypes['ClinTrakPatientVisit']> = {
  actualDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  patientVisitId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  patientVisitMasterId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  scheduledDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  statusAbbreviation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ClinTrakVisitNamesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClinTrakVisitNamesConnection'] = ResolversParentTypes['ClinTrakVisitNamesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ClinTrakVisitNamesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['PatientVisit']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ClinTrakVisitNamesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClinTrakVisitNamesEdge'] = ResolversParentTypes['ClinTrakVisitNamesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PatientVisit'], ParentType, ContextType>;
};

export type CountriesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountriesConnection'] = ResolversParentTypes['CountriesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['CountriesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Country']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CountriesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountriesEdge'] = ResolversParentTypes['CountriesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
};

export type CountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Country'] = ResolversParentTypes['Country']> = {
  currencyIsoCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  regionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  threeCharCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CurrenciesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrenciesConnection'] = ResolversParentTypes['CurrenciesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['CurrenciesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['CurrencyInfo']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CurrenciesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrenciesEdge'] = ResolversParentTypes['CurrenciesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CurrencyInfo'], ParentType, ContextType>;
};

export type CurrencyInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyInfo'] = ResolversParentTypes['CurrencyInfo']> = {
  decimalPlaces?: Resolver<ResolversTypes['Byte'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isocode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isoid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Short'], ParentType, ContextType>;
  symbolDecimal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  symbolHex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export interface DecimalScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Decimal'], any> {
  name: 'Decimal';
}

export type DeletePatientEditRequestPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePatientEditRequestPayload'] = ResolversParentTypes['DeletePatientEditRequestPayload']> = {
  successPatientEditRequestResponseDto?: Resolver<Maybe<ResolversTypes['SuccessPatientEditRequestResponseDto']>, ParentType, ContextType>;
};

export type EditPatientPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditPatientPayload'] = ResolversParentTypes['EditPatientPayload']> = {
  successPatientEditRequestResponseDto?: Resolver<Maybe<ResolversTypes['SuccessPatientEditRequestResponseDto']>, ParentType, ContextType>;
};

export type ExpenseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Expense'] = ResolversParentTypes['Expense']> = {
  expenseDefaultValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expenseKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reimbursementTransaction?: Resolver<Array<ResolversTypes['ReimbursementTransaction']>, ParentType, ContextType>;
  studyExpense?: Resolver<Array<ResolversTypes['StudyExpense']>, ParentType, ContextType>;
};

export type ExpensesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExpensesConnection'] = ResolversParentTypes['ExpensesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ExpensesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Expense']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ExpensesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExpensesEdge'] = ResolversParentTypes['ExpensesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Expense'], ParentType, ContextType>;
};

export type GetPatientPortalAccessRequestByIdResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetPatientPortalAccessRequestByIdResult'] = ResolversParentTypes['GetPatientPortalAccessRequestByIdResult']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type LoginPatientPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginPatientPayload'] = ResolversParentTypes['LoginPatientPayload']> = {
  authResult?: Resolver<Maybe<ResolversTypes['AuthResult']>, ParentType, ContextType>;
};

export type LogoutPatientPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutPatientPayload'] = ResolversParentTypes['LogoutPatientPayload']> = {
  boolean?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type MileageReimbursementRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MileageReimbursementRate'] = ResolversParentTypes['MileageReimbursementRate']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  mileageDistanceUnits?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mileageReimbursementRatePerUnit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MileageReimbursementRatesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MileageReimbursementRatesConnection'] = ResolversParentTypes['MileageReimbursementRatesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['MileageReimbursementRatesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['MileageReimbursementRate']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type MileageReimbursementRatesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MileageReimbursementRatesEdge'] = ResolversParentTypes['MileageReimbursementRatesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MileageReimbursementRate'], ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  changeLoggedPatientPassword?: Resolver<ResolversTypes['ChangeLoggedPatientPasswordPayload'], ParentType, ContextType, RequireFields<MutationChangeLoggedPatientPasswordArgs, 'input'>>;
  changePasswordInPasswordResetScenario?: Resolver<ResolversTypes['ChangePasswordInPasswordResetScenarioPayload'], ParentType, ContextType, RequireFields<MutationChangePasswordInPasswordResetScenarioArgs, 'input'>>;
  changePatientUserLanguage?: Resolver<ResolversTypes['ChangePatientUserLanguagePayload'], ParentType, ContextType, RequireFields<MutationChangePatientUserLanguageArgs, 'input'>>;
  deletePatientEditRequest?: Resolver<ResolversTypes['DeletePatientEditRequestPayload'], ParentType, ContextType>;
  editPatient?: Resolver<ResolversTypes['EditPatientPayload'], ParentType, ContextType, RequireFields<MutationEditPatientArgs, 'input'>>;
  loginPatient?: Resolver<ResolversTypes['LoginPatientPayload'], ParentType, ContextType, RequireFields<MutationLoginPatientArgs, 'input'>>;
  logoutPatient?: Resolver<ResolversTypes['LogoutPatientPayload'], ParentType, ContextType>;
  refreshTokenFromBody?: Resolver<ResolversTypes['RefreshTokenFromBodyPayload'], ParentType, ContextType, RequireFields<MutationRefreshTokenFromBodyArgs, 'input'>>;
  refreshTokenFromCookie?: Resolver<ResolversTypes['RefreshTokenFromCookiePayload'], ParentType, ContextType>;
  registerPatient?: Resolver<ResolversTypes['RegisterPatientPayload'], ParentType, ContextType, RequireFields<MutationRegisterPatientArgs, 'input'>>;
  removePatientFcmToken?: Resolver<ResolversTypes['RemovePatientFcmTokenPayload'], ParentType, ContextType, RequireFields<MutationRemovePatientFcmTokenArgs, 'input'>>;
  resetPassword?: Resolver<ResolversTypes['ResetPasswordPayload'], ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'input'>>;
  saveDraftReimbursementRequest?: Resolver<ResolversTypes['SaveDraftReimbursementRequestPayload'], ParentType, ContextType, RequireFields<MutationSaveDraftReimbursementRequestArgs, 'input'>>;
  saveDraftTravelRequest?: Resolver<ResolversTypes['SaveDraftTravelRequestPayload'], ParentType, ContextType, RequireFields<MutationSaveDraftTravelRequestArgs, 'input'>>;
  savePatientUserFcmToken?: Resolver<ResolversTypes['SavePatientUserFcmTokenPayload'], ParentType, ContextType, RequireFields<MutationSavePatientUserFcmTokenArgs, 'input'>>;
  setPatientUserNotificationDefaults?: Resolver<ResolversTypes['SetPatientUserNotificationDefaultsPayload'], ParentType, ContextType>;
  setPatientUserNotifications?: Resolver<ResolversTypes['SetPatientUserNotificationsPayload'], ParentType, ContextType, RequireFields<MutationSetPatientUserNotificationsArgs, 'input'>>;
  submitPatientEditRequest?: Resolver<ResolversTypes['SubmitPatientEditRequestPayload'], ParentType, ContextType>;
  submitReimbursementRequest?: Resolver<ResolversTypes['SubmitReimbursementRequestPayload'], ParentType, ContextType, RequireFields<MutationSubmitReimbursementRequestArgs, 'input'>>;
  submitTravelRequest?: Resolver<ResolversTypes['SubmitTravelRequestPayload'], ParentType, ContextType, RequireFields<MutationSubmitTravelRequestArgs, 'input'>>;
};

export type NotificationSentResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationSent'] = ResolversParentTypes['NotificationSent']> = {
  createDatetime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  notificationEventKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  targetGroup?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type NotificationsSentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationsSentConnection'] = ResolversParentTypes['NotificationsSentConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['NotificationsSentEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['NotificationSent']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type NotificationsSentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationsSentEdge'] = ResolversParentTypes['NotificationsSentEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['NotificationSent'], ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PasswordResetRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordResetRequest'] = ResolversParentTypes['PasswordResetRequest']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patientUser?: Resolver<ResolversTypes['PatientUser'], ParentType, ContextType>;
  patientUserId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requestTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  resetPasswordCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['Patient'] = ResolversParentTypes['Patient']> = {
  accessRamp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  accessWalker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  accessWheelChair?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  accessibilityRequirements?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airTravelRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  airlinePrimary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airlineSecondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergies?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankDetailsId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caregiver?: Resolver<Array<ResolversTypes['Caregiver']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  groundTransportRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hotelChainPrimary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  internationTravelRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  internationalTraveler?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lodgingRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notificationSent?: Resolver<Array<ResolversTypes['NotificationSent']>, ParentType, ContextType>;
  patientData?: Resolver<Maybe<ResolversTypes['PatientData']>, ParentType, ContextType>;
  patientEditRequest?: Resolver<Maybe<ResolversTypes['PatientEditRequest']>, ParentType, ContextType>;
  patientNum?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patientPaymentDetails?: Resolver<Maybe<ResolversTypes['PatientPaymentDetails']>, ParentType, ContextType>;
  patientPortalAccessRequest?: Resolver<Maybe<ResolversTypes['PatientPortalAccessRequest']>, ParentType, ContextType>;
  patientUser?: Resolver<Maybe<ResolversTypes['PatientUser']>, ParentType, ContextType>;
  pcsId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reimbursementRequest?: Resolver<Array<ResolversTypes['ReimbursementRequest']>, ParentType, ContextType>;
  rentalCarRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  seatPreference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  site?: Resolver<ResolversTypes['Site'], ParentType, ContextType>;
  siteId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PatientStatus'], ParentType, ContextType>;
  statusId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stipendRequest?: Resolver<Array<ResolversTypes['StipendRequest']>, ParentType, ContextType>;
  trainRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  travelRequest?: Resolver<Array<ResolversTypes['TravelRequest']>, ParentType, ContextType>;
  travelRequestSpendData?: Resolver<Array<ResolversTypes['TravelRequestSpendData']>, ParentType, ContextType>;
};

export type PatientCtsmStatusDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientCtsmStatusDto'] = ResolversParentTypes['PatientCtsmStatusDto']> = {
  statusName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PatientDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientData'] = ResolversParentTypes['PatientData']> = {
  address1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airlineRewardsPrimary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airlineRewardsSecondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airlineSpecialNeeds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  caregiverInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groundSpecialNeeds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasConsentForm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  knownTravelerNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lodgingRoomPreference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lodgingSpecialNeeds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passportCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passportExpiration?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  passportIssue?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  passportNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  preferredLang?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rentalCarFrequentTravelerNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainSpecialNeeds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  underEighteen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  visitGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PatientDataConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientDataConnection'] = ResolversParentTypes['PatientDataConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['PatientDataEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['PatientData']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PatientDataEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientDataEdge'] = ResolversParentTypes['PatientDataEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PatientData'], ParentType, ContextType>;
};

export type PatientEditRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientEditRequest'] = ResolversParentTypes['PatientEditRequest']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airlinePrimary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airlineRewardsPrimary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airlineRewardsSecondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airlineSecondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airlineSpecialNeeds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergies?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  caregiverEditRequest?: Resolver<Array<ResolversTypes['CaregiverEditRequest']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groundSpecialNeeds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hotelChainPrimary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isSubmitted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  knownTravelerNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdateTimestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lodgingRoomPreference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lodgingSpecialNeeds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passportCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passportExpiration?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  passportIssue?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  passportNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredLang?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileChangeDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentalCarFrequentTravelerNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seatPreference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainSpecialNeeds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PatientPaymentDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientPaymentDetails'] = ResolversParentTypes['PatientPaymentDetails']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kycdocumentInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  kycvendorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentApprovalDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  paymentApprover?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentRecipientEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentRecipientFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentRecipientLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentRecipientRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pqaccountStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pqfundingAccountPublicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredPayment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  readyForPayment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type PatientPaymentDetailsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientPaymentDetailsConnection'] = ResolversParentTypes['PatientPaymentDetailsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['PatientPaymentDetailsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['PatientData']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PatientPaymentDetailsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientPaymentDetailsEdge'] = ResolversParentTypes['PatientPaymentDetailsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PatientData'], ParentType, ContextType>;
};

export type PatientPortalAccessRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientPortalAccessRequest'] = ResolversParentTypes['PatientPortalAccessRequest']> = {
  expire?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  registrationTrialsLeft?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PatientStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientStatus'] = ResolversParentTypes['PatientStatus']> = {
  appName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patient?: Resolver<Array<ResolversTypes['Patient']>, ParentType, ContextType>;
};

export type PatientStatusesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientStatusesConnection'] = ResolversParentTypes['PatientStatusesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['PatientStatusesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['PatientStatus']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PatientStatusesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientStatusesEdge'] = ResolversParentTypes['PatientStatusesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PatientStatus'], ParentType, ContextType>;
};

export type PatientUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientUser'] = ResolversParentTypes['PatientUser']> = {
  applicationLanguage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passwordResetRequest?: Resolver<Maybe<ResolversTypes['PasswordResetRequest']>, ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  patientUserFcmToken?: Resolver<Array<ResolversTypes['PatientUserFcmToken']>, ParentType, ContextType>;
  patientUserNotification?: Resolver<Array<ResolversTypes['PatientUserNotification']>, ParentType, ContextType>;
  patientUserPassword?: Resolver<Maybe<ResolversTypes['PatientUserPassword']>, ParentType, ContextType>;
};

export type PatientUserFcmTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientUserFcmToken'] = ResolversParentTypes['PatientUserFcmToken']> = {
  deviceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fcmToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fcmTokenExpirationDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patientUser?: Resolver<ResolversTypes['PatientUser'], ParentType, ContextType>;
  patientUserId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PatientUserNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientUserNotification'] = ResolversParentTypes['PatientUserNotification']> = {
  allowEmailNotification?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowPushNotification?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patientUser?: Resolver<ResolversTypes['PatientUser'], ParentType, ContextType>;
  patientUserId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  templateId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PatientUserNotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientUserNotificationsConnection'] = ResolversParentTypes['PatientUserNotificationsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['PatientUserNotificationsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['PatientUserNotification']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PatientUserNotificationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientUserNotificationsEdge'] = ResolversParentTypes['PatientUserNotificationsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PatientUserNotification'], ParentType, ContextType>;
};

export type PatientUserPasswordResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientUserPassword'] = ResolversParentTypes['PatientUserPassword']> = {
  patientUser?: Resolver<ResolversTypes['PatientUser'], ParentType, ContextType>;
  patientUserId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type PatientVisitResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientVisit'] = ResolversParentTypes['PatientVisit']> = {
  actualDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  clinTrakPatientVisits?: Resolver<Maybe<Array<ResolversTypes['ClinTrakPatientVisit']>>, ParentType, ContextType>;
  clintrakActualDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  hasStipendSupport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requestCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requests?: Resolver<Maybe<Array<ResolversTypes['VisitScheduleRequestItem']>>, ParentType, ContextType>;
  scheduled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  scheduledDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sortOrderDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  stipendConfigAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  stipendRequestStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stipendRequestStatusTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  visitGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visitNameType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  caregiver?: Resolver<Maybe<ResolversTypes['Caregiver']>, ParentType, ContextType, Partial<QueryCaregiverArgs>>;
  caregivers?: Resolver<Maybe<ResolversTypes['CaregiversConnection']>, ParentType, ContextType, Partial<QueryCaregiversArgs>>;
  clinTrakVisitNames?: Resolver<Maybe<ResolversTypes['ClinTrakVisitNamesConnection']>, ParentType, ContextType, RequireFields<QueryClinTrakVisitNamesArgs, 'studyId'>>;
  countries?: Resolver<Maybe<ResolversTypes['CountriesConnection']>, ParentType, ContextType, Partial<QueryCountriesArgs>>;
  country?: Resolver<Maybe<ResolversTypes['Country']>, ParentType, ContextType, Partial<QueryCountryArgs>>;
  currencies?: Resolver<Maybe<ResolversTypes['CurrenciesConnection']>, ParentType, ContextType, Partial<QueryCurrenciesArgs>>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyInfo']>, ParentType, ContextType, Partial<QueryCurrencyArgs>>;
  currentPatient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  expense?: Resolver<Maybe<ResolversTypes['Expense']>, ParentType, ContextType, Partial<QueryExpenseArgs>>;
  expenses?: Resolver<Maybe<ResolversTypes['ExpensesConnection']>, ParentType, ContextType, Partial<QueryExpensesArgs>>;
  mileageReimbursementRate?: Resolver<Maybe<ResolversTypes['MileageReimbursementRate']>, ParentType, ContextType, Partial<QueryMileageReimbursementRateArgs>>;
  mileageReimbursementRates?: Resolver<Maybe<ResolversTypes['MileageReimbursementRatesConnection']>, ParentType, ContextType, Partial<QueryMileageReimbursementRatesArgs>>;
  notificationsSent?: Resolver<Maybe<ResolversTypes['NotificationsSentConnection']>, ParentType, ContextType, Partial<QueryNotificationsSentArgs>>;
  patientCtsmStatus?: Resolver<Maybe<ResolversTypes['PatientCtsmStatusDto']>, ParentType, ContextType>;
  patientData?: Resolver<Maybe<ResolversTypes['PatientDataConnection']>, ParentType, ContextType, Partial<QueryPatientDataArgs>>;
  patientDatum?: Resolver<Maybe<ResolversTypes['PatientData']>, ParentType, ContextType, Partial<QueryPatientDatumArgs>>;
  patientPaymentDetail?: Resolver<Maybe<ResolversTypes['PatientData']>, ParentType, ContextType, Partial<QueryPatientPaymentDetailArgs>>;
  patientPaymentDetails?: Resolver<Maybe<ResolversTypes['PatientPaymentDetailsConnection']>, ParentType, ContextType, Partial<QueryPatientPaymentDetailsArgs>>;
  patientPortalAccessRequestById?: Resolver<Maybe<ResolversTypes['GetPatientPortalAccessRequestByIdResult']>, ParentType, ContextType, RequireFields<QueryPatientPortalAccessRequestByIdArgs, 'id'>>;
  patientStatus?: Resolver<Maybe<ResolversTypes['PatientStatus']>, ParentType, ContextType, Partial<QueryPatientStatusArgs>>;
  patientStatuses?: Resolver<Maybe<ResolversTypes['PatientStatusesConnection']>, ParentType, ContextType, Partial<QueryPatientStatusesArgs>>;
  patientUser?: Resolver<Maybe<ResolversTypes['PatientUser']>, ParentType, ContextType, Partial<QueryPatientUserArgs>>;
  patientUserFcmToken?: Resolver<Maybe<ResolversTypes['PatientUserFcmToken']>, ParentType, ContextType, Partial<QueryPatientUserFcmTokenArgs>>;
  patientUserFcmTokens?: Resolver<Maybe<ResolversTypes['PatientUserFcmToken']>, ParentType, ContextType, Partial<QueryPatientUserFcmTokensArgs>>;
  patientUserNotification?: Resolver<Maybe<ResolversTypes['PatientUserNotification']>, ParentType, ContextType, Partial<QueryPatientUserNotificationArgs>>;
  patientUserNotifications?: Resolver<Maybe<ResolversTypes['PatientUserNotificationsConnection']>, ParentType, ContextType, Partial<QueryPatientUserNotificationsArgs>>;
  reimbursementRequest?: Resolver<Maybe<ResolversTypes['ReimbursementRequest']>, ParentType, ContextType, Partial<QueryReimbursementRequestArgs>>;
  reimbursementRequests?: Resolver<Maybe<ResolversTypes['ReimbursementRequestsConnection']>, ParentType, ContextType, Partial<QueryReimbursementRequestsArgs>>;
  site?: Resolver<Maybe<ResolversTypes['Site']>, ParentType, ContextType>;
  sites?: Resolver<Maybe<ResolversTypes['SitesConnection']>, ParentType, ContextType, Partial<QuerySitesArgs>>;
  stipendRequest?: Resolver<Maybe<ResolversTypes['StipendRequest']>, ParentType, ContextType, Partial<QueryStipendRequestArgs>>;
  stipendRequests?: Resolver<Maybe<ResolversTypes['StipendRequestsConnection']>, ParentType, ContextType, Partial<QueryStipendRequestsArgs>>;
  studies?: Resolver<Maybe<ResolversTypes['StudiesConnection']>, ParentType, ContextType, Partial<QueryStudiesArgs>>;
  study?: Resolver<Maybe<ResolversTypes['Study']>, ParentType, ContextType, Partial<QueryStudyArgs>>;
  studyActiveExpenses?: Resolver<Array<ResolversTypes['ActiveStudyExpenses']>, ParentType, ContextType, RequireFields<QueryStudyActiveExpensesArgs, 'studyId'>>;
  studyExpense?: Resolver<Maybe<ResolversTypes['StudyExpense']>, ParentType, ContextType, Partial<QueryStudyExpenseArgs>>;
  studyExpenses?: Resolver<Maybe<ResolversTypes['StudyExpensesConnection']>, ParentType, ContextType, Partial<QueryStudyExpensesArgs>>;
  travelRequest?: Resolver<Maybe<ResolversTypes['TravelRequest']>, ParentType, ContextType, Partial<QueryTravelRequestArgs>>;
  travelRequests?: Resolver<Maybe<ResolversTypes['TravelRequestsConnection']>, ParentType, ContextType, Partial<QueryTravelRequestsArgs>>;
  visitName?: Resolver<Maybe<ResolversTypes['VisitName']>, ParentType, ContextType, Partial<QueryVisitNameArgs>>;
  visitNames?: Resolver<Maybe<ResolversTypes['VisitNamesConnection']>, ParentType, ContextType, Partial<QueryVisitNamesArgs>>;
};

export type RefreshTokenFromBodyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefreshTokenFromBodyPayload'] = ResolversParentTypes['RefreshTokenFromBodyPayload']> = {
  authResult?: Resolver<Maybe<ResolversTypes['AuthResult']>, ParentType, ContextType>;
};

export type RefreshTokenFromCookiePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefreshTokenFromCookiePayload'] = ResolversParentTypes['RefreshTokenFromCookiePayload']> = {
  authResult?: Resolver<Maybe<ResolversTypes['AuthResult']>, ParentType, ContextType>;
};

export type RegisterPatientPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterPatientPayload'] = ResolversParentTypes['RegisterPatientPayload']> = {
  authResult?: Resolver<Maybe<ResolversTypes['AuthResult']>, ParentType, ContextType>;
};

export type ReimbursementRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReimbursementRequest'] = ResolversParentTypes['ReimbursementRequest']> = {
  additionalDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  completingUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  completingUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deducted?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  deductedCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deductedUsd?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  erReportingPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  erTrackingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flaggedDuplicate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastEditTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  liasonInitials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reimbursementRequestApprovalStatusLog?: Resolver<Array<ResolversTypes['ReimbursementRequestApprovalStatusLog']>, ParentType, ContextType>;
  reimbursementTransaction?: Resolver<Array<ResolversTypes['ReimbursementTransaction']>, ParentType, ContextType>;
  statusChangedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  statusId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  submittedTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  submittingUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  submittingUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  totalAmountAuthorized?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  totalCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  travelerInstructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitEndDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  visitEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitName?: Resolver<Maybe<ResolversTypes['VisitName']>, ParentType, ContextType>;
  visitNameId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  visitStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  visitStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ReimbursementRequestApprovalStatusLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReimbursementRequestApprovalStatusLog'] = ResolversParentTypes['ReimbursementRequestApprovalStatusLog']> = {
  actionWasPerformedInPatientPortal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  anonymized?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  request?: Resolver<ResolversTypes['ReimbursementRequest'], ParentType, ContextType>;
  requestApprovalStatusId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  responsibleUserEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responsibleUserName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type ReimbursementRequestsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReimbursementRequestsConnection'] = ResolversParentTypes['ReimbursementRequestsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ReimbursementRequestsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ReimbursementRequest']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ReimbursementRequestsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReimbursementRequestsEdge'] = ResolversParentTypes['ReimbursementRequestsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ReimbursementRequest'], ParentType, ContextType>;
};

export type ReimbursementTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReimbursementTransaction'] = ResolversParentTypes['ReimbursementTransaction']> = {
  amount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  authorizedAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  authorizedAmountUsd?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expense?: Resolver<Maybe<ResolversTypes['Expense']>, ParentType, ContextType>;
  expenseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isIncomplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  manualTotalCalculation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mileageComments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mileageDistanceUnits?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mileageEndLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mileageReimbursementCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mileageReimbursementRatePerUnit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mileageStartLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mileageTotalDistance?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  request?: Resolver<ResolversTypes['ReimbursementRequest'], ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  transactionAttachmentInfo?: Resolver<Maybe<ResolversTypes['TransactionAttachmentInfo']>, ParentType, ContextType>;
  transactionAttachmentInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type RemovePatientFcmTokenPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemovePatientFcmTokenPayload'] = ResolversParentTypes['RemovePatientFcmTokenPayload']> = {
  boolean?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ResetPasswordPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordPayload'] = ResolversParentTypes['ResetPasswordPayload']> = {
  boolean?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type SaveDraftReimbursementRequestPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveDraftReimbursementRequestPayload'] = ResolversParentTypes['SaveDraftReimbursementRequestPayload']> = {
  reimbursementRequest?: Resolver<Maybe<ResolversTypes['ReimbursementRequest']>, ParentType, ContextType>;
};

export type SaveDraftTravelRequestPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveDraftTravelRequestPayload'] = ResolversParentTypes['SaveDraftTravelRequestPayload']> = {
  travelRequest?: Resolver<Maybe<ResolversTypes['TravelRequest']>, ParentType, ContextType>;
};

export type SavePatientUserFcmTokenPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavePatientUserFcmTokenPayload'] = ResolversParentTypes['SavePatientUserFcmTokenPayload']> = {
  boolean?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type SetPatientUserNotificationDefaultsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetPatientUserNotificationDefaultsPayload'] = ResolversParentTypes['SetPatientUserNotificationDefaultsPayload']> = {
  boolean?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type SetPatientUserNotificationsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetPatientUserNotificationsPayload'] = ResolversParentTypes['SetPatientUserNotificationsPayload']> = {
  boolean?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export interface ShortScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Short'], any> {
  name: 'Short';
}

export type SiteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Site'] = ResolversParentTypes['Site']> = {
  address1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allowPpinvitations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isReviewedByCrc?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isShippingAddressSameAsPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastReminderDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patient?: Resolver<Array<ResolversTypes['Patient']>, ParentType, ContextType>;
  paymentPayQuicker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pilastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  preRegisteredDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  primaryCrcEmailToInvite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reimbursementSupport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  shippingAddress1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingAddress2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingZipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  siteNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stipendSupport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  study?: Resolver<ResolversTypes['Study'], ParentType, ContextType>;
  studyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  travelServiceSupport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SitesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SitesConnection'] = ResolversParentTypes['SitesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['SitesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Site']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type SitesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SitesEdge'] = ResolversParentTypes['SitesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Site'], ParentType, ContextType>;
};

export type StipendRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['StipendRequest'] = ResolversParentTypes['StipendRequest']> = {
  additionalDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  authorizedAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  authorizedAmountUsd?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  completingUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deducted?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  deductedCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deductedUsd?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  erReportingPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  erTrackingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusChangedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  statusId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  travelerInstructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitName?: Resolver<Maybe<ResolversTypes['VisitName']>, ParentType, ContextType>;
  visitNameId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  visitStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  visitStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type StipendRequestsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StipendRequestsConnection'] = ResolversParentTypes['StipendRequestsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['StipendRequestsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['StipendRequest']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type StipendRequestsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StipendRequestsEdge'] = ResolversParentTypes['StipendRequestsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['StipendRequest'], ParentType, ContextType>;
};

export type StudiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudiesConnection'] = ResolversParentTypes['StudiesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['StudiesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Study']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type StudiesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudiesEdge'] = ResolversParentTypes['StudiesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Study'], ParentType, ContextType>;
};

export type StudyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Study'] = ResolversParentTypes['Study']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasMultipleVisitSchedules?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isApproved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFromClinTrak?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  site?: Resolver<Array<ResolversTypes['Site']>, ParentType, ContextType>;
  sponsor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  studyExpense?: Resolver<Array<ResolversTypes['StudyExpense']>, ParentType, ContextType>;
  studyLogoInfo?: Resolver<Maybe<ResolversTypes['StudyLogoInfo']>, ParentType, ContextType>;
  studyLogoInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  studyTravelOption?: Resolver<Array<ResolversTypes['StudyTravelOption']>, ParentType, ContextType>;
  supportTierId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  visitName?: Resolver<Array<ResolversTypes['VisitName']>, ParentType, ContextType>;
};

export type StudyExpenseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyExpense'] = ResolversParentTypes['StudyExpense']> = {
  expense?: Resolver<ResolversTypes['Expense'], ParentType, ContextType>;
  expenseId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  study?: Resolver<ResolversTypes['Study'], ParentType, ContextType>;
  studyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type StudyExpensesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyExpensesConnection'] = ResolversParentTypes['StudyExpensesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['StudyExpensesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['StudyExpense']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type StudyExpensesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyExpensesEdge'] = ResolversParentTypes['StudyExpensesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['StudyExpense'], ParentType, ContextType>;
};

export type StudyLogoInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyLogoInfo'] = ResolversParentTypes['StudyLogoInfo']> = {
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  extension?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  study?: Resolver<Array<ResolversTypes['Study']>, ParentType, ContextType>;
  uniqueIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type StudyTravelOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyTravelOption'] = ResolversParentTypes['StudyTravelOption']> = {
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  study?: Resolver<ResolversTypes['Study'], ParentType, ContextType>;
  studyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  travelOption?: Resolver<ResolversTypes['TravelOption'], ParentType, ContextType>;
  travelOptionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type SubmitPatientEditRequestPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitPatientEditRequestPayload'] = ResolversParentTypes['SubmitPatientEditRequestPayload']> = {
  successPatientEditRequestResponseDto?: Resolver<Maybe<ResolversTypes['SuccessPatientEditRequestResponseDto']>, ParentType, ContextType>;
};

export type SubmitReimbursementRequestPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitReimbursementRequestPayload'] = ResolversParentTypes['SubmitReimbursementRequestPayload']> = {
  reimbursementRequest?: Resolver<Maybe<ResolversTypes['ReimbursementRequest']>, ParentType, ContextType>;
};

export type SubmitTravelRequestPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitTravelRequestPayload'] = ResolversParentTypes['SubmitTravelRequestPayload']> = {
  travelRequest?: Resolver<Maybe<ResolversTypes['TravelRequest']>, ParentType, ContextType>;
};

export type SuccessPatientEditRequestResponseDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuccessPatientEditRequestResponseDto'] = ResolversParentTypes['SuccessPatientEditRequestResponseDto']> = {
  saveSuccessful?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type TransactionAttachmentInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionAttachmentInfo'] = ResolversParentTypes['TransactionAttachmentInfo']> = {
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  extension?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reimbursementTransaction?: Resolver<Array<ResolversTypes['ReimbursementTransaction']>, ParentType, ContextType>;
  uniqueIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type TravelOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelOption'] = ResolversParentTypes['TravelOption']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  studyTravelOption?: Resolver<Array<ResolversTypes['StudyTravelOption']>, ParentType, ContextType>;
};

export type TravelRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelRequest'] = ResolversParentTypes['TravelRequest']> = {
  additionalDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  approvalRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  carServiceAttachmentInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  carServiceMerchant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  carServiceReceiptDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  carServiceRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carServiceRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  carServiceTransactionAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  carServiceTransactionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carServiceTransactionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  carServiceUsdExpense?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  caregiver?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  completedTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  completingUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  completingUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  erReportingPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  erTrackingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flightAttachmentInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flightMerchant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flightReceiptDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  flightRequestDetails?: Resolver<Maybe<ResolversTypes['TravelRequestFlightTravelDetails']>, ParentType, ContextType>;
  flightRequestDetailsId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flightRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flightRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  flightTransactionAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  flightTransactionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flightTransactionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  flightUsdExpense?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastEditTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lodgingAttachmentInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lodgingCheckInDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lodgingCheckOutDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lodgingDateRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lodgingMerchant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lodgingReceiptDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lodgingRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lodgingRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lodgingTransactionAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  lodgingTransactionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lodgingTransactionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lodgingUsdExpense?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  otherAttachmentInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  otherMerchant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  otherReceiptDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  otherRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  otherServiceRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  otherTransactionAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  otherTransactionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  otherTransactionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  otherUsdExpense?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentalCarAttachmentInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentalCarCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentalCarDropOffDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  rentalCarDropOffTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentalCarLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentalCarMerchant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentalCarPickUpDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  rentalCarPickUpTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentalCarReceiptDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rentalCarRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentalCarRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rentalCarTransactionAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  rentalCarTransactionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentalCarTransactionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rentalCarUsdExpense?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  rentalCarUseFlightDate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  statusChangedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  statusId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  submittedTimestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  submittingUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  submittingUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainAttachmentInfoId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trainMerchant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trainReceiptDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  trainRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trainTransactionAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  trainTransactionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainTransactionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  trainTravelDetailsForPatient?: Resolver<Maybe<ResolversTypes['TravelRequestTrainTravelDetails']>, ParentType, ContextType>;
  trainTravelDetailsForPatientId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trainUsdExpense?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  travelRequestApprovalStatusLog?: Resolver<Array<ResolversTypes['TravelRequestApprovalStatusLog']>, ParentType, ContextType>;
  travelRequestCaregiver?: Resolver<Array<ResolversTypes['TravelRequestCaregiver']>, ParentType, ContextType>;
  travelRequestTransferData?: Resolver<Array<ResolversTypes['TravelRequestTransferData']>, ParentType, ContextType>;
  travelRestrictions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  travelTransaction?: Resolver<Array<ResolversTypes['TravelTransaction']>, ParentType, ContextType>;
  travelerInstructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitEndDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  visitEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitName?: Resolver<Maybe<ResolversTypes['VisitName']>, ParentType, ContextType>;
  visitNameId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  visitStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  visitStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type TravelRequestApprovalStatusLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelRequestApprovalStatusLog'] = ResolversParentTypes['TravelRequestApprovalStatusLog']> = {
  actionWasPerformedInPatientPortal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  anonymized?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  request?: Resolver<ResolversTypes['TravelRequest'], ParentType, ContextType>;
  requestApprovalStatusId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  responsibleUserEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responsibleUserName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type TravelRequestCaregiverResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelRequestCaregiver'] = ResolversParentTypes['TravelRequestCaregiver']> = {
  caregiver?: Resolver<ResolversTypes['Caregiver'], ParentType, ContextType>;
  caregiverId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  caregiverName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdTimestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  flightRequestDetails?: Resolver<Maybe<ResolversTypes['TravelRequestFlightTravelDetails']>, ParentType, ContextType>;
  flightRequestDetailsId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flightRequestTheSameAsPatient?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainRequestDetails?: Resolver<Maybe<ResolversTypes['TravelRequestTrainTravelDetails']>, ParentType, ContextType>;
  trainRequestDetailsId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trainRequestTheSameAsPatient?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  travelRequest?: Resolver<ResolversTypes['TravelRequest'], ParentType, ContextType>;
  travelRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TravelRequestFlightTravelDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelRequestFlightTravelDetails'] = ResolversParentTypes['TravelRequestFlightTravelDetails']> = {
  airportDestination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airportOrigin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returnDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  specialRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  travelRequest?: Resolver<Array<ResolversTypes['TravelRequest']>, ParentType, ContextType>;
  travelRequestCaregiver?: Resolver<Array<ResolversTypes['TravelRequestCaregiver']>, ParentType, ContextType>;
  travelType?: Resolver<ResolversTypes['Byte'], ParentType, ContextType>;
};

export type TravelRequestSpendDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelRequestSpendData'] = ResolversParentTypes['TravelRequestSpendData']> = {
  carServiceSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  debitCardSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  flightSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hotelSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mealSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mileageSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  otherSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  parkingSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxiSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  trainSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  translationSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  visaSpend?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  visit?: Resolver<ResolversTypes['VisitName'], ParentType, ContextType>;
  visitId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TravelRequestTrainTravelDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelRequestTrainTravelDetails'] = ResolversParentTypes['TravelRequestTrainTravelDetails']> = {
  departureDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isRoundTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returnDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  specialRequests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainStationDestination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainStationOrigin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  travelRequest?: Resolver<Maybe<ResolversTypes['TravelRequest']>, ParentType, ContextType>;
  travelRequestCaregiver?: Resolver<Array<ResolversTypes['TravelRequestCaregiver']>, ParentType, ContextType>;
};

export type TravelRequestTransferDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelRequestTransferData'] = ResolversParentTypes['TravelRequestTransferData']> = {
  dropoffAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pickupAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pickupDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  request?: Resolver<ResolversTypes['TravelRequest'], ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TravelRequestsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelRequestsConnection'] = ResolversParentTypes['TravelRequestsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['TravelRequestsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['TravelRequest']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TravelRequestsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelRequestsEdge'] = ResolversParentTypes['TravelRequestsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TravelRequest'], ParentType, ContextType>;
};

export type TravelTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TravelTransaction'] = ResolversParentTypes['TravelTransaction']> = {
  amount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  travelRequest?: Resolver<ResolversTypes['TravelRequest'], ParentType, ContextType>;
  travelRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export type VisitNameResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitName'] = ResolversParentTypes['VisitName']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reimbursementRequest?: Resolver<Array<ResolversTypes['ReimbursementRequest']>, ParentType, ContextType, Partial<VisitNameReimbursementRequestArgs>>;
  scheduled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['Byte'], ParentType, ContextType>;
  stipendRequest?: Resolver<Array<ResolversTypes['StipendRequest']>, ParentType, ContextType, Partial<VisitNameStipendRequestArgs>>;
  study?: Resolver<ResolversTypes['Study'], ParentType, ContextType>;
  studyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  travelRequest?: Resolver<Array<ResolversTypes['TravelRequest']>, ParentType, ContextType, Partial<VisitNameTravelRequestArgs>>;
  travelRequestSpendData?: Resolver<Array<ResolversTypes['TravelRequestSpendData']>, ParentType, ContextType>;
  visitGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type VisitNamesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitNamesConnection'] = ResolversParentTypes['VisitNamesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['VisitNamesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['VisitName']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type VisitNamesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitNamesEdge'] = ResolversParentTypes['VisitNamesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['VisitName'], ParentType, ContextType>;
};

export type VisitScheduleRequestItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitScheduleRequestItem'] = ResolversParentTypes['VisitScheduleRequestItem']> = {
  amount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  amountCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visitStartDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ActiveStudyExpenses?: ActiveStudyExpensesResolvers<ContextType>;
  AuthResult?: AuthResultResolvers<ContextType>;
  Byte?: GraphQLScalarType;
  Caregiver?: CaregiverResolvers<ContextType>;
  CaregiverEditRequest?: CaregiverEditRequestResolvers<ContextType>;
  CaregiversConnection?: CaregiversConnectionResolvers<ContextType>;
  CaregiversEdge?: CaregiversEdgeResolvers<ContextType>;
  ChangeLoggedPatientPasswordPayload?: ChangeLoggedPatientPasswordPayloadResolvers<ContextType>;
  ChangePasswordInPasswordResetScenarioPayload?: ChangePasswordInPasswordResetScenarioPayloadResolvers<ContextType>;
  ChangePatientUserLanguagePayload?: ChangePatientUserLanguagePayloadResolvers<ContextType>;
  ClinTrakPatientVisit?: ClinTrakPatientVisitResolvers<ContextType>;
  ClinTrakVisitNamesConnection?: ClinTrakVisitNamesConnectionResolvers<ContextType>;
  ClinTrakVisitNamesEdge?: ClinTrakVisitNamesEdgeResolvers<ContextType>;
  CountriesConnection?: CountriesConnectionResolvers<ContextType>;
  CountriesEdge?: CountriesEdgeResolvers<ContextType>;
  Country?: CountryResolvers<ContextType>;
  CurrenciesConnection?: CurrenciesConnectionResolvers<ContextType>;
  CurrenciesEdge?: CurrenciesEdgeResolvers<ContextType>;
  CurrencyInfo?: CurrencyInfoResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  Decimal?: GraphQLScalarType;
  DeletePatientEditRequestPayload?: DeletePatientEditRequestPayloadResolvers<ContextType>;
  EditPatientPayload?: EditPatientPayloadResolvers<ContextType>;
  Expense?: ExpenseResolvers<ContextType>;
  ExpensesConnection?: ExpensesConnectionResolvers<ContextType>;
  ExpensesEdge?: ExpensesEdgeResolvers<ContextType>;
  GetPatientPortalAccessRequestByIdResult?: GetPatientPortalAccessRequestByIdResultResolvers<ContextType>;
  LoginPatientPayload?: LoginPatientPayloadResolvers<ContextType>;
  LogoutPatientPayload?: LogoutPatientPayloadResolvers<ContextType>;
  MileageReimbursementRate?: MileageReimbursementRateResolvers<ContextType>;
  MileageReimbursementRatesConnection?: MileageReimbursementRatesConnectionResolvers<ContextType>;
  MileageReimbursementRatesEdge?: MileageReimbursementRatesEdgeResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NotificationSent?: NotificationSentResolvers<ContextType>;
  NotificationsSentConnection?: NotificationsSentConnectionResolvers<ContextType>;
  NotificationsSentEdge?: NotificationsSentEdgeResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PasswordResetRequest?: PasswordResetRequestResolvers<ContextType>;
  Patient?: PatientResolvers<ContextType>;
  PatientCtsmStatusDto?: PatientCtsmStatusDtoResolvers<ContextType>;
  PatientData?: PatientDataResolvers<ContextType>;
  PatientDataConnection?: PatientDataConnectionResolvers<ContextType>;
  PatientDataEdge?: PatientDataEdgeResolvers<ContextType>;
  PatientEditRequest?: PatientEditRequestResolvers<ContextType>;
  PatientPaymentDetails?: PatientPaymentDetailsResolvers<ContextType>;
  PatientPaymentDetailsConnection?: PatientPaymentDetailsConnectionResolvers<ContextType>;
  PatientPaymentDetailsEdge?: PatientPaymentDetailsEdgeResolvers<ContextType>;
  PatientPortalAccessRequest?: PatientPortalAccessRequestResolvers<ContextType>;
  PatientStatus?: PatientStatusResolvers<ContextType>;
  PatientStatusesConnection?: PatientStatusesConnectionResolvers<ContextType>;
  PatientStatusesEdge?: PatientStatusesEdgeResolvers<ContextType>;
  PatientUser?: PatientUserResolvers<ContextType>;
  PatientUserFcmToken?: PatientUserFcmTokenResolvers<ContextType>;
  PatientUserNotification?: PatientUserNotificationResolvers<ContextType>;
  PatientUserNotificationsConnection?: PatientUserNotificationsConnectionResolvers<ContextType>;
  PatientUserNotificationsEdge?: PatientUserNotificationsEdgeResolvers<ContextType>;
  PatientUserPassword?: PatientUserPasswordResolvers<ContextType>;
  PatientVisit?: PatientVisitResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RefreshTokenFromBodyPayload?: RefreshTokenFromBodyPayloadResolvers<ContextType>;
  RefreshTokenFromCookiePayload?: RefreshTokenFromCookiePayloadResolvers<ContextType>;
  RegisterPatientPayload?: RegisterPatientPayloadResolvers<ContextType>;
  ReimbursementRequest?: ReimbursementRequestResolvers<ContextType>;
  ReimbursementRequestApprovalStatusLog?: ReimbursementRequestApprovalStatusLogResolvers<ContextType>;
  ReimbursementRequestsConnection?: ReimbursementRequestsConnectionResolvers<ContextType>;
  ReimbursementRequestsEdge?: ReimbursementRequestsEdgeResolvers<ContextType>;
  ReimbursementTransaction?: ReimbursementTransactionResolvers<ContextType>;
  RemovePatientFcmTokenPayload?: RemovePatientFcmTokenPayloadResolvers<ContextType>;
  ResetPasswordPayload?: ResetPasswordPayloadResolvers<ContextType>;
  SaveDraftReimbursementRequestPayload?: SaveDraftReimbursementRequestPayloadResolvers<ContextType>;
  SaveDraftTravelRequestPayload?: SaveDraftTravelRequestPayloadResolvers<ContextType>;
  SavePatientUserFcmTokenPayload?: SavePatientUserFcmTokenPayloadResolvers<ContextType>;
  SetPatientUserNotificationDefaultsPayload?: SetPatientUserNotificationDefaultsPayloadResolvers<ContextType>;
  SetPatientUserNotificationsPayload?: SetPatientUserNotificationsPayloadResolvers<ContextType>;
  Short?: GraphQLScalarType;
  Site?: SiteResolvers<ContextType>;
  SitesConnection?: SitesConnectionResolvers<ContextType>;
  SitesEdge?: SitesEdgeResolvers<ContextType>;
  StipendRequest?: StipendRequestResolvers<ContextType>;
  StipendRequestsConnection?: StipendRequestsConnectionResolvers<ContextType>;
  StipendRequestsEdge?: StipendRequestsEdgeResolvers<ContextType>;
  StudiesConnection?: StudiesConnectionResolvers<ContextType>;
  StudiesEdge?: StudiesEdgeResolvers<ContextType>;
  Study?: StudyResolvers<ContextType>;
  StudyExpense?: StudyExpenseResolvers<ContextType>;
  StudyExpensesConnection?: StudyExpensesConnectionResolvers<ContextType>;
  StudyExpensesEdge?: StudyExpensesEdgeResolvers<ContextType>;
  StudyLogoInfo?: StudyLogoInfoResolvers<ContextType>;
  StudyTravelOption?: StudyTravelOptionResolvers<ContextType>;
  SubmitPatientEditRequestPayload?: SubmitPatientEditRequestPayloadResolvers<ContextType>;
  SubmitReimbursementRequestPayload?: SubmitReimbursementRequestPayloadResolvers<ContextType>;
  SubmitTravelRequestPayload?: SubmitTravelRequestPayloadResolvers<ContextType>;
  SuccessPatientEditRequestResponseDto?: SuccessPatientEditRequestResponseDtoResolvers<ContextType>;
  TransactionAttachmentInfo?: TransactionAttachmentInfoResolvers<ContextType>;
  TravelOption?: TravelOptionResolvers<ContextType>;
  TravelRequest?: TravelRequestResolvers<ContextType>;
  TravelRequestApprovalStatusLog?: TravelRequestApprovalStatusLogResolvers<ContextType>;
  TravelRequestCaregiver?: TravelRequestCaregiverResolvers<ContextType>;
  TravelRequestFlightTravelDetails?: TravelRequestFlightTravelDetailsResolvers<ContextType>;
  TravelRequestSpendData?: TravelRequestSpendDataResolvers<ContextType>;
  TravelRequestTrainTravelDetails?: TravelRequestTrainTravelDetailsResolvers<ContextType>;
  TravelRequestTransferData?: TravelRequestTransferDataResolvers<ContextType>;
  TravelRequestsConnection?: TravelRequestsConnectionResolvers<ContextType>;
  TravelRequestsEdge?: TravelRequestsEdgeResolvers<ContextType>;
  TravelTransaction?: TravelTransactionResolvers<ContextType>;
  UUID?: GraphQLScalarType;
  VisitName?: VisitNameResolvers<ContextType>;
  VisitNamesConnection?: VisitNamesConnectionResolvers<ContextType>;
  VisitNamesEdge?: VisitNamesEdgeResolvers<ContextType>;
  VisitScheduleRequestItem?: VisitScheduleRequestItemResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  cost?: CostDirectiveResolver<any, any, ContextType>;
  listSize?: ListSizeDirectiveResolver<any, any, ContextType>;
  NgModule?: NgModuleDirectiveResolver<any, any, ContextType>;
  namedClient?: NamedClientDirectiveResolver<any, any, ContextType>;
};
